export default {
  en_gb: {
    navbar: {
      logo: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say-vue/static/img/logos/just-eat-logo.png',
      country_toggle: [
        {
          logo: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say-vue/static/img/logos/countries/gb.svg',
          url: '',
          text: 'English'
        },
      ]
    },
    button: {
      text: 'Go home',
      url: 'https://www.just-eat.co.uk'
    },
    footer: {
      logo: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say-vue/static/img/logos/dss_logo_footer.png',
      main_link: 'https://www.just-eat.co.uk',
      links: [
        {
          text: 'Customer service',
          url: 'https://www.just-eat.co.uk/help'
        },
        {
          text: 'Signup a restaurant',
          url: 'https://partnersignup.just-eat.co.uk/'
        },
        {
          text: 'Jobs',
          url: 'https://careers.justeattakeaway.com/global/en',
        },
        {
          text: 'Terms of use',
          url: 'https://www.just-eat.co.uk/info/terms-and-conditions'
        },
        {
          text: 'Privacy statement',
          url: 'https://www.just-eat.co.uk/info/privacy-policy',
        },
        {
          text: 'Cookie statement',
          url: 'https://www.just-eat.co.uk/info/cookies-policy'
        }
      ],
      copyright: '2023 Just Eat Takeaway.com',
      mainNavFirst: {
        colTitle: 'Just Eat',
        subLinks: [
          {
            text: 'Customer service',
            url: 'https://www.just-eat.co.uk/help',
          },
          {
            text: 'List your business',
            url: 'https://partnersignup.just-eat.co.uk/',
          },
          {
            text: 'Become a courier',
            url: 'https://couriers.just-eat.co.uk/application',
          },
          {
            text: 'Jobs',
            url: 'https://careers.justeattakeaway.com/global/en',
          },
          {
            text: 'Just Eat for business',
            url: 'https://www.justeatpay.co.uk/business/',
          },
          {
            text: 'Terms of use',
            url: 'https://www.just-eat.co.uk/info/terms-and-conditions',
          },
          {
            text: 'Privacy Statement',
            url: 'https://www.just-eat.co.uk/info/privacy-policy',
          },
          {
            text: 'Cookie Statement',
            url: 'https://www.just-eat.co.uk/info/cookies-policy',
          }
        ],
      },
      mainNavSecond: [
        {
          colTitle: 'International',
          subLinks: [
            {
              text: 'Investor Relations',
              url: 'https://www.justeattakeaway.com/',
            },
            {
              text: '10bis',
              url: 'https://www.10bis.co.il',
            },
            {
              text: 'Bistro.sk',
              url: 'https://www.bistro.sk',
            },
            {
              text: 'Grubhub',
              url: 'https://www.grubhub.com',
            },
            {
              text: 'Just Eat - Switzerland',
              url: 'https://www.just-eat.ch',
            },
            {
              text: 'Just Eat - France',
              url: 'https://www.just-eat.fr',
            },
            {
              text: 'Just Eat - Denmark',
              url: 'https://www.just-eat.dk',
            },
            {
              text: 'Just Eat - Spain',
              url: 'https://www.just-eat.es',
            },
            {
              text: 'Just Eat - United Kingdom',
              url: 'https://www.just-eat.co.uk',
            },
            {
              text: 'Just Eat - Ireland',
              url: 'https://www.just-eat.ie',
            },
            {
              text: 'Just Eat - Italy',
              url: 'https://www.justeat.it',
            },
            {
              text: 'Lieferando.at',
              url: 'https://www.lieferando.at',
            },
            {
              text: 'Lieferando.de',
              url: 'https://www.lieferando.de',
            },
            {
              text: 'Menulog - Australia',
              url: 'https://www.menulog.com.au',
            },
            {
              text: 'Menulog - New Zealand',
              url: 'https://www.menulog.co.nz',
            },
            {
              text: 'Pyszne.pl',
              url: 'https://www.pyszne.pl',
            },
            {
              text: 'SkipTheDishes',
              url: 'https://www.skipthedishes.com',
            },
            {
              text: 'Takeaway.com - Belgium',
              url: 'https://www.takeaway.com/be',
            },
            {
              text: 'Takeaway.com - Luxembourg',
              url: 'https://www.takeaway.com/lu',
            },
            {
              text: 'Takeaway.com - Bulgaria',
              url: 'https://www.takeaway.com/bg',
            },
            {
              text: 'Thuisbezorgd.nl',
              url: 'https://www.thuisbezorgd.nl',
            }
          ],
        },
        {          
          colTitle: 'Food',
          subLinks: [
            {
              text: 'Food',
              url: 'https://www.just-eat.co.uk/',
            },
            {
              text: 'Pizza',
              url: 'https://www.just-eat.co.uk/takeaway/nearme/pizza',
            },
            {
              text: 'Chinese',
              url: 'https://www.just-eat.co.uk/takeaway/nearme/chinese',
            },
            {
              text: 'Sushi',
              url: 'https://www.just-eat.co.uk/takeaway/nearme/sushi',
            },
            {
              text: 'Kebab',
              url: 'https://www.just-eat.co.uk/takeaway/nearme/kebabs',
            },
            {
              text: 'Japenese',
              url: 'https://www.just-eat.co.uk/takeaway/nearme/japanese',
            },
            {
              text: 'Breakfast',
              url: 'https://www.just-eat.co.uk/takeaway/nearme/breakfast',
            },
            {
              text: 'Groceries',
              url: 'https://www.just-eat.co.uk/takeaway/nearme/groceries',
            },
            {
              text: 'Burgers',
              url: 'https://www.just-eat.co.uk/takeaway/nearme/burgers',
            },
            {
              text: 'Vegan',
              url: 'https://www.just-eat.co.uk/takeaway/nearme/vegan',
            },
            {
              text: 'Thai',
              url: 'https://www.just-eat.co.uk/takeaway/nearme/thai',
            },
            {
              text: 'Order more food...',
              url: 'https://www.just-eat.co.uk/takeaway/nearme',
            }
          ],
        },
        {          
          colTitle: 'Explore',
          subLinks: [
            {
              text: 'Giftcards',
              url: 'https://www.just-eat.co.uk/info/gift-cards',
            },
            {
              text: 'Taste the summer',
              url: 'https://www.just-eat.co.uk/deals/tastethesummer/',
            },
            {
              text: 'Win Champions League® Tickets',
              url: 'https://www.just-eat.co.uk/deals/win-uefa-champions-league-tickets/',
            },
          ],
        },
        {
          colTitle: 'Cities',
          subLinks: [
            {
              text: 'London',
              url: 'https://www.just-eat.co.uk/takeaway/london/'
            },
            {
              text: 'Manchester',
              url: 'https://www.just-eat.co.uk/takeaway/manchester/'
            },
            {
              text: 'Birmingham',
              url: 'https://www.just-eat.co.uk/takeaway/birmingham/'
            },
            {
              text: 'Leeds',
              url: 'https://www.just-eat.co.uk/takeaway/leeds/'
            },
            {
              text: 'Glasgow',
              url: 'https://www.just-eat.co.uk/takeaway/glasgow/',
            },
            {
              text: 'View all locations',
              url: 'https://www.just-eat.co.uk/takeaway/'
            }
          ]
        },
        {
          colTitle: 'Restaurants',
          subLinks: [
            {
              text: "McDonald's",
              url: 'https://www.just-eat.co.uk/takeaway/brands/mcdonalds'
            },
            {
              text: 'KFC',
              url: 'https://www.just-eat.co.uk/takeaway/brands/kfc'
            },
            {
              text: 'Burger King',
              url: 'https://www.just-eat.co.uk/takeaway/brands/burgerking'
            },
            {
              text: "Domino's Pizza",
              url: 'https://www.just-eat.co.uk/takeaway/brands/dominos-pizza'
            },
            {
              text: "Papa John's",
              url: 'https://www.just-eat.co.uk/takeaway/brands/papa-johns'
            },
            {
              text: 'Greggs',
              url: 'https://www.just-eat.co.uk/takeaway/brands/greggs'
            },
            {
              text: 'Subway',
              url: 'https://www.just-eat.co.uk/takeaway/brands/subway'
            },
            {
              text: 'Starbucks',
              url: 'https://www.just-eat.co.uk/takeaway/brands/starbucks'
            },
            {
              text: 'Costa Coffee',
              url: 'https://www.just-eat.co.uk/takeaway/brands/costa-coffee'
            },
            {
              text: 'View all brands',
              url: 'https://www.just-eat.co.uk/takeaway/brands'
            }
          ]
        },
      ]
    },
    faqs: [
      {
        question: 'Who’s starring in the new Just Eat ad?',
        answer: 'Pop icon, Katy Perry.'
      },
      {
        question: 'Why did we choose to work with Katy Perry?',
        answer: 'Following on from the success of our Snoop Dogg campaign, we wanted to go out loud and proud with a totally fresh, fun energy and Katy brings unparalleled star power to the brand, plus her playful nature matches ours to a tee. It’s the perfect partnership to continue building the instinctive connection between Just Eat and the joy of food delivery.',
      },
      {
        question: 'What is the concept of the ad?',
        answer: 'Just Eat offers a host of cuisines to cater for every mood and occasion. In the new TV ad, Katy Perry brings this to life by welcoming you into her world. A world where you can get whatever you want, whenever you want it.'
      },
      {
        question: 'What are the lyrics for Did somebody say featuring Katy Perry?',
        answer: '{Already shared per market}'
      }
    ],
    hero: {
      logo: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say-vue/static/img/logos/dss_logo.svg',
      main: 'Christina Aguilera and Latto',
      sub: 'Just Eat brand campaign 2023',
      img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say-vue/static/img/christina-latto.png?123',
    },
    about: {
      title: 'About the campaign',
      text: 'Together with McCann London, our latest creation brings together Latto’s hip-hop energy with Christina Aguilera’s effortless take on opera. The result? An unexpected visual and musical delight that perfectly embodies the surprising range of flavours you’ll find at Just Eat.',
      img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say-vue/static/img/xtina-wave.git?222',
    },
    video: {
      title: 'Full Did Somebody Say music video',
      id: 'https://www.youtube.com/embed/mJqG8YIPRh0?si=NeImEgV5TvOhZ12Z',
    },
    lyrics: {
      title: 'Did Somebody Say ft. Christina Aguilera and Latto full lyrics',
      lyrics: `La la la la la la laaa								
      Did Somebody Say Just Eat			
      
      Oh you thought it was just burgers and fries 
      They got more flavours than you tasted or you heard in your life			
      Ooh - this is what the app do, it ain’t only fast food 				
      Switching  styles like opera to rap too 	
      
      Yummy
      And it ain’t only restaurants any more
      We can go bananas at the grocery store 
      Yum yum yum yum			
      
      I’m a bad girl but my takeout badder
      What you need dude? I can cop a taco platter
      Thai rice sticky icky
      Gyoza on the side fried right cos we kinda picky 
      
      Breakfast or lunch hun, dinner or brunch 
      Wanna find the finest dining? I got a hunch
      And some hot tall dude’s bringing buns to the ballroom 
      
      Got me a strong coffee, let’s get it on papi
      Ice-cream with my magazine, who can stop me 				
      
      And my sushi train is on loop 		
      When you this slick, whatchoo gon’ do?
      
      Laaaaaaaaaa						
      Did Somebody Say Just Eat	`,
      img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say-vue/static/img/christina-lyrics.png?123',
    },
    food: {
      title: 'Featured food from the new campaign featuring Christina Aguilera and Latto',
      intro: 'Something tasty caught your eye? Here are all the featured dishes from the ad available on our platform.',
      list: [
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature1_tunapoke.png',
          title: 'Tuna poke bowl',
          link: 'https://www.just-eat.co.uk/takeaway/nearme/healthy',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature2_foccacia.png',
          title: 'Focaccia sandwich',
          link: 'https://www.just-eat.co.uk/takeaway/nearme/sandwiches',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature3_thaisalad.png',
          title: 'Thai salad',
          link: 'https://www.just-eat.co.uk/takeaway/nearme/thai',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature4_groceries.png',
          title: 'Groceries',
          link: 'https://www.just-eat.co.uk/takeaway/nearme/groceries',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature5_tacos.png',
          title: 'Tacos',
          link: 'https://www.just-eat.co.uk/takeaway/nearme/mexican',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature6_pizza.png',
          title: 'Pizza',
          link: 'https://www.just-eat.co.uk/takeaway/nearme/pizza',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature7_turkishmezze.png',
          title: 'Turkish mezze',
          link: 'https://www.just-eat.co.uk/takeaway/nearme/turkish',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature8_macaroons.png',
          title: 'Macaroons',
          link: 'https://www.just-eat.co.uk/takeaway/nearme/desserts',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature9_waffles.png',
          title: 'Waffles',
          link: 'https://www.just-eat.co.uk/takeaway/nearme/waffles',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature10_avotoast.png',
          title: 'Avocado & poached egg on toast',
          link: 'https://www.just-eat.co.uk/takeaway/nearme/breakfast',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature11_acaibowl.png',
          title: 'Acai bowl',
          link: 'https://www.just-eat.co.uk/takeaway/nearme/breakfast',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature12_fruitsalad.png',
          title: 'Fruit salad',
          link: 'https://www.just-eat.co.uk/takeaway/nearme/healthy',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature13_yogurt.png',
          title: 'Yogurt & granola',
          link: 'https://www.just-eat.co.uk/takeaway/nearme/breakfast',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature14_pastries.png',
          title: 'Selection of pastries',
          link: 'https://www.just-eat.co.uk/takeaway/nearme/desserts',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature15_icedcoffee.png',
          title: 'Iced coffee',
          link: 'https://www.just-eat.co.uk/takeaway/nearme/coffee',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature16_smoothie.png',
          title: 'Smoothies',
          link: 'https://www.just-eat.co.uk/takeaway/nearme/smoothies',
        },
      ]
    },
    word: {
      title: 'A word from those involved with the new Just Eat advert',
      words: [
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say-vue/static/img/profile_image_xtina.png',
          name: 'Christina Aguilera',
          role: 'Talent',
          quote: 'I had so much fun combining different music styles alongside my girl Latto for Just Eat Takeaway. With non-stop laughter and love, we had the best time bringing this project to life. It was clear while shooting long days that JET is the much needed one-stop-shop for meals and grocery needs.',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say-vue/static/img/profile_image_latto.png',
          name: 'Latto',
          role: 'Talent',
          quote: 'When I heard about the opportunity to work with Just Eat I was actually abroad on tour using the app! It was a no-brainer for me especially with the iconic Christina Aguilera involved. I had so much fun with this collab and have loved seeing it come to life.'
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say-vue/static/img/profile_image_suso.png',
          name: 'Susan O’Brien',
          role: 'VP Global Brand at Just Eat',
          quote: "We’re back with a new hip-hopera twist of our Did Somebody Say brand platform, this time with double the star power. Christina Aguilera and Latto are the perfect duo to bring something extraordinary to our customers, and this new mix doesn’t disappoint, just like the food choices you can get on Just Eat. Whether you're craving your favourite takeaway or looking for everyday groceries, we’re here everyday to deliver it all and more.",
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say-vue/static/img/profile_image_dept.png',
          name: 'Dept',
          role: 'Digital Agency',
          quote: 'Jeff Bowerman, Executive Creative Director at DEPT® said: “Our role at DEPT® was taking this great idea and making it sing in social and digital spaces. Tapping into cultural and native platform insights to speak to audiences wherever they spend their time, whilst making sure we deliver key brand messages like range and delivery in stand-out creative ways.”'
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say-vue/static/img/profile_logo_weber.png',
          name: 'Joanna Pritchard',
          role: 'Executive Vice President at Weber Shandwick',
          quote: 'The opportunity to explore the unexpected collision of hip hop and opera from an earned media perspective has been a fantastic challenge. We’ve loved developing earned ideas for the markets to adapt and implement locally that reflect joy in the unexpected and the surprising breadth of cuisines now available through Just Eat Takeaway.com.',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say-vue/static/img/profile_logo_radicalmedia.png',
          name: 'Ben Schneider',
          role: 'SVP and Executive Producer at RadicalMedia London',
          quote: 'Producing this years campaign alongside our partners at McCann London and JET Global has been a pleasure and privilege. The genre-crossing music - and a yet unseen artist pairing JET has curated presented a unique opportunity for our director Dave Meyers to bring the campaign to life.',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say-vue/static/img/profile_image_mccann.png',
          name: 'Rob Webster and Alexei Berwitz',
          role: 'Creative Directors at McCann London',
          quote: "Surprising is the greatest and perhaps the hardest brief of all. But thanks to our ever-courageous clients and the amazing efforts of all involved, this campaign hits unexpected notes at every turn – hip-hop and opera isn't an obvious musical combination, but it's one that really, really works.",
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say-vue/static/img/profile_image_talentrepublic.png',
          name: 'Talent Republic',
          role: 'Talent agency',
          quote: "The hip-hop meets opera creative certainly made this ‘Did Somebody Say’ campaign the most challenging from a Talent perspective. There are very few iconic female singers who can reach the vocal levels that Christina soared to, and with such a distinctive delivery. In Latto we found the perfect counterpoint as someone who has bags of attitude and energy, and who is fast becoming one of the most sought-after rappers around.\n\nIn terms of audience reach and recognition, pairing such an established Artist with such a fresh, new talent was key. The fact they embodied the characteristics of ‘rap’ and ‘opera’  they were asked to convey in their respective roles, and looked so stunning together, was the icing on the cake for us",
        }
      ]
    }
  },
  ie_ie: {
    navbar: {
      logo: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say-vue/static/img/logos/just-eat-logo.png',
      country_toggle: [
        {
          logo: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say-vue/static/img/logos/countries/ie.svg',
          url: '',
          text: 'Ireland'
        },
      ]
    },
    button: {
      text: 'Go home',
      url: 'https://www.just-eat.ie'
    },
    footer: {
      logo: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say-vue/static/img/logos/dss_logo_footer.png',
      main_link: 'https://www.just-eat.ie',
      links: [
        {
          text: 'Partner sign-up',
          url: 'https://restaurants.just-eat.ie/signup'
        },
        {
          text: 'Jobs',
          url: 'https://careers.justeattakeaway.com/global/en'
        },
        {
          text: 'Terms of Service',
          url: 'https://www.just-eat.ie/info/terms-and-conditions'
        },
        {
          text: 'Privacy statement',
          url: 'https://www.just-eat.ie/info/privacy-policy',
        },
        {
          text: 'Legal Info',
          url: 'https://www.just-eat.ie/info/legal-information'
        },
        {
          text: 'Cookie Statement',
          url: 'https://www.just-eat.ie/info/cookies-policy',
        },
        {
          text: 'Bug Bounty',
          url: 'https://www.just-eat.ie/info/bugbounty'
        },
        {
          text: 'Ethics hotline',
          url: 'https://app.convercent.com/en-ie/LandingPage/d8e86634-ec59-ec11-a985-000d3ab9f296'
        }
      ],
      copyright: '2023 Just Eat',
      mainNavFirst: {
        colTitle: 'Just Eat',
        subLinks: [
          {
            text: 'Just Eat for Business',
            url: 'https://business.just-eat.co.uk/just-eat-pay-ie',
          },
          {
            text: 'Customer service',
            url: 'https://www.just-eat.ie/help',
          },
          {
            text: 'List your business',
            url: 'https://restaurants.just-eat.ie/signup',
          },
          {
            text: 'Become an affiliate',
            url: 'https://restaurants.just-eat.ie/',
          },
          {
            text: 'Become a courier',
            url: 'https://couriers.just-eat.ie/application',
          },
          {
            text: 'Jobs',
            url: 'https://careers.justeattakeaway.com/global/en',
          },
          {
            text: 'Terms of use',
            url: 'https://www.just-eat.ie/info/terms-and-conditions',
          },
          {
            text: 'Privacy statement',
            url: 'https://www.just-eat.ie/info/privacy-policy',
          },
          {
            text: 'Legal Info',
            url: 'https://www.just-eat.ie/info/legal-information',
          },
          {
            text: 'Cookie statement',
            url: 'https://www.just-eat.ie/info/cookies-policy',
          },
          {
            text: 'Newsroom',
            url: 'https://www.justeattakeaway.com/newsroom/en-GB/?_gl=1*16vaaeu*_ga*ZDA5ODExZDgtMGZmNS00YmYwLThkYTAtMjg5MWM2MDljNjM0*_ga_4PH28YDTSD*MTY5ODQwNjU2My45LjEuMTY5ODQwNzE1OC4wLjAuMA..',
          }
        ],
      },
      mainNavSecond: [
        {
          colTitle: 'International',
          subLinks: [
            {
              text: 'Investor Relations',
              url: 'https://www.justeattakeaway.com/',
            },
            {
              text: '10bis',
              url: 'https://www.10bis.co.il',
            },
            {
              text: 'Bistro.sk',
              url: 'https://www.bistro.sk',
            },
            {
              text: 'Grubhub',
              url: 'https://www.grubhub.com',
            },
            {
              text: 'Just Eat - Switzerland',
              url: 'https://www.just-eat.ch',
            },
            {
              text: 'Just Eat - France',
              url: 'https://www.just-eat.fr',
            },
            {
              text: 'Just Eat - Denmark',
              url: 'https://www.just-eat.dk',
            },
            {
              text: 'Just Eat - Spain',
              url: 'https://www.just-eat.es',
            },
            {
              text: 'Just Eat - United Kingdom',
              url: 'https://www.just-eat.co.uk',
            },
            {
              text: 'Just Eat - Ireland',
              url: 'https://www.just-eat.ie',
            },
            {
              text: 'Just Eat - Italy',
              url: 'https://www.justeat.it',
            },
            {
              text: 'Lieferando.at',
              url: 'https://www.lieferando.at',
            },
            {
              text: 'Lieferando.de',
              url: 'https://www.lieferando.de',
            },
            {
              text: 'Menulog - Australia',
              url: 'https://www.menulog.com.au',
            },
            {
              text: 'Menulog - New Zealand',
              url: 'https://www.menulog.co.nz',
            },
            {
              text: 'Pyszne.pl',
              url: 'https://www.pyszne.pl',
            },
            {
              text: 'SkipTheDishes',
              url: 'https://www.skipthedishes.com',
            },
            {
              text: 'Takeaway.com - Belgium',
              url: 'https://www.takeaway.com/be',
            },
            {
              text: 'Takeaway.com - Luxembourg',
              url: 'https://www.takeaway.com/lu',
            },
            {
              text: 'Takeaway.com - Bulgaria',
              url: 'https://www.takeaway.com/bg',
            },
            {
              text: 'Thuisbezorgd.nl',
              url: 'https://www.thuisbezorgd.nl',
            }
          ],
        },
        {          
          colTitle: 'Food',
          subLinks: [
            {
              text: 'Chinese',
              url: 'https://www.just-eat.ie/takeaway/nearme/chinese',
            },
            {
              text: 'Pizza',
              url: 'https://www.just-eat.ie/takeaway/nearme/pizza',
            },
            {
              text: 'Indian',
              url: 'https://www.just-eat.ie/takeaway/nearme/indian',
            },
            {
              text: 'Chipper',
              url: 'https://www.just-eat.ie/takeaway/nearme/traditional-chipper',
            },
            {
              text: 'Sushi',
              url: 'https://www.just-eat.co.uk/takeaway/nearme/sushi',
            },
            {
              text: 'Burgers',
              url: 'https://www.just-eat.ie/takeaway/nearme/burgers',
            },
            {
              text: 'Mexican',
              url: 'https://www.just-eat.ie/takeaway/nearme/mexican',
            },
            {
              text: 'Italian',
              url: 'https://www.just-eat.ie/takeaway/nearme/italian',
            },
            {
              text: 'Breakfast',
              url: 'https://www.just-eat.ie/takeaway/nearme/breakfast',
            },
            {
              text: 'Lunch',
              url: 'https://www.just-eat.ie/takeaway/nearme/lunch',
            },
            {
              text: 'Dessert',
              url: 'https://www.just-eat.ie/takeaway/nearme/dessert',
            },
            {
              text: 'More',
              url: 'https://www.just-eat.ie/takeaway/nearme',
            }
          ],
        },
        {          
          colTitle: 'Explore',
          subLinks: [
            {
              text: 'Blog',
              url: 'https://www.just-eat.ie/blog',
            },
            {
              text: 'Just Eat Giftcards',
              url: 'https://giftcards.just-eat.ie/',
            },
            {
              text: 'Partner centre',
              url: 'https://partner.just-eat.ie/',
            },
            {
              text: 'Courier portal',
              url: 'https://couriers.just-eat.ie/application',
            },
            {
              text: 'Sustainability',
              url: 'https://www.just-eat.ie/explore/sustainability/'
            }
          ],
        },
        {
          colTitle: 'Cities',
          subLinks: [
            {
              text: 'Dublin',
              url: 'https://www.just-eat.ie/takeaway/dublin'
            },
            {
              text: 'Limerick',
              url: 'https://www.just-eat.ie/takeaway/limerick'
            },
            {
              text: 'Cork',
              url: 'https://www.just-eat.ie/takeaway/cork'
            },
            {
              text: 'Galway',
              url: 'https://www.just-eat.ie/takeaway/galway'
            },
            {
              text: 'Waterford',
              url: 'https://www.just-eat.ie/takeaway/waterford',
            },
            {
              text: 'View all locations',
              url: 'https://www.just-eat.ie/takeaway'
            }
          ]
        },
        {
          colTitle: 'Chains',
          subLinks: [
            {
              text: "McDonald's",
              url: 'https://www.just-eat.ie/takeaway/brands/mcdonalds'
            },
            {
              text: 'KFC',
              url: 'https://www.just-eat.ie/takeaway/brands/kfc'
            },
            {
              text: 'Burger King',
              url: 'https://www.just-eat.ie/takeaway/brands/burgerking'
            },
            {
              text: "Supermac's",
              url: 'https://www.just-eat.ie/takeaway/brands/supermacs'
            },
            {
              text: "Apache Pizza",
              url: 'https://www.just-eat.ie/takeaway/brands/apache-pizza'
            },
            {
              text: 'Subway',
              url: 'https://www.just-eat.ie/takeaway/brands/subway'
            },
            {
              text: 'Pizzza Hut',
              url: 'https://www.just-eat.ie/takeaway/brands/pizza-hut',
            },
            {
              text: 'Boojum',
              url: 'https://www.just-eat.ie/takeaway/brands/boojum-mex'
            },
            {
              text: 'Eddie Rockets',
              url: 'https://www.just-eat.ie/takeaway/brands/eddie-rockets'
            },
            {
              text: "Domino's Pizza",
              url: 'https://www.just-eat.ie/takeaway/brands/dominos-pizza',
            },
            {
              text: 'Centra',
              url: 'https://www.just-eat.ie/takeaway/brands/centra',
            },
            {
              text: 'View all chains',
              url: 'https://www.just-eat.ie/takeaway/brands'
            }
          ]
        },
      ]
    },
    faqs: [
      {
        question: 'Who’s starring in the new Just Eat ad?',
        answer: 'Pop icon, Katy Perry.'
      },
      {
        question: 'Why did we choose to work with Katy Perry?',
        answer: 'Following on from the success of our Snoop Dogg campaign, we wanted to go out loud and proud with a totally fresh, fun energy and Katy brings unparalleled star power to the brand, plus her playful nature matches ours to a tee. It’s the perfect partnership to continue building the instinctive connection between Just Eat and the joy of food delivery.',
      },
      {
        question: 'What is the concept of the ad?',
        answer: 'Just Eat offers a host of cuisines to cater for every mood and occasion. In the new TV ad, Katy Perry brings this to life by welcoming you into her world. A world where you can get whatever you want, whenever you want it.'
      },
      {
        question: 'What are the lyrics for Did somebody say featuring Katy Perry?',
        answer: '{Already shared per market}'
      }
    ],
    hero: {
      logo: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say-vue/static/img/logos/dss_logo.svg',
      main: 'Christina Aguilera and Latto',
      sub: 'Just Eat brand campaign 2023',
      img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say-vue/static/img/christina-latto.png?123',
    },
    about: {
      title: 'About the campaign',
      text: 'Together with McCann London, our latest creation brings together Latto’s hip-hop energy with Christina Aguilera’s effortless take on opera. The result? An unexpected visual and musical delight that perfectly embodies the surprising range of flavours you’ll find at Just Eat.',
      img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say-vue/static/img/xtina-wave.gif?222',
    },
    video: {
      title: 'Full Did Somebody Say music video',
      id: 'https://www.youtube.com/embed/lyKLT0IwTfY?si=2C80qd-6w97cgSll',
    },
    lyrics: {
      title: 'Did Somebody Say ft. Christina Aguilera and Latto full lyrics',
      lyrics: `La la la la la la laaa								
      Did Somebody Say Just Eat			
      
      Oh you thought it was just burgers and fries 
      They got more flavours than you tasted or you heard in your life			
      Ooh - this is what the app do, it ain’t only fast food 				
      Switching  styles like opera to rap too 	
      
      Yummy
      And it ain’t only restaurants any more
      We can go bananas at the grocery store 
      Yum yum yum yum			
      
      I’m a bad girl but my takeout badder
      What you need dude? I can cop a taco platter
      Thai rice sticky icky
      Gyoza on the side fried right cos we kinda picky 
      
      Breakfast or lunch hun, dinner or brunch 
      Wanna find the finest dining? I got a hunch
      And some hot tall dude’s bringing buns to the ballroom 
      
      Got me a strong coffee, let’s get it on papi
      Ice-cream with my magazine, who can stop me 				
      
      And my sushi train is on loop 		
      When you this slick, whatchoo gon’ do?
      
      Laaaaaaaaaa						
      Did Somebody Say Just Eat	`,
      img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say-vue/static/img/christina-lyrics.png?123',
    },
    food: {
      title: 'Featured food from the new campaign featuring Christina Aguilera and Latto',
      intro: 'Something tasty caught your eye? Here are all the featured dishes from the ad available on our platform.',
      list: [
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature1_tunapoke.png',
          title: 'Tuna poke bowl',
          link: 'https://www.just-eat.ie/takeaway/nearme/healthy',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature2_foccacia.png',
          title: 'Focaccia sandwich',
          link: 'https://www.just-eat.ie/takeaway/nearme/sandwiches',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature3_thaisalad.png',
          title: 'Thai salad',
          link: 'https://www.just-eat.ie/takeaway/nearme/thai',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature4_groceries.png',
          title: 'Groceries',
          link: 'https://www.just-eat.ie/takeaway/nearme/groceries',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature5_tacos.png',
          title: 'Tacos',
          link: 'https://www.just-eat.ie/takeaway/nearme/mexican',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature6_pizza.png',
          title: 'Pizza',
          link: 'https://www.just-eat.ie/takeaway/nearme/pizza',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature7_turkishmezze.png',
          title: 'Turkish mezze',
          link: 'https://www.just-eat.ie/takeaway/nearme/turkish',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature8_macaroons.png',
          title: 'Macaroons',
          link: 'https://www.just-eat.ie/takeaway/nearme/desserts',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature9_waffles.png',
          title: 'Waffles',
          link: 'https://www.just-eat.ie/takeaway/nearme/waffles',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature10_avotoast.png',
          title: 'Avocado & poached egg on toast',
          link: 'https://www.just-eat.ie/takeaway/nearme/breakfast',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature11_acaibowl.png',
          title: 'Acai bowl',
          link: 'https://www.just-eat.ie/takeaway/nearme/breakfast',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature12_fruitsalad.png',
          title: 'Fruit salad',
          link: 'https://www.just-eat.ie/takeaway/nearme/healthy',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature13_yogurt.png',
          title: 'Yogurt & granola',
          link: 'https://www.just-eat.ie/takeaway/nearme/breakfast',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature14_pastries.png',
          title: 'Selection of pastries',
          link: 'https://www.just-eat.ie/takeaway/nearme/desserts',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature15_icedcoffee.png',
          title: 'Iced coffee',
          link: 'https://www.just-eat.ie/takeaway/nearme/coffee',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature16_smoothie.png',
          title: 'Smoothies',
          link: 'https://www.just-eat.ie/takeaway/nearme/smoothies',
        },
      ]
    },
    word: {
      title: 'A word from those involved with the new Just Eat advert',
      words: [
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say-vue/static/img/profile_image_xtina.png',
          name: 'Christina Aguilera',
          role: 'Talent',
          quote: 'I had so much fun combining different music styles alongside my girl Latto for Just Eat Takeaway. With non-stop laughter and love, we had the best time bringing this project to life. It was clear while shooting long days that JET is the much needed one-stop-shop for meals and grocery needs.',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say-vue/static/img/profile_image_latto.png',
          name: 'Latto',
          role: 'Talent',
          quote: 'When I heard about the opportunity to work with Just Eat I was actually abroad on tour using the app! It was a no-brainer for me especially with the iconic Christina Aguilera involved. I had so much fun with this collab and have loved seeing it come to life.'
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say-vue/static/img/profile_image_suso.png',
          name: 'Susan O’Brien',
          role: 'VP Global Brand at Just Eat',
          quote: "We’re back with a new hip-hopera twist of our Did Somebody Say brand platform, this time with double the star power. Christina Aguilera and Latto are the perfect duo to bring something extraordinary to our customers, and this new mix doesn’t disappoint, just like the food choices you can get on Just Eat. Whether you're craving your favourite takeaway or looking for everyday groceries, we’re here everyday to deliver it all and more.",
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say-vue/static/img/profile_image_dept.png',
          name: 'Dept',
          role: 'Digital Agency',
          quote: 'Jeff Bowerman, Executive Creative Director at DEPT® said: “Our role at DEPT® was taking this great idea and making it sing in social and digital spaces. Tapping into cultural and native platform insights to speak to audiences wherever they spend their time, whilst making sure we deliver key brand messages like range and delivery in stand-out creative ways.”'
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say-vue/static/img/profile_logo_weber.png',
          name: 'Joanna Pritchard',
          role: 'Executive Vice President at Weber Shandwick',
          quote: 'The opportunity to explore the unexpected collision of hip hop and opera from an earned media perspective has been a fantastic challenge. We’ve loved developing earned ideas for the markets to adapt and implement locally that reflect joy in the unexpected and the surprising breadth of cuisines now available through Just Eat Takeaway.com.',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say-vue/static/img/profile_logo_radicalmedia.png',
          name: 'Ben Schneider',
          role: 'SVP and Executive Producer at RadicalMedia London',
          quote: 'Producing this years campaign alongside our partners at McCann London and JET Global has been a pleasure and privilege. The genre-crossing music - and a yet unseen artist pairing JET has curated presented a unique opportunity for our director Dave Meyers to bring the campaign to life.',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say-vue/static/img/profile_image_mccann.png',
          name: 'Rob Webster and Alexei Berwitz',
          role: 'Creative Directors at McCann London',
          quote: "Surprising is the greatest and perhaps the hardest brief of all. But thanks to our ever-courageous clients and the amazing efforts of all involved, this campaign hits unexpected notes at every turn – hip-hop and opera isn't an obvious musical combination, but it's one that really, really works.",
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say-vue/static/img/profile_image_talentrepublic.png',
          name: 'Talent Republic',
          role: 'Talent agency',
          quote: "The hip-hop meets opera creative certainly made this ‘Did Somebody Say’ campaign the most challenging from a Talent perspective. There are very few iconic female singers who can reach the vocal levels that Christina soared to, and with such a distinctive delivery. In Latto we found the perfect counterpoint as someone who has bags of attitude and energy, and who is fast becoming one of the most sought-after rappers around.\n\nIn terms of audience reach and recognition, pairing such an established Artist with such a fresh, new talent was key. The fact they embodied the characteristics of ‘rap’ and ‘opera’  they were asked to convey in their respective roles, and looked so stunning together, was the icing on the cake for us",
        }
      ]
    }
  },
  bg_bg: {
    navbar: {
      logo: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/logos/logo_be.svg',
      country_toggle: [
        {
          logo: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/country-svg/bg.svg',
          url: 'https://www.takeaway.com/bg/deals/koi-kaza/',
          text: 'български'
        },
        {
          logo: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/country-svg/gb.svg',
          url: 'https://www.takeaway.com/bg-en/deals/did-somebody-say/',
          text: 'English'
        },
      ]
    },
    button: {
      text: 'Go home',
      url: 'https://www.takeaway.com/bg'
    },
    footer: {
      logo: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/logos/dss_footer_takeaway.png',
      main_link: 'https://www.takeaway.com/bg',
      links: [
        {
          text: 'Препоръчай ресторант',
          url: 'https://www.takeaway.com/bg/preporachai'
        },
        {
          text: 'Регистрация на ресторант',
          url: 'https://www.takeaway.com/bg/registrirai-se'
        },
        {
          text: 'Кариери',
          url: 'https://careers.justeattakeaway.com/bg/bg?_gl=1*qvrvau*_ga*MDE4NmEyMmI0MTIwMDAxMzQ5OTMxMTEzNTFkZDA1MDc1MDAyZTA2ZDAwYjNi*_ga_4PH28YDTSD*MTY5OTk2Mjk2Mi4zMS4xLjE2OTk5NjgyMDguMC4wLjA.',
        },
        {
          text: 'Условия за ползване',
          url: 'https://www.takeaway.com/bg/uslovia-na-polzvane'
        },
        {
          text: 'Декларация за поверителност',
          url: 'https://www.takeaway.com/bg/politika-za-poveritelnost',
        },
        {
          text: 'Правна информация',
          url: 'https://www.takeaway.com/bg/pravna-informatsia'
        },
        {
          text: 'Използване на бисквитки',
          url: 'https://www.takeaway.com/bg/cookiestatement'
        },
        {
          text: 'Bug Bounty',
          url: 'https://www.takeaway.com/bg/bugbounty',
        },
        {
          text: 'Гореща линия за етични въпроси',
          url: 'https://app.convercent.com/bg-bg/LandingPage/d8e86634-ec59-ec11-a985-000d3ab9f296',
        }
      ],
      copyright: '2023 Takeaway.com',
      mainNavFirst: {
        colTitle: 'Takeaway.com',
        subLinks: [
          {
            text: 'Takeaway.com for Business',
            url: 'https://www.takeaway.com/bg/business',
          },
          {
            text: 'Обслужване на клиенти',
            url: 'https://www.takeaway.com/bg/obslujvaneklienti',
          },
          {
            text: 'Препоръчай бизнес',
            url: 'https://www.takeaway.com/bg/preporachai',
          },
          {
            text: 'Включи бизнеса си',
            url: 'https://www.takeaway.com/bg/registrirai-se',
          },
          {
            text: 'Стани куриер',
            url: 'https://www.takeaway.com/bg/dostavchik?utm_source=mainsite&utm_medium=referral&utm_content=footer',
          },
          {
            text: 'Кариери',
            url: 'https://careers.justeattakeaway.com/bg/bg?_gl=1*7317uo*_ga*MDE4NmEyMmI0MTIwMDAxMzQ5OTMxMTEzNTFkZDA1MDc1MDAyZTA2ZDAwYjNi*_ga_4PH28YDTSD*MTY5OTk2Mjk2Mi4zMS4xLjE2OTk5NjgyMDguMC4wLjA.',
          },
          {
            text: 'Печати',
            url: 'https://www.takeaway.com/bg#%D0%BF%D0%B5%D1%87%D0%B0%D1%82%D0%B8',
          },
          {
            text: 'Условия за ползване',
            url: 'https://www.takeaway.com/bg/uslovia-na-polzvane',
          },
          {
            text: 'Декларация за поверителност',
            url: 'https://www.takeaway.com/bg/politika-za-poveritelnost'
          },
          {
            text: 'Правна информация',
            url: 'https://www.takeaway.com/bg/pravna-informatsia',
          },
          {
            text: 'Използване на бисквитки',
            url: 'https://www.takeaway.com/bg/cookiestatement'
          }
        ],
      },
      mainNavSecond: [
        {
          colTitle: 'International',
          subLinks: [
            {
              text: 'Investor Relations',
              url: 'https://www.justeattakeaway.com/',
            },
            {
              text: '10bis',
              url: 'https://www.10bis.co.il',
            },
            {
              text: 'Bistro.sk',
              url: 'https://www.bistro.sk',
            },
            {
              text: 'Grubhub',
              url: 'https://www.grubhub.com',
            },
            {
              text: 'Just Eat - Switzerland',
              url: 'https://www.just-eat.ch',
            },
            {
              text: 'Just Eat - France',
              url: 'https://www.just-eat.fr',
            },
            {
              text: 'Just Eat - Denmark',
              url: 'https://www.just-eat.dk',
            },
            {
              text: 'Just Eat - Spain',
              url: 'https://www.just-eat.es',
            },
            {
              text: 'Just Eat - United Kingdom',
              url: 'https://www.just-eat.co.uk',
            },
            {
              text: 'Just Eat - Ireland',
              url: 'https://www.just-eat.ie',
            },
            {
              text: 'Just Eat - Italy',
              url: 'https://www.justeat.it',
            },
            {
              text: 'Lieferando.at',
              url: 'https://www.lieferando.at',
            },
            {
              text: 'Lieferando.de',
              url: 'https://www.lieferando.de',
            },
            {
              text: 'Menulog - Australia',
              url: 'https://www.menulog.com.au',
            },
            {
              text: 'Menulog - New Zealand',
              url: 'https://www.menulog.co.nz',
            },
            {
              text: 'Pyszne.pl',
              url: 'https://www.pyszne.pl',
            },
            {
              text: 'SkipTheDishes',
              url: 'https://www.skipthedishes.com',
            },
            {
              text: 'Takeaway.com - Belgium',
              url: 'https://www.takeaway.com/be',
            },
            {
              text: 'Takeaway.com - Luxembourg',
              url: 'https://www.takeaway.com/lu',
            },
            {
              text: 'Takeaway.com - Bulgaria',
              url: 'https://www.takeaway.com/bg',
            },
            {
              text: 'Thuisbezorgd.nl',
              url: 'https://www.thuisbezorgd.nl',
            }
          ],
        },
        {          
          colTitle: 'Кухня',
          subLinks: [
            {
              text: 'Кухня',
              url: 'https://www.takeaway.com/bg/porachai-hrana',
            },
            {
              text: 'Пица',
              url: 'https://www.takeaway.com/bg/porachai-pizza',
            },
            {
              text: 'Средиземноморска',
              url: 'https://www.takeaway.com/bg/porachai-sredizemnomorska-hrana',
            },
            {
              text: 'Грил',
              url: 'https://www.takeaway.com/bg/porachai-grill',
            },
            {
              text: 'Азиатска',
              url: 'https://www.takeaway.com/bg/porachai-asiatska-hrana',
            },
            {
              text: 'Друго',
              url: 'https://www.takeaway.com/bg/porachai-druga-hrana',
            },
            {
              text: 'Обяд/закуска',
              url: 'https://www.takeaway.com/bg/porachai-zakuska-i-obiad',
            },
            {
              text: 'Сладолед',
              url: 'https://www.takeaway.com/bg/porachai-napitki-i-sladoled',
            },
            {
              text: 'Още типове кухни...',
              url: 'https://www.takeaway.com/bg/porachai-oshte-hrana',
            },
          ],
        },
        {          
          colTitle: 'Виж още',
          subLinks: [
            {
              text: 'Foodwiki',
              url: 'https://www.takeaway.com/bg/foodwiki/',
            },
            {
              text: 'Станете куриер в София',
              url: 'https://www.takeaway.com/bg/dostavchik/sofiya',
            },
            {
              text: 'Станете куриер в Бургас',
              url: 'https://www.takeaway.com/bg/dostavchik/burgas',
            },
            {
              text: 'Станете куриер в Варна',
              url: 'https://www.takeaway.com/bg/dostavchik/varna',
            },
            {
              text: 'Станете куриер в Стара Загора',
              url: 'https://www.takeaway.com/bg/dostavchik/stara-zagora',
            },
            {
              text: 'Станете куриер в Пловдив',
              url: 'https://www.takeaway.com/bg/dostavchik/plovdiv',
            },
          ],
        },
        {
          colTitle: 'Вериги',
          subLinks: [
            {
              text: 'KFC',
              url: 'https://www.takeaway.com/bg/kfc'
            },
            {
              text: 'Aladin Foods',
              url: 'https://www.takeaway.com/bg/aladin-foods'
            },
            {
              text: 'Vetrilo',
              url: 'https://www.takeaway.com/bg/vetrilo'
            },
            {
              text: 'Subway',
              url: 'https://www.takeaway.com/bg/subway'
            },
            {
              text: 'Amici',
              url: 'https://www.takeaway.com/bg/amici',
            },
            {
              text: "McDonald's",
              url: 'https://www.takeaway.com/bg/mcdonalds'
            },
            {
              text: 'Starbucks',
              url: 'https://www.takeaway.com/bg/starbucks'
            },
            {
              text: 'PizzaLab',
              url: 'https://www.takeaway.com/bg/pizzalab'
            },
            {
              text: 'Mr. Pizza',
              url: 'https://www.takeaway.com/bg/mr-pizza'
            },
            {
              text: 'Пицария Лъчони',
              url: 'https://www.takeaway.com/bg/pitsariya-lachoni'
            },
            {
              text: 'Aiko',
              url: 'https://www.takeaway.com/bg/aiko',
            },
            {
              text: "Victoria",
              url: 'https://www.takeaway.com/bg/victoria'
            },
            {
              text: 'Burger King',
              url: 'https://www.takeaway.com/bg/burger-king'
            },
            {
              text: 'Street Chefs',
              url: 'https://www.takeaway.com/bg/street-chefs'
            },
            {
              text: 'Вериги ресторанти',
              url: 'https://www.takeaway.com/bg/chains',
            },
          ]
        },
        {
          colTitle: 'Нови търговски обекти',
          subLinks: [
            {
              text: "Quick Snack|Бърза Закуска, Пловдив",
              url: 'https://www.takeaway.com/bg/menu/quick-snackbrza-zakuska'
            },
            {
              text: 'Gostilitsa Dekovis|Гостилница Дековис, Благоевград',
              url: 'https://www.takeaway.com/bg/menu/dekovis-inngostilnica-dekovis'
            },
            {
              text: 'Fast Food Mireli|Бързо Хранене Мирели, Благоевград',
              url: 'https://www.takeaway.com/bg/menu/fast-food-mirelibrzo-xranene-mireli-blagoevgrad'
            },
            {
              text: "Egg Point|Ег Пойнт, Бургас",
              url: 'https://www.takeaway.com/bg/menu/egg-pointeg-point-yakim-yakimov'
            },
            {
              text: "Protein House|Протеин Хаус, София",
              url: 'https://www.takeaway.com/bg/menu/protein-hausprotein-xaus-oc'
            },
            {
              text: 'CAVA Restaurant|Ресторант КАВА, София',
              url: 'https://www.takeaway.com/bg/menu/cava-restaurantrestorant-kava-1'
            },
            {
              text: 'Egg Point|Ег Пойнт, София',
              url: 'https://www.takeaway.com/bg/menu/egg-pointeg-point-angel-kncev'
            },
            {
              text: 'Egg Point|Ег Пойнт, Бургас',
              url: 'https://www.takeaway.com/bg/menu/egg-pointeg-point-burgas'
            },
            {
              text: 'Egg Point|Ег Пойнт, София',
              url: 'https://www.takeaway.com/bg/menu/egg-pointeg-point-paradise'
            },
            {
              text: 'Salateria Soups & Salads|Салатерия Супи & Салати, София',
              url: 'https://www.takeaway.com/bg/menu/salateria-soups-saladssalateriya-supi-salati-mladost-4'
            }
          ]
        },
        {
          colTitle: 'Pегиони',
          subLinks: [
            {
              text: "Благоевград",
              url: 'https://www.takeaway.com/bg/porachai-hrana-blagoevgrad'
            },
            {
              text: 'Бургас',
              url: 'https://www.takeaway.com/bg/porachai-hrana-burgas'
            },
            {
              text: 'Варна',
              url: 'https://www.takeaway.com/bg/porachai-hrana-varna'
            },
            {
              text: "Велико Търново",
              url: 'https://www.takeaway.com/bg/porachai-hrana-veliko-trnovo'
            },
            {
              text: "Видин",
              url: 'https://www.takeaway.com/bg/porachai-hrana-vidin'
            },
            {
              text: 'Враца',
              url: 'https://www.takeaway.com/bg/porachai-hrana-vratsa'
            },
            {
              text: 'Габрово',
              url: 'https://www.takeaway.com/bg/porachai-hrana-gabrovo'
            },
            {
              text: 'Добрич',
              url: 'https://www.takeaway.com/bg/porachai-hrana-dobrich'
            },
            {
              text: 'Кърджали',
              url: 'https://www.takeaway.com/bg/porachai-hrana-krdzhali'
            },
            {
              text: 'Кюстендил',
              url: 'https://www.takeaway.com/bg/porachai-hrana-kyustendil'
            },
            {
              text: 'Ловеч',
              url: 'https://www.takeaway.com/bg/porachai-hrana-lovech'
            },
            {
              text: 'Монтана',
              url: 'https://www.takeaway.com/bg/porachai-hrana-montana'
            },
            {
              text: 'Пазарджик',
              url: 'https://www.takeaway.com/bg/porachai-hrana-pazardzhik'
            },
            {
              text: 'Перник',
              url: 'https://www.takeaway.com/bg/porachai-hrana-pernik'
            },
            {
              text: 'Плевен',
              url: 'https://www.takeaway.com/bg/porachai-hrana-pleven',
            },
            {
              text: "Пловдив",
              url: 'https://www.takeaway.com/bg/porachai-hrana-plovdiv'
            },
            {
              text: 'Разград',
              url: 'https://www.takeaway.com/bg/porachai-hrana-razgrad'
            },
            {
              text: 'Русе',
              url: 'https://www.takeaway.com/bg/porachai-hrana-ruse'
            },
            {
              text: 'Силистра',
              url: 'https://www.takeaway.com/bg/porachai-hrana-silistra'
            },
            {
              text: 'Сливен',
              url: 'https://www.takeaway.com/bg/porachai-hrana-sliven'
            },
            {
              text: 'Смолян',
              url: 'https://www.takeaway.com/bg/porachai-hrana-smolyan',
            },
            {
              text: "София",
              url: 'https://www.takeaway.com/bg/porachai-hrana-sofiya-province'
            },
            {
              text: 'София-град',
              url: 'https://www.takeaway.com/bg/porachai-hrana-sofiya-grad'
            },
            {
              text: 'Стара Загора',
              url: 'https://www.takeaway.com/bg/porachai-hrana-stara-zagora'
            },
            {
              text: 'Търговище',
              url: 'https://www.takeaway.com/bg/porachai-hrana-trgovishche',
            },
            {
              text: 'Хасково',
              url: 'https://www.takeaway.com/bg/porachai-hrana-khaskovo'
            },
            {
              text: 'Шумен',
              url: 'https://www.takeaway.com/bg/porachai-hrana-shumen',
            },
            {
              text: 'Ямбол',
              url: 'https://www.takeaway.com/bg/porachai-hrana-yambol'
            }
          ]
        },
      ]
    },
    faqs: [
      {
        question: 'Who’s starring in the new Just Eat ad?',
        answer: 'Pop icon, Katy Perry.'
      },
      {
        question: 'Why did we choose to work with Katy Perry?',
        answer: 'Following on from the success of our Snoop Dogg campaign, we wanted to go out loud and proud with a totally fresh, fun energy and Katy brings unparalleled star power to the brand, plus her playful nature matches ours to a tee. It’s the perfect partnership to continue building the instinctive connection between Just Eat and the joy of food delivery.',
      },
      {
        question: 'What is the concept of the ad?',
        answer: 'Just Eat offers a host of cuisines to cater for every mood and occasion. In the new TV ad, Katy Perry brings this to life by welcoming you into her world. A world where you can get whatever you want, whenever you want it.'
      },
      {
        question: 'What are the lyrics for Did somebody say featuring Katy Perry?',
        answer: '{Already shared per market}'
      }
    ],
    hero: {
      logo: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/logos/dss_takeaway_bg.png',
      main: 'Кристина Агилера и Latto',
      sub: 'Takeaway.com бранд кампания 2023',
      img: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/christina-latto.png',
    },
    about: {
      title: 'За кампанията',
      text: 'Завръщаме се с поредната свежа кампания.\n\nСъздадена заедно с агенцията McCann London,\nнай-новата ни реклама съчетава хип-хоп енергията на Latto с лекотата, с която Кристина Агилера навлиза в оперния диапазон. Резултатът? Неочаквано визуално и музикално удоволствие, идеално олицетворение на изненадващо широкия спектър от вкусове, които ще намерите в Takeaway.com.',
      img: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/xtina-wave.gif',
    },
    video: {
      title: 'Целият музикален клип „Did Somebody Say”',
      id: 'https://www.youtube.com/embed/cuEKDhd73DE?si=_7ksqIyyK92S0Vsr',
    },
    lyrics: {
      title: 'Did Somebody Say с участието на Кристина Агилера и  Latto – пълен текст',
      lyrics: `Готови ли сте за нещо ново?

      Кой каза Takeaway
      
      О, ти си мислеше, че имат само
      бургери и пържени картофки?
      
      Имат повече вкусни неща 
      отколкото си чул или опитал досега
      
      О, значи това е готино приложение
      Не само бърза храна, а супер улеснение
      
      Сменяш стила от опера до рап
      
      Вкусно
      
      И не е вече от ресторанти само
      
      Идва от магазина разнообразие голямо
      
      Като лошо момиче поръчвам по много
      
      Какво искаш, кажи!
      От всичко в поръчката добави
      
      Екзотична или местна, сложна или лесна
      
      Носeте вкусната храна
      че да чакам дълго не търпя
      
      Закуска, брънч или обяд ще намеря
      и, разбира се, вечеря
      
      Искам да хапна с класа и стил?
      Всичко тук мога да намеря
      
      И някой снажен кавалер на мига
      ще ми сервира на крака
      
      Дайте ми силно кафе веднага
      Че музата ми дойде и не ми се ляга
      
      Искам и нещо сладко, сладолед
      По релсите летя напред!
      
      Щом всичко се отпуши, ще хапна и суши
      
      Като съм толкова умна, нали
      какво да направя, по вода ми върви!
      
      Кой каза Takeaway`,
      img: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/christina-lyrics.png',
    },
    food: {
      title: 'Хапването, включено в новата кампания с Кристина Агилера и Latto',
      intro: 'Нещо вкусно ти хвана окото? Ето всички храни и рецепти от рекламата, които са налични в нашата платформа.*',
      list: [
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature1_tunapoke.png',
          title: 'Поке боул с риба тон',
          link: 'https://www.takeaway.com/bg/porachai-zdravoslovna-hrana-za',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature2_foccacia.png',
          title: 'Фокача сандвич',
          link: 'https://www.takeaway.com/bg/porachai-sandvichi',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature3_thaisalad.png',
          title: 'Тайландска салата',
          link: 'https://www.takeaway.com/bg/porachai-thai-hrana',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature5_tacos.png',
          title: 'Такос',
          link: 'https://www.takeaway.com/bg/porachai-mexican-hrana',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature6_pizza.png',
          title: 'Пица',
          link: 'https://www.takeaway.com/bg/porachai-italian-style-pizza',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature7_turkishmezze.png',
          title: 'Турско мезе',
          link: 'https://www.takeaway.com/bg/porachai-turkisch-hrana',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature8_macaroons.png',
          title: 'Френски макарони',
          link: 'https://www.takeaway.com/bg/porachai-deserti',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature10_avotoast.png',
          title: 'Авокадо тост с поширано яйце',
          link: 'https://www.takeaway.com/bg/porachai-zakuska',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature11_acaibowl.png',
          title: 'Купа с асаи бери',
          link: 'https://www.takeaway.com/bg/porachai-zakuska',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature12_fruitsalad.png',
          title: 'Плодова салата',
          link: 'https://www.takeaway.com/bg/porachai-zdravoslovna-hrana-za',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature13_yogurt.png',
          title: 'Йогурт и гранола',
          link: 'https://www.takeaway.com/bg/porachai-zakuska',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature14_pastries.png',
          title: 'Селекция от тестени закуски',
          link: 'https://www.takeaway.com/bg/porachai-deserti',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature15_icedcoffee.png',
          title: 'Ледено кафе ("Ice coffee")',
          link: 'https://www.takeaway.com/bg/porachai-kafe',
        },
      ],
      disclaimer: '*Наличността и доставката зависят от локацията.',
    },
  },
  bg_en: {
    navbar: {
      logo: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/logos/logo_be.svg',
      country_toggle: [
        {
          logo: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/country-svg/gb.svg',
          url: 'https://www.takeaway.com/bg/deals/koi-kaza/',
          text: 'English'
        },
        {
          logo: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/country-svg/bg.svg',
          url: 'https://www.takeaway.com/bg-en/deals/did-somebody-say/',
          text: 'български'
        },
      ],
      language: 'Language',
    },
    button: {
      text: 'Go home',
      url: 'https://www.takeaway.com/bg'
    },
    footer: {
      logo: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/logos/dss_footer_takeaway.png',
      main_link: 'https://www.takeaway.com/bg-en',
      links: [
        {
          text: 'Recommend a restaurant',
          url: 'https://www.takeaway.com/bg-en/recommend'
        },
        {
          text: 'Signup a restaurant',
          url: 'https://www.takeaway.com/bg-en/signup'
        },
        {
          text: 'Jobs',
          url: 'https://careers.justeattakeaway.com/global/en?_gl=1*6nu7io*_ga*MDE4NmEyMmI0MTIwMDAxMzQ5OTMxMTEzNTFkZDA1MDc1MDAyZTA2ZDAwYjNi*_ga_4PH28YDTSD*MTY5OTk2Mjk2Mi4zMS4xLjE2OTk5NzUwMTIuMC4wLjA.',
        },
        {
          text: 'Terms of Service',
          url: 'https://www.takeaway.com/bg-en/terms-of-use'
        },
        {
          text: 'Privacy statement',
          url: 'https://www.takeaway.com/bg-en/privacy-statement',
        },
        {
          text: 'Colophon',
          url: 'https://www.takeaway.com/bg-en/colofon'
        },
        {
          text: 'Cookie statement',
          url: 'https://www.takeaway.com/bg-en/cookiestatement'
        },
        {
          text: 'Bug Bounty',
          url: 'https://www.takeaway.com/bg-en/bugbounty',
        },
        {
          text: 'Ethics hotline',
          url: 'https://app.convercent.com/en-gb/LandingPage/d8e86634-ec59-ec11-a985-000d3ab9f296'
        },
      ],
      copyright: '2023 Takeaway.com',
      mainNavFirst: {
        colTitle: 'Just Eat',
        subLinks: [
          {
            text: 'Takeaway.com for Business',
            url: 'https://www.takeaway.com/bg-en/business',
          },
          {
            text: 'Customer service',
            url: 'https://www.takeaway.com/bg-en/customerservice'
          },
          {
            text: 'Recommend a business',
            url: 'https://www.takeaway.com/bg-en/recommend'
          },
          {
            text: 'List your business',
            url: 'https://www.takeaway.com/bg-en/signup',
          },
          {
            text: 'Become a courier',
            url: 'https://www.takeaway.com/bg/dostavchik?utm_source=mainsite&utm_medium=referral&utm_content=footer'
          },
          {
            text: 'Jobs',
            url: 'https://careers.justeattakeaway.com/global/en?_gl=1*1o1ab1i*_ga*MDE4NmEyMmI0MTIwMDAxMzQ5OTMxMTEzNTFkZDA1MDc1MDAyZTA2ZDAwYjNi*_ga_4PH28YDTSD*MTY5OTk2Mjk2Mi4zMS4xLjE2OTk5NzUwMTIuMC4wLjA.'
          },
          {
            text: 'StampCard',
            url: 'https://www.takeaway.com/bg-en#stamp-cards'
          },
          {
            text: 'Terms of use',
            url: 'https://www.takeaway.com/bg-en/terms-of-use'
          },
          {
            text: 'Privacy statement',
            url: 'https://www.takeaway.com/bg-en/privacy-statement',
          },
          {
            text: 'Colophon',
            url: 'https://www.takeaway.com/bg-en/colofon',
          },
          {
            text: 'Cookie statement',
            url: 'https://www.takeaway.com/bg-en/cookiestatement'
          }
        ],
      },
      mainNavSecond: [
        {
          colTitle: 'International',
          subLinks: [
            {
              text: 'Investor Relations',
              url: 'https://www.justeattakeaway.com/',
            },
            {
              text: '10bis',
              url: 'https://www.10bis.co.il',
            },
            {
              text: 'Bistro.sk',
              url: 'https://www.bistro.sk',
            },
            {
              text: 'Grubhub',
              url: 'https://www.grubhub.com',
            },
            {
              text: 'Just Eat - Switzerland',
              url: 'https://www.just-eat.ch',
            },
            {
              text: 'Just Eat - France',
              url: 'https://www.just-eat.fr',
            },
            {
              text: 'Just Eat - Denmark',
              url: 'https://www.just-eat.dk',
            },
            {
              text: 'Just Eat - Spain',
              url: 'https://www.just-eat.es',
            },
            {
              text: 'Just Eat - United Kingdom',
              url: 'https://www.just-eat.co.uk',
            },
            {
              text: 'Just Eat - Ireland',
              url: 'https://www.just-eat.ie',
            },
            {
              text: 'Just Eat - Italy',
              url: 'https://www.justeat.it',
            },
            {
              text: 'Lieferando.at',
              url: 'https://www.lieferando.at',
            },
            {
              text: 'Lieferando.de',
              url: 'https://www.lieferando.de',
            },
            {
              text: 'Menulog - Australia',
              url: 'https://www.menulog.com.au',
            },
            {
              text: 'Menulog - New Zealand',
              url: 'https://www.menulog.co.nz',
            },
            {
              text: 'Pyszne.pl',
              url: 'https://www.pyszne.pl',
            },
            {
              text: 'SkipTheDishes',
              url: 'https://www.skipthedishes.com',
            },
            {
              text: 'Takeaway.com - Belgium',
              url: 'https://www.takeaway.com/be',
            },
            {
              text: 'Takeaway.com - Luxembourg',
              url: 'https://www.takeaway.com/lu',
            },
            {
              text: 'Takeaway.com - Bulgaria',
              url: 'https://www.takeaway.com/bg',
            },
            {
              text: 'Thuisbezorgd.nl',
              url: 'https://www.thuisbezorgd.nl',
            }
          ],
        },
        {          
          colTitle: 'Food',
          subLinks: [
            {
              text: 'Food',
              url: 'https://www.takeaway.com/bg-en/order-takeaway',
            },
            {
              text: 'Pizza',
              url: 'https://www.takeaway.com/bg-en/order-pizza',
            },
            {
              text: 'Mediterranean',
              url: 'https://www.takeaway.com/bg-en/order-mediterranean-food',
            },
            {
              text: 'Grill',
              url: 'https://www.takeaway.com/bg-en/order-grill',
            },
            {
              text: 'Asian',
              url: 'https://www.takeaway.com/bg-en/order-asian-food',
            },
            {
              text: 'Other',
              url: 'https://www.takeaway.com/bg-en/order-other-food',
            },
            {
              text: 'Lunch / breakfast',
              url: 'https://www.takeaway.com/bg-en/order-lunch-and-breakfast',
            },
            {
              text: 'Drinks Ice cream',
              url: 'https://www.takeaway.com/bg-en/order-drinks-and-icecream',
            },
            {
              text: 'Order more food...',
              url: 'https://www.takeaway.com/bg-en/order-more-food',
            }
          ],
        },
        {          
          colTitle: 'Explore',
          subLinks: [
            {
              text: 'Foodwiki',
              url: 'https://www.takeaway.com/bg-en/foodwiki/',
            },
            {
              text: 'Win UEFA Europa League® Tickets',
              url: 'https://www.takeaway.com/bg-en/deals/match-day-deals/',
            },
          ],
        },
        {
          colTitle: 'Chains',
          subLinks: [
            {
              text: 'KFC',
              url: 'https://www.takeaway.com/bg-en/kfc'
            },
            {
              text: 'Aladin Foods',
              url: 'https://www.takeaway.com/bg-en/aladin-foods'
            },
            {
              text: 'Vetrilo',
              url: 'https://www.takeaway.com/bg-en/vetrilo'
            },
            {
              text: 'Subway',
              url: 'https://www.takeaway.com/bg-en/subway'
            },
            {
              text: 'Amici',
              url: 'https://www.takeaway.com/bg-en/amici',
            },
            {
              text: "McDonald's",
              url: 'https://www.takeaway.com/bg-en/mcdonalds'
            },
            {
              text: 'Starbucks',
              url: 'https://www.takeaway.com/bg-en/starbucks'
            },
            {
              text: 'PizzaLab',
              url: 'https://www.takeaway.com/bg-en/pizzalab'
            },
            {
              text: 'Mr. Pizza',
              url: 'https://www.takeaway.com/bg-en/mr-pizza'
            },
            {
              text: 'Пицария Лъчони',
              url: 'https://www.takeaway.com/bg-en/pitsariya-lachoni'
            },
            {
              text: 'Aiko',
              url: 'https://www.takeaway.com/bg-en/aiko',
            },
            {
              text: "Victoria",
              url: 'https://www.takeaway.com/bg-en/victoria'
            },
            {
              text: 'Burger King',
              url: 'https://www.takeaway.com/bg-en/burger-king'
            },
            {
              text: 'Street Chefs',
              url: 'https://www.takeaway.com/bg-en/street-chefs'
            },
            {
              text: 'More chains...',
              url: 'https://www.takeaway.com/bg-en/chains',
            },
          ]
        },
        {
          colTitle: 'New places',
          subLinks: [
            {
              text: "Bar and Bistrot Joshua|Бар Джошуа, Благоевград",
              url: 'https://www.takeaway.com/bg-en/menu/bar-and-bistrot-joshuabar-dzhoshua'
            },
            {
              text: 'Quick Snack|Бърза Закуска, Пловдив',
              url: 'https://www.takeaway.com/bg-en/menu/quick-snackbrza-zakuska'
            },
            {
              text: 'Gostilitsa Dekovis|Гостилница Дековис, Благоевград',
              url: 'https://www.takeaway.com/bg-en/menu/dekovis-inngostilnica-dekovis'
            },
            {
              text: "Fast Food Mireli|Бързо Хранене Мирели, Благоевград",
              url: 'https://www.takeaway.com/bg-en/menu/fast-food-mirelibrzo-xranene-mireli-blagoevgrad'
            },
            {
              text: "Egg Point|Ег Пойнт, Бургас",
              url: 'https://www.takeaway.com/bg-en/menu/egg-pointeg-point-yakim-yakimov'
            },
            {
              text: 'Protein House|Протеин Хаус, София',
              url: 'https://www.takeaway.com/bg-en/menu/protein-hausprotein-xaus-oc'
            },
            {
              text: 'CAVA Restaurant|Ресторант КАВА, София',
              url: 'https://www.takeaway.com/bg-en/menu/cava-restaurantrestorant-kava-1'
            },
            {
              text: 'Egg Point|Ег Пойнт, София',
              url: 'https://www.takeaway.com/bg-en/menu/egg-pointeg-point-angel-kncev'
            },
            {
              text: 'Egg Point|Ег Пойнт, Бургас',
              url: 'https://www.takeaway.com/bg-en/menu/egg-pointeg-point-burgas'
            },
            {
              text: 'Egg Point|Ег Пойнт, София',
              url: 'https://www.takeaway.com/bg-en/menu/egg-pointeg-point-paradise'
            }
          ]
        },
        {
          colTitle: 'Regions',
          subLinks: [
            {
              text: "Blagoevgrad",
              url: 'https://www.takeaway.com/bg-en/order-takeaway-blagoevgrad'
            },
            {
              text: 'Burgas',
              url: 'https://www.takeaway.com/bg-en/order-takeaway-burgas'
            },
            {
              text: 'Varna',
              url: 'https://www.takeaway.com/bg-en/order-takeaway-varna'
            },
            {
              text: "Veliko Tarnovo",
              url: 'https://www.takeaway.com/bg-en/order-takeaway-veliko-trnovo'
            },
            {
              text: "Vidin",
              url: 'https://www.takeaway.com/bg-en/order-takeaway-vidin'
            },
            {
              text: 'Vratsa',
              url: 'https://www.takeaway.com/bg-en/order-takeaway-vratsa'
            },
            {
              text: 'Gabrovo',
              url: 'https://www.takeaway.com/bg-en/order-takeaway-gabrovo'
            },
            {
              text: 'Dobrich',
              url: 'https://www.takeaway.com/bg-en/order-takeaway-dobrich'
            },
            {
              text: 'Kardzhali',
              url: 'https://www.takeaway.com/bg-en/order-takeaway-kardzhali'
            },
            {
              text: 'Kyustendil',
              url: 'https://www.takeaway.com/bg-en/order-takeaway-kyustendil'
            },
            {
              text: 'Lovech',
              url: 'https://www.takeaway.com/bg-en/order-takeaway-lovech'
            },
            {
              text: 'Мontana',
              url: 'https://www.takeaway.com/bg-en/order-takeaway-montana'
            },
            {
              text: 'Pazardzhik',
              url: 'https://www.takeaway.com/bg-en/order-takeaway-pazardzhik'
            },
            {
              text: 'Pernik',
              url: 'https://www.takeaway.com/bg-en/order-takeaway-pernik'
            },
            {
              text: 'Pleven',
              url: 'https://www.takeaway.com/bg-en/order-takeaway-pleven',
            },
            {
              text: "Plovdiv",
              url: 'https://www.takeaway.com/bg-en/order-takeaway-plovdiv'
            },
            {
              text: 'Razgrad',
              url: 'https://www.takeaway.com/bg-en/order-takeaway-razgrad'
            },
            {
              text: 'Ruse',
              url: 'https://www.takeaway.com/bg-en/order-takeaway-ruse'
            },
            {
              text: 'Silistra',
              url: 'https://www.takeaway.com/bg-en/order-takeaway-silistra'
            },
            {
              text: 'Sliven',
              url: 'https://www.takeaway.com/bg-en/order-takeaway-sliven',
            },
            {
              text: "Smolyan",
              url: 'https://www.takeaway.com/bg-en/order-takeaway-smolyan'
            },
            {
              text: 'Sofia province',
              url: 'https://www.takeaway.com/bg-en/order-takeaway-sofia-province'
            },
            {
              text: 'Sofia City',
              url: 'https://www.takeaway.com/bg-en/order-takeaway-sofia-city'
            },
            {
              text: 'Stara Zagora',
              url: 'https://www.takeaway.com/bg-en/order-takeaway-stara-zagora',
            },
            {
              text: 'Targovishte',
              url: 'https://www.takeaway.com/bg-en/order-takeaway-targovishte'
            },
            {
              text: 'Haskovo',
              url: 'https://www.takeaway.com/bg-en/order-takeaway-haskovo',
            },
            {
              text: 'Shumen',
              url: 'https://www.takeaway.com/bg-en/order-takeaway-shumen'
            },
            {
              text: 'Yambol',
              url: 'https://www.takeaway.com/bg-en/order-takeaway-yambol'
            }
          ]
        },
      ]
    },
    hero: {
      logo: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/logos/dss_takeaway_bg.png',
      main: 'Christina Aguilera and Latto',
      sub: 'Takeaway.com brand campaign 2023',
      img: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/christina-latto.png',
    },
    about: {
      title: 'About the campaign',
      text: "We are back with another fresh campaign.\n\nCreated in conjunction with agency McCann London, our latest ad combines Latto's hip-hop energy with Christina Aguilera's operatic range of ease. The result? An unexpected visual and musical delight, a perfect embodiment of the surprisingly wide range of flavors you'll find at Takeaway.com.",
      img: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/xtina-wave.gif',
    },
    video: {
      title: 'Did Somebody Say Full Music Video',
      id: 'https://www.youtube.com/embed/cuEKDhd73DE?si=_7ksqIyyK92S0Vsr',
    },
    lyrics: {
      title: 'Did Somebody Say Featuring Christina Aguilera & Latto - Full Text',
      lyrics: `"Y'all ready for something new?

      Who said Takeaway
      
      Oh, you thought they only have
      burgers and fries?
      
      They've got more tasty things than you
      have heard or tasted so far
      
      Ooh, it's a cool app then
      It ain't just fast food, but super helpful
      
      Switching style from opera to rap
      
      Yummy
      
      And it ain't only from restaurants anymore
      
      Great variety comes from the store
      
      Like a bad girl I order a lot
      
      What you want, just say it!
      Add from everything to the order
      
      Exotic or local, complex or simple
      
      Bring me the tasty food
      cos I don't like to wait
      
      Breakfast, brunch or lunch I'll find
      and dinner, of course 
      
      Wanna еat with style and class?
      I can find it all here
      
      And some tall handsome man now 
      will come to serve me where I sit
      
      Gеt me a strong coffee at once
      Cos my muse appeared and I don't feel like going to bed
      
      I want something sweet too, some ice cream
      I steam forward on the tracks! 
      
      When everything is going (well) I can have some sushi too
      
      When I'm so smart, right
      what can I do, all goes well for me!
      
      Who said Takeaway"`,
      img: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/christina-lyrics.png',
    },
    food: {
      title: 'The chow included in the the new campaign with Christina Aguilera and Latto',
      intro: 'Something tasty caught your eye? Here are all the foods and recipes from the ad that are available on our platform.*',
      list: [
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature1_tunapoke.png',
          title: 'Tuna poke bowl',
          link: 'https://www.takeaway.com/bg-en/order-healthy-food-in',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature2_foccacia.png',
          title: 'Focaccia sandwich',
          link: 'https://www.takeaway.com/bg-en/order-sandwiches',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature3_thaisalad.png',
          title: 'Thai salad',
          link: 'https://www.takeaway.com/bg-en/order-thai-food',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature4_groceries.png',
          title: 'Groceries',
          link: 'https://www.takeaway.com/bg-en/order-groceries',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature5_tacos.png',
          title: 'Tacos',
          link: 'https://www.takeaway.com/bg-en/order-mexican-food',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature6_pizza.png',
          title: 'Pizza',
          link: 'https://www.takeaway.com/bg-en/order-italian-style-pizza',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature7_turkishmezze.png',
          title: 'Turkish mezze',
          link: 'https://www.takeaway.com/bg-en/order-turkisch-food',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature8_macaroons.png',
          title: 'Macaroons',
          link: 'https://www.takeaway.com/bg-en/order-desserts',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature10_avotoast.png',
          title: 'Avocado & poached egg on toast',
          link: 'https://www.takeaway.com/bg-en/order-breakfast',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature11_acaibowl.png',
          title: 'Acai bowl',
          link: 'https://www.takeaway.com/bg-en/order-breakfast',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature12_fruitsalad.png',
          title: 'Fruit salad',
          link: 'https://www.takeaway.com/bg-en/order-healthy-food-in',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature13_yogurt.png',
          title: 'Yogurt & granola',
          link: 'https://www.takeaway.com/bg-en/order-breakfast',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature14_pastries.png',
          title: 'Selection of pastries',
          link: 'https://www.takeaway.com/bg-en/order-desserts',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature15_icedcoffee.png',
          title: 'Iced coffee',
          link: 'https://www.takeaway.com/bg-en/order-coffee',
        },
      ],
      disclaimer: '*All supply is dependent on location.',
    },
  },
  de_en: {
    navbar: {
      logo: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/logos/logo_at.svg',
      country_toggle: [
        {
          logo: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/country-svg/gb.svg',
          url: 'https://www.lieferando.de/en/explore/did-somebody-say/',
          text: 'English'
        },
        {
          logo: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/country-svg/de.svg',
          url: 'https://www.lieferando.de/entdecke/hoer-ich-da-lieferando/',
          text: 'Deutsch'
        },
      ],
      language: 'Language',
    },
    button: {
      text: 'Go home',
      url: 'https://www.lieferando.de/en'
    },
    footer: {
      logo: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/logos/dss_footer_lieferando.png',
      main_link: 'https://www.lieferando.de/en',
      links: [
        {
          text: 'Recommend a restaurant',
          url: 'https://www.lieferando.de/en/recommend'
        },
        {
          text: 'Sign up a restaurant',
          url: 'https://www.lieferando.de/en/signup'
        },
        {
          text: 'Jobs',
          url: 'https://careers.justeattakeaway.com/global/en?_gl=1*slj9ai*_ga*MDE4NWJiMTBmMzQ5MDAyMmYyNDFkYjRmZDdjMjA1MDc1MDAzMDA2ZDAwYjNi*_ga_4PH28YDTSD*MTcwMDA0NzI3OC41Mi4xLjE3MDAwNTAyODguMC4wLjA.',
        },
        {
          text: 'Terms of Service',
          url: 'https://www.lieferando.de/en/terms-of-use'
        },
        {
          text: 'Privacy statement',
          url: 'https://www.lieferando.de/en/privacy-statement',
        },
        {
          text: 'Colophon',
          url: 'https://www.lieferando.de/en/colofon'
        },
        {
          text: 'Cookie statement',
          url: 'https://www.lieferando.de/en/cookiestatement'
        },
        {
          text: 'Bug Bounty',
          url: 'https://www.lieferando.de/en/bugbounty',
        },
        {
          text: 'Ethics hotline',
          url: 'https://app.convercent.com/en-gb/LandingPage/d8e86634-ec59-ec11-a985-000d3ab9f296'
        },
      ],
      copyright: '2023 Lieferando.de',
      mainNavFirst: {
        colTitle: 'Lieferando.de',
        subLinks: [
          {
            text: 'Lieferando for Business',
            url: 'https://www.lieferando.de/en/business',
          },
          {
            text: 'Customer service',
            url: 'https://www.lieferando.de/en/customerservice'
          },
          {
            text: 'Recommend a business',
            url: 'https://www.lieferando.de/en/recommend'
          },
          {
            text: 'List your business',
            url: 'https://www.lieferando.de/en/signup',
          },
          {
            text: 'Become an affiliate',
            url: 'https://www.lieferando.de/en/affiliate',
          },
          {
            text: 'Become a courier',
            url: 'https://www.lieferando.de/en/courier?utm_source=mainsite&utm_medium=referral&utm_content=footer'
          },
          {
            text: 'Jobs',
            url: 'https://careers.justeattakeaway.com/global/en?_gl=1*1p0imqn*_ga*MDE4NWJiMTBmMzQ5MDAyMmYyNDFkYjRmZDdjMjA1MDc1MDAzMDA2ZDAwYjNi*_ga_4PH28YDTSD*MTcwMDA0NzI3OC41Mi4xLjE3MDAwNTAyODguMC4wLjA.'
          },
          {
            text: 'StampCard',
            url: 'https://www.lieferando.de/en#stamp-cards'
          },
          {
            text: 'Points',
            url: 'https://www.lieferando.de/en/punkte',
          },
          {
            text: 'Terms of use',
            url: 'https://www.lieferando.de/en/terms-of-use'
          },
          {
            text: 'Privacy statement',
            url: 'https://www.lieferando.de/en/privacy-statement',
          },
          {
            text: 'Colophon',
            url: 'https://www.lieferando.de/en/colofon',
          },
          {
            text: 'Cookie statement',
            url: 'https://www.lieferando.de/en/cookiestatement'
          },
          {
            text: 'Newsroom',
            url: 'https://www.justeattakeaway.com/newsroom/de-DE/?_gl=1*5qojc9*_ga*MDE4NWJiMTBmMzQ5MDAyMmYyNDFkYjRmZDdjMjA1MDc1MDAzMDA2ZDAwYjNi*_ga_4PH28YDTSD*MTcwMDA0NzI3OC41Mi4xLjE3MDAwNTAyODguMC4wLjA.',
          }
        ],
      },
      mainNavSecond: [
        {
          colTitle: 'International',
          subLinks: [
            {
              text: 'Investor Relations',
              url: 'https://www.justeattakeaway.com/',
            },
            {
              text: '10bis',
              url: 'https://www.10bis.co.il',
            },
            {
              text: 'Bistro.sk',
              url: 'https://www.bistro.sk',
            },
            {
              text: 'Grubhub',
              url: 'https://www.grubhub.com',
            },
            {
              text: 'Just Eat - Switzerland',
              url: 'https://www.just-eat.ch',
            },
            {
              text: 'Just Eat - France',
              url: 'https://www.just-eat.fr',
            },
            {
              text: 'Just Eat - Denmark',
              url: 'https://www.just-eat.dk',
            },
            {
              text: 'Just Eat - Spain',
              url: 'https://www.just-eat.es',
            },
            {
              text: 'Just Eat - United Kingdom',
              url: 'https://www.just-eat.co.uk',
            },
            {
              text: 'Just Eat - Ireland',
              url: 'https://www.just-eat.ie',
            },
            {
              text: 'Just Eat - Italy',
              url: 'https://www.justeat.it',
            },
            {
              text: 'Lieferando.at',
              url: 'https://www.lieferando.at',
            },
            {
              text: 'Lieferando.de',
              url: 'https://www.lieferando.de',
            },
            {
              text: 'Menulog - Australia',
              url: 'https://www.menulog.com.au',
            },
            {
              text: 'Menulog - New Zealand',
              url: 'https://www.menulog.co.nz',
            },
            {
              text: 'Pyszne.pl',
              url: 'https://www.pyszne.pl',
            },
            {
              text: 'SkipTheDishes',
              url: 'https://www.skipthedishes.com',
            },
            {
              text: 'Takeaway.com - Belgium',
              url: 'https://www.takeaway.com/be',
            },
            {
              text: 'Takeaway.com - Luxembourg',
              url: 'https://www.takeaway.com/lu',
            },
            {
              text: 'Takeaway.com - Bulgaria',
              url: 'https://www.takeaway.com/bg',
            },
            {
              text: 'Thuisbezorgd.nl',
              url: 'https://www.thuisbezorgd.nl',
            }
          ],
        },
        {          
          colTitle: 'Food',
          subLinks: [
            {
              text: 'Food',
              url: 'https://www.lieferando.de/en/order-takeaway',
            },
            {
              text: 'Pizza',
              url: 'https://www.lieferando.de/en/order-pizza',
            },
            {
              text: 'Chinese',
              url: 'https://www.lieferando.de/en/order-chinese-food',
            },
            {
              text: 'Vegan',
              url: 'https://www.lieferando.de/en/order-vegan',
            },
            {
              text: 'Sushi',
              url: 'https://www.lieferando.de/en/order-sushi',
            },
            {
              text: 'Indian',
              url: 'https://www.lieferando.de/en/order-indian-food',
            },
            {
              text: 'Döner',
              url: 'https://www.lieferando.de/en/order-doner',
            },
            {
              text: 'Burgers',
              url: 'https://www.lieferando.de/en/order-burger',
            },
            {
              text: 'Ice cream',
              url: 'https://www.lieferando.de/en/order-ice-cream',
            },
            {
              text: 'Asian',
              url: 'https://www.lieferando.de/en/order-asian',
            },
            {
              text: 'Groceries',
              url: 'https://www.lieferando.de/en/order-groceries',
            },
            {
              text: 'Order more food...',
              url: 'https://www.lieferando.de/en/order-more-food',
            }
          ],
        },
        {          
          colTitle: 'Explore',
          subLinks: [
            {
              text: 'Foodwiki',
              url: 'https://www.lieferando.de/en/foodwiki/',
            },
            {
              text: 'Coca-Cola MealDeals',
              url: 'https://www.lieferando.de/en/deals/coca-cola/',
            },
            {
              text: 'Giftcards',
              url: 'https://www.lieferando.de/en/gift-cards/',
            },
            {
              text: 'Sustainability',
              url: 'https://www.lieferando.de/en/sustainability/',
            },
            {
              text: 'Taste the Summer',
              url: 'https://www.lieferando.de/en/deals/tastethesummer/',
            },
            {
              text: 'Become a Courier in Düsseldorf',
              url: 'https://www.lieferando.de/en/courier/dusseldorf',
            },
            {
              text: 'Become a Courier in Stuttgart',
              url: 'https://www.lieferando.de/en/courier/stuttgart',
            },
            {
              text: 'Become a Courier in Cologne',
              url: 'https://www.lieferando.de/en/courier/cologne',
            },
            {
              text: 'Become a Courier in Hannover',
              url: 'https://www.lieferando.de/en/courier/hannover',
            },
            {
              text: 'Become a Courier in Frankfurt',
              url: 'https://www.lieferando.de/en/courier/frankfurt',
            },
            {
              text: 'Become a Courier in Munich',
              url: 'https://www.lieferando.de/en/courier/munich',
            },
            {
              text: 'Become a Courier in Berlin',
              url: 'https://www.lieferando.de/en/courier/berlin',
            },
            {
              text: 'Become a Courier in Hamburg',
              url: 'https://www.lieferando.de/en/courier/hamburg',
            },
            {
              text: 'Win UEFA Europa League® Tickets',
              url: 'https://www.lieferando.de/en/deals/match-day-deals/',
            },
          ],
        },
        {
          colTitle: 'Cities',
          subLinks: [
            {
              text: 'Berlin',
              url: 'https://www.lieferando.de/en/order-takeaway-berlin-berlin'
            },
            {
              text: 'Hamburg',
              url: 'https://www.lieferando.de/en/order-takeaway-hamburg-hamburg'
            },
            {
              text: 'München',
              url: 'https://www.lieferando.de/en/order-takeaway-muenchen'
            },
            {
              text: 'Frankfurt',
              url: 'https://www.lieferando.de/en/order-takeaway-frankfurt'
            },
            {
              text: 'Essen',
              url: 'https://www.lieferando.de/en/order-takeaway-essen',
            },
            {
              text: "Dortmund",
              url: 'https://www.lieferando.de/en/order-takeaway-dortmund'
            },
            {
              text: 'Stuttgart',
              url: 'https://www.lieferando.de/en/order-takeaway-stuttgart'
            },
            {
              text: 'Düsseldorf',
              url: 'https://www.lieferando.de/en/order-takeaway-duesseldorf'
            },
            {
              text: 'Bremen',
              url: 'https://www.lieferando.de/en/order-takeaway-bremen-bremen'
            },
            {
              text: 'Hannover',
              url: 'https://www.lieferando.de/en/order-takeaway-hannover'
            },
            {
              text: 'Leipzig',
              url: 'https://www.lieferando.de/en/order-takeaway-leipzig',
            },
            {
              text: "Dresden",
              url: 'https://www.lieferando.de/en/order-takeaway-dresden'
            },
          ]
        },
        {
          colTitle: 'Chains',
          subLinks: [
            {
              text: "McDonald's",
              url: 'https://www.lieferando.de/en/mcdonalds'
            },
            {
              text: 'Burger King',
              url: 'https://www.lieferando.de/en/burger-king'
            },
            {
              text: 'Call a Pizza',
              url: 'https://www.lieferando.de/en/call-a-pizza',
            },
            {
              text: 'Royal Donuts',
              url: 'https://www.lieferando.de/en/royal-donuts',
            },
            {
              text: 'KFC',
              url: 'https://www.lieferando.de/en/kfc'
            },
            {
              text: 'Subway',
              url: 'https://www.lieferando.de/en/subway'
            },
            {
              text: 'Wonder Waffel',
              url: 'https://www.lieferando.de/en/wonder-waffel'
            },
            {
              text: "Domino's Pizza",
              url: 'https://www.lieferando.de/en/dominos'
            },

            {
              text: "L'Osteria",
              url: 'https://www.lieferando.de/en/l-osteria',
            },
            {
              text: 'Dunkin Donuts',
              url: 'https://www.lieferando.de/en/dunkin-donuts'
            },
            {
              text: 'Cigköftem',
              url: 'https://www.lieferando.de/en/cigkoeftem'
            },
            {
              text: 'burgerme',
              url: 'https://www.lieferando.de/en/burgerme'
            },
            {
              text: 'Hans im Glück',
              url: 'https://www.lieferando.de/en/hans-im-glueck',
            },
            {
              text: "Starbucks",
              url: 'https://www.lieferando.de/en/starbucks'
            },
            {
              text: 'Pizza Hut',
              url: 'https://www.lieferando.de/en/pizza-hut'
            },
            {
              text: 'More chains...',
              url: 'https://www.lieferando.de/en/chains',
            },
          ]
        },
        {
          colTitle: 'New places',
          subLinks: [
            {
              text: "Lokmahouse, Bochum",
              url: 'https://www.lieferando.de/en/menu/lokmahouse'
            },
            {
              text: 'Glemstal Taverna Janni & Güllo, Ditzingen',
              url: 'https://www.lieferando.de/en/menu/restaurant-ditzingen'
            },
            {
              text: 'Trattoria Futtitinni, Kiel',
              url: 'https://www.lieferando.de/en/menu/trattoria-fottitinni'
            },
            {
              text: "Pizzeria Milano, Achern",
              url: 'https://www.lieferando.de/en/menu/pizzeria-milano-achern'
            },
            {
              text: "Domian Restaurant, Berlin",
              url: 'https://www.lieferando.de/en/menu/domian-restaurant'
            },
            {
              text: 'Mr.Döner Stühlinger, Freiburg im Breisgau',
              url: 'https://www.lieferando.de/en/menu/mrdoener'
            },
            {
              text: 'CAVA Restaurant|Ресторант КАВА, София',
              url: 'https://www.takeaway.com/bg-en/menu/cava-restaurantrestorant-kava-1'
            },
            {
              text: 'Restaurant Kroatica, Nürnberg',
              url: 'https://www.lieferando.de/en/menu/restaurant-kroatica'
            },
            {
              text: 'Bollywood.RE, Recklinghausen',
              url: 'https://www.lieferando.de/en/menu/bollywoodre-recklinghausen'
            },
            {
              text: 'Dönabude, Ingersheim',
              url: 'https://www.lieferando.de/en/menu/donabude'
            },
            {
              text: 'Yasmin Pizza&Burger, Dresden',
              url: 'https://www.lieferando.de/en/menu/yasmin-pizzaburger',
            }
          ]
        },
        {
          colTitle: 'Regions',
          subLinks: [
            {
              text: "Baden-Württemberg",
              url: 'https://www.lieferando.de/en/order-takeaway-baden-wuerttemberg'
            },
            {
              text: 'Bayern',
              url: 'https://www.lieferando.de/en/order-takeaway-bayern'
            },
            {
              text: 'Berlin',
              url: 'https://www.lieferando.de/en/order-takeaway-berlin'
            },
            {
              text: "Brandenburg",
              url: 'https://www.lieferando.de/en/order-takeaway-brandenburg'
            },
            {
              text: "Bremen",
              url: 'https://www.lieferando.de/en/order-takeaway-bremen'
            },
            {
              text: 'Hamburg',
              url: 'https://www.lieferando.de/en/order-takeaway-hamburg'
            },
            {
              text: 'Hessen',
              url: 'https://www.lieferando.de/en/order-takeaway-hessen'
            },
            {
              text: 'Mecklenburg-Vorpommern',
              url: 'https://www.lieferando.de/en/order-takeaway-mecklenburg-vorpommern'
            },
            {
              text: 'Niedersachsen',
              url: 'https://www.lieferando.de/en/order-takeaway-niedersachsen'
            },
            {
              text: 'Nordrhein-Westfalen',
              url: 'https://www.lieferando.de/en/order-takeaway-nordrhein-westfalen'
            },
            {
              text: 'Rheinland-Pfalz',
              url: 'https://www.lieferando.de/en/order-takeaway-rheinland-pfalz'
            },
            {
              text: 'Saarland',
              url: 'https://www.lieferando.de/en/order-takeaway-saarland'
            },
            {
              text: 'Sachsen',
              url: 'https://www.lieferando.de/en/order-takeaway-sachsen'
            },
            {
              text: 'Sachsen-Anhalt',
              url: 'https://www.lieferando.de/en/order-takeaway-sachsen-anhalt'
            },
            {
              text: 'Schleswig-Holstein',
              url: 'https://www.lieferando.de/en/order-takeaway-schleswig-holstein',
            },
            {
              text: "Thüringen",
              url: 'https://www.lieferando.de/en/order-takeaway-thueringen'
            },
          ]
        },
      ]
    },
    faqs: [
      {
        question: 'Who’s starring in the new Just Eat ad?',
        answer: 'Pop icon, Katy Perry.'
      },
    ],
    hero: {
      logo: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/logos/dss_lieferando_de.png',
      main: 'Christina Aguilera and Latto',
      sub: 'Just Eat brand campaign 2023',
      img: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/christina-latto.png',
    },
    about: {
      title: 'About the campaign',
      text: "We are back with another fresh campaign.\n\nCreated in conjunction with agency McCann London, our latest ad combines Latto's hip-hop energy with Christina Aguilera's operatic range of ease. The result? An unexpected visual and musical delight, a perfect embodiment of the surprisingly wide range of flavors you'll find at Lieferando.",
      img: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/xtina-wave.gif',
    },
    video: {
      title: 'Music video: Did Somebody Say Lieferando',
      id: 'https://www.youtube.com/embed/ag-QEn7ms_E?si=CVN0LC7fFv3ES44A',
    },
    lyrics: {
      title: 'Lyrics of “Hör ich da Lieferando” ft. Christina Aguilera and Latto',
      lyrics: `Are you ready for something new?

      Did Somebody Say Just Eat
      
      So, you think there's
      only burgers and fries
      
      As if: anything goes
      ""
      With endless choices""
      
      Oh, yeah, the app can do so much more
      than only fast food & co
      
      Switching styles, like opera to rap, yo
      
      Yummy
      
      And not just restaurants on the agenda
      
      Groceries, too, look at that!
      
      Ok, time for indulgence at its best
      
      What do you fancy, bro?
      How about a juicy taco?
      
      Pad Thai, that's so good
      
      Gyoza on the side, well fried,
      because we are picky, absolutely!
      
      Breakfast or lunch, babe?
      Dinner or brunch?
      
      Want some fine food?
      Lieferando delivers for all occasions
      
      A cool guy
      brings the best bao buns
      
      Then coffee, extra strong
      Will be super fun
      
      Licking ice-cream, checking fashion
      What's next?
      
      Nonstop sushi train, I'm going all out
      
      When you are as cool as me
      what can you do?
      
      Hör ich da Lieferando`,
      img: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/christina-lyrics.png',
    },
    food: {
      title: 'These treats play a role in the new campaign starring Christina Aguilera and Latto',
      intro: 'What do you fancy? Here you can find everything that appears in the commercial and that you can order from Lieferando:*',
      list: [
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature1_tunapoke.png',
          title: 'Tuna poke bowl',
          link: 'https://www.lieferando.de/en/order-poke-bowl',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature2_foccacia.png',
          title: 'Focaccia sandwich',
          link: 'https://www.lieferando.de/en/order-sandwiches',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature3_thaisalad.png',
          title: 'Thai salad',
          link: 'https://www.lieferando.de/en/order-thai-food',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature4_groceries.png',
          title: 'Groceries',
          link: 'https://www.lieferando.de/en/order-groceries',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature5_tacos.png',
          title: 'Tacos',
          link: 'https://www.lieferando.de/en/order-mexican-food',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature6_pizza.png',
          title: 'Pizza',
          link: 'https://www.lieferando.de/en/order-american-style-pizza',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature7_turkishmezze.png',
          title: 'Turkish mezze',
          link: 'https://www.lieferando.de/en/order-turkisch-food',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature8_macaroons.png',
          title: 'Macaroons',
          link: 'https://www.lieferando.de/en/order-desserts',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature10_avotoast.png',
          title: 'Avocado & poached egg on toast',
          link: 'https://www.lieferando.de/en/order-breakfast',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature11_acaibowl.png',
          title: 'Acai bowl',
          link: 'https://www.lieferando.de/en/order-breakfast',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature13_yogurt.png',
          title: 'Yogurt & granola',
          link: 'https://www.lieferando.de/en/order-breakfast',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature14_pastries.png',
          title: 'Selection of pastries',
          link: 'https://www.lieferando.de/en/order-desserts',
        },
      ],
      disclaimer: '*All supply is dependent on location.',
    },
  },
  de_de: {
    navbar: {
      logo: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/logos/logo_at.svg',
      country_toggle: [
        {
          logo: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/country-svg/de.svg',
          url: 'https://www.lieferando.de/entdecke/hoer-ich-da-lieferando/',
          text: 'Deutsch'
        },
        {
          logo: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/country-svg/gb.svg',
          url: 'https://www.lieferando.de/en/explore/did-somebody-say/',
          text: 'English'
        },
      ],
      language: 'Sprache',
    },
    button: {
      text: 'Go home',
      url: 'https://www.lieferando.de'
    },
    footer: {
      logo: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/logos/dss_footer_lieferando.png',
      main_link: 'https://www.lieferando.de',
      links: [
        {
          text: 'Ein Restaurant empfehlen',
          url: 'https://www.lieferando.de/empfehlen'
        },
        {
          text: 'Ein Restaurant anmelden',
          url: 'https://www.lieferando.de/anmelden'
        },
        {
          text: 'Jobs',
          url: 'https://careers.justeattakeaway.com/de/de?_gl=1*1twziwp*_ga*MDE4NWJiMTBmMzQ5MDAyMmYyNDFkYjRmZDdjMjA1MDc1MDAzMDA2ZDAwYjNi*_ga_4PH28YDTSD*MTcwMDA0NzI3OC41Mi4xLjE3MDAwNjEzMzAuMC4wLjA.',
        },
        {
          text: 'AGB',
          url: 'https://www.lieferando.de/agb'
        },
        {
          text: 'Datenschutzerklärung',
          url: 'https://www.lieferando.de/privacy-statement',
        },
        {
          text: 'Impressum',
          url: 'https://www.lieferando.de/impressum'
        },
        {
          text: 'Verwendung von Cookies',
          url: 'https://www.lieferando.de/cookiestatement'
        },
        {
          text: 'Bug Bounty',
          url: 'https://www.lieferando.de/bugbounty',
        },
        {
          text: 'Ethik-Hotline',
          url: 'https://app.convercent.com/de-de/LandingPage/d8e86634-ec59-ec11-a985-000d3ab9f296'
        },
      ],
      copyright: '2023 Lieferando.de',
      mainNavFirst: {
        colTitle: 'Lieferando.de',
        subLinks: [
          {
            text: 'Lieferando for Business',
            url: 'https://www.lieferando.de/business',
          },
          {
            text: 'Kundenservice',
            url: 'https://www.lieferando.de/kundenservice'
          },
          {
            text: 'Ein Geschäft empfehlen',
            url: 'https://www.lieferando.de/empfehlen'
          },
          {
            text: 'Ein Geschäft anmelden',
            url: 'https://www.lieferando.de/anmelden',
          },
          {
            text: 'Werde Affiliate-Partner',
            url: 'https://www.lieferando.de/affiliate',
          },
          {
            text: 'Fahrer*in werden',
            url: 'https://www.lieferando.de/fahrer?utm_source=mainsite&utm_medium=referral&utm_content=footer'
          },
          {
            text: 'Jobs',
            url: 'https://careers.justeattakeaway.com/de/de?_gl=1*4a1puc*_ga*MDE4NWJiMTBmMzQ5MDAyMmYyNDFkYjRmZDdjMjA1MDc1MDAzMDA2ZDAwYjNi*_ga_4PH28YDTSD*MTcwMDA0NzI3OC41Mi4xLjE3MDAwNjEzMzAuMC4wLjA.'
          },
          {
            text: 'Stempelkarten',
            url: 'https://www.lieferando.de/#stempelkarten'
          },
          {
            text: 'Points',
            url: 'https://www.lieferando.de/punkte',
          },
          {
            text: 'AGB',
            url: 'https://www.lieferando.de/agb'
          },
          {
            text: 'Datenschutzerklärung',
            url: 'https://www.lieferando.de/privacy-statement',
          },
          {
            text: 'Impressum',
            url: 'https://www.lieferando.de/impressum',
          },
          {
            text: 'Verwendung von Cookies',
            url: 'https://www.lieferando.de/cookiestatement'
          },
          {
            text: 'Newsroom',
            url: 'https://www.justeattakeaway.com/newsroom/de-DE/?_gl=1*1c8674y*_ga*MDE4NWJiMTBmMzQ5MDAyMmYyNDFkYjRmZDdjMjA1MDc1MDAzMDA2ZDAwYjNi*_ga_4PH28YDTSD*MTcwMDA0NzI3OC41Mi4xLjE3MDAwNjEzMzAuMC4wLjA.',
          }
        ],
      },
      mainNavSecond: [
        {
          colTitle: 'International',
          subLinks: [
            {
              text: 'Investor Relations',
              url: 'https://www.justeattakeaway.com/',
            },
            {
              text: '10bis',
              url: 'https://www.10bis.co.il',
            },
            {
              text: 'Bistro.sk',
              url: 'https://www.bistro.sk',
            },
            {
              text: 'Grubhub',
              url: 'https://www.grubhub.com',
            },
            {
              text: 'Just Eat - Switzerland',
              url: 'https://www.just-eat.ch',
            },
            {
              text: 'Just Eat - France',
              url: 'https://www.just-eat.fr',
            },
            {
              text: 'Just Eat - Denmark',
              url: 'https://www.just-eat.dk',
            },
            {
              text: 'Just Eat - Spain',
              url: 'https://www.just-eat.es',
            },
            {
              text: 'Just Eat - United Kingdom',
              url: 'https://www.just-eat.co.uk',
            },
            {
              text: 'Just Eat - Ireland',
              url: 'https://www.just-eat.ie',
            },
            {
              text: 'Just Eat - Italy',
              url: 'https://www.justeat.it',
            },
            {
              text: 'Lieferando.at',
              url: 'https://www.lieferando.at',
            },
            {
              text: 'Lieferando.de',
              url: 'https://www.lieferando.de',
            },
            {
              text: 'Menulog - Australia',
              url: 'https://www.menulog.com.au',
            },
            {
              text: 'Menulog - New Zealand',
              url: 'https://www.menulog.co.nz',
            },
            {
              text: 'Pyszne.pl',
              url: 'https://www.pyszne.pl',
            },
            {
              text: 'SkipTheDishes',
              url: 'https://www.skipthedishes.com',
            },
            {
              text: 'Takeaway.com - Belgium',
              url: 'https://www.takeaway.com/be',
            },
            {
              text: 'Takeaway.com - Luxembourg',
              url: 'https://www.takeaway.com/lu',
            },
            {
              text: 'Takeaway.com - Bulgaria',
              url: 'https://www.takeaway.com/bg',
            },
            {
              text: 'Thuisbezorgd.nl',
              url: 'https://www.thuisbezorgd.nl',
            }
          ],
        },
        {          
          colTitle: 'Essen',
          subLinks: [
            {
              text: 'Essen',
              url: 'https://www.lieferando.de/lieferservice',
            },
            {
              text: 'Pizza',
              url: 'https://www.lieferando.de/pizza-bestellen',
            },
            {
              text: 'Chinesisch',
              url: 'https://www.lieferando.de/chinesisch-bestellen',
            },
            {
              text: 'Vegan',
              url: 'https://www.lieferando.de/vegan-essen-bestellen',
            },
            {
              text: 'Sushi',
              url: 'https://www.lieferando.de/sushi-bestellen',
            },
            {
              text: 'Indisch',
              url: 'https://www.lieferando.de/indisch-bestellen',
            },
            {
              text: 'Döner',
              url: 'https://www.lieferando.de/doener-bestellen',
            },
            {
              text: 'Burger',
              url: 'https://www.lieferando.de/burger-bestellen',
            },
            {
              text: 'Eiscreme',
              url: 'https://www.lieferando.de/eiscreme-bestellen',
            },
            {
              text: 'Asiatisch',
              url: 'https://www.lieferando.de/asiatisch-essen-bestellen',
            },
            {
              text: 'Lebensmittel',
              url: 'https://www.lieferando.de/lebensmittel-bestellen',
            },
            {
              text: 'Mehr Essen bestellen...',
              url: 'https://www.lieferando.de/mehr-essen-bestellen',
            }
          ],
        },
        {          
          colTitle: 'Entdecke',
          subLinks: [
            {
              text: 'Essen bestellen',
              url: 'https://www.lieferando.de/essen-bestellen',
            },
            {
              text: 'Essen zum mitnehmen',
              url: 'https://www.lieferando.de/essen-zum-mitnehmen',
            },
            {
              text: 'Foodwiki',
              url: 'https://www.lieferando.de/foodwiki/',
            },
            {
              text: 'Gutscheine',
              url: 'https://www.lieferando.de/geschenkkarten',
            },
            {
              text: 'Coca-Cola MealDeals',
              url: 'https://www.lieferando.de/deals/coca-cola/',
            },
            {
              text: 'Geschenkkarten',
              url: 'https://www.lieferando.de/geschenkkarten/',
            },
            {
              text: 'Nachhaltigkeit',
              url: 'https://www.lieferando.de/nachhaltigkeit/',
            },
            {
              text: 'Lieferando Report 2022',
              url: 'https://www.lieferando.de/deals/der-lieferando-report-2022/',
            },
            {
              text: 'Schmeckt wie Sommer',
              url: 'https://www.lieferando.de/deals/schmeckt-wie-sommer/',
            },
            {
              text: 'Werde Fahrer:in in Düsseldorf',
              url: 'https://www.lieferando.de/fahrer/dusseldorf',
            },
            {
              text: 'Werde Fahrer:in in Stuttgart',
              url: 'https://www.lieferando.de/fahrer/stuttgart',
            },
            {
              text: 'Werde Fahrer:in in Köln',
              url: 'https://www.lieferando.de/fahrer/koln',
            },
            {
              text: 'Werde Fahrer:in in Hannover',
              url: 'https://www.lieferando.de/fahrer/hannover',
            },
            {
              text: 'Werde Fahrer:in in Frankfurt',
              url: 'https://www.lieferando.de/fahrer/frankfurt',
            },
            {
              text: 'Werde Fahrer:in in München',
              url: 'https://www.lieferando.de/fahrer/munchen',
            },
            {
              text: 'Werde Fahrer:in in Berlin',
              url: 'https://www.lieferando.de/fahrer/berlin',
            },
            {
              text: 'Werde Fahrer:in in Hamburg',
              url: 'https://www.lieferando.de/fahrer/hamburg',
            },
            {
              text: 'Gewinne UEFA Europa League® Tickets',
              url: 'https://www.lieferando.de/deals/deals-zum-spiel-deals/',
            },
          ],
        },
        {
          colTitle: 'Städte',
          subLinks: [
            {
              text: 'Berlin',
              url: 'https://www.lieferando.de/lieferservice-berlin-berlin'
            },
            {
              text: 'Hamburg',
              url: 'https://www.lieferando.de/lieferservice-hamburg-hamburg'
            },
            {
              text: 'München',
              url: 'https://www.lieferando.de/lieferservice-muenchen'
            },
            {
              text: 'Frankfurt',
              url: 'https://www.lieferando.de/lieferservice-frankfurt'
            },
            {
              text: 'Essen',
              url: 'https://www.lieferando.de/lieferservice-essen',
            },
            {
              text: "Dortmund",
              url: 'https://www.lieferando.de/lieferservice-dortmund'
            },
            {
              text: 'Stuttgart',
              url: 'https://www.lieferando.de/lieferservice-stuttgart'
            },
            {
              text: 'Düsseldorf',
              url: 'https://www.lieferando.de/lieferservice-duesseldorf'
            },
            {
              text: 'Bremen',
              url: 'https://www.lieferando.de/lieferservice-bremen-bremen'
            },
            {
              text: 'Hannover',
              url: 'https://www.lieferando.de/lieferservice-hannover'
            },
            {
              text: 'Leipzig',
              url: 'https://www.lieferando.de/lieferservice-leipzig',
            },
            {
              text: "Dresden",
              url: 'https://www.lieferando.de/lieferservice-dresden'
            },
          ]
        },
        {
          colTitle: 'Ketten',
          subLinks: [
            {
              text: "McDonald's",
              url: 'https://www.lieferando.de/mcdonalds'
            },
            {
              text: 'Burger King',
              url: 'https://www.lieferando.de/burger-king'
            },
            {
              text: 'Call a Pizza',
              url: 'https://www.lieferando.de/call-a-pizza',
            },
            {
              text: 'Royal Donuts',
              url: 'https://www.lieferando.de/royal-donuts',
            },
            {
              text: 'KFC',
              url: 'https://www.lieferando.de/kfc'
            },
            {
              text: 'Subway',
              url: 'https://www.lieferando.de/subway'
            },
            {
              text: 'Wonder Waffel',
              url: 'https://www.lieferando.de/wonder-waffel'
            },
            {
              text: "Domino's Pizza",
              url: 'https://www.lieferando.de/dominos'
            },

            {
              text: "L'Osteria",
              url: 'https://www.lieferando.de/l-osteria',
            },
            {
              text: 'Dunkin Donuts',
              url: 'https://www.lieferando.de/dunkin-donuts'
            },
            {
              text: 'Cigköftem',
              url: 'https://www.lieferando.de/cigkoeftem'
            },
            {
              text: 'burgerme',
              url: 'https://www.lieferando.de/burgerme'
            },
            {
              text: 'Hans im Glück',
              url: 'https://www.lieferando.de/hans-im-glueck',
            },
            {
              text: "Starbucks",
              url: 'https://www.lieferando.de/starbucks'
            },
            {
              text: 'Pizza Hut',
              url: 'https://www.lieferando.de/pizza-hut'
            },
            {
              text: 'Mehr Restaurantketten...',
              url: 'https://www.lieferando.de/ketten',
            },
          ]
        },
        {
          colTitle: 'Neue Partner',
          subLinks: [
            {
              text: "Big Pizza, Viernheim",
              url: 'https://www.lieferando.de/speisekarte/big-pizza-viernheim-1'
            },
            {
              text: 'Mamma Mia, Wittislingen',
              url: 'https://www.lieferando.de/speisekarte/mama-mia-1'
            },
            {
              text: 'Bistro Knappenkeller, Ludwigshafen am Rhein',
              url: 'https://www.lieferando.de/speisekarte/bistro-knappenkeller'
            },
            {
              text: "60 seconds to Napoli, Bonn",
              url: 'https://www.lieferando.de/speisekarte/60-seconds-to-napoli-bonn'
            },
            {
              text: "Mö Mandeln, Hamburg",
              url: 'https://www.lieferando.de/speisekarte/mo-mandeln'
            },
            {
              text: 'Pret a Manger, Düsseldorf',
              url: 'https://www.lieferando.de/speisekarte/pret-a-manger-dusseldorf'
            },
            {
              text: "Jo's Curry die Pommesbude, Krefeld",
              url: 'https://www.lieferando.de/speisekarte/jos-curry'
            },
            {
              text: 'Pizzeria La Cantina, Bad Iburg',
              url: 'https://www.lieferando.de/speisekarte/pizzeria-la-cantina-bad-iburg-2'
            },
            {
              text: 'Tabilo Sindelfingen, Sindelfingen',
              url: 'https://www.lieferando.de/speisekarte/tabilo-sindelfingen'
            },
            {
              text: 'Wöllstädter Döner und Pizzahaus, Wöllstadt',
              url: 'https://www.lieferando.de/speisekarte/wollstadter-doner-und-pizzahaus-wollstadt-1'
            },
          ]
        },
        {
          colTitle: 'Regionen',
          subLinks: [
            {
              text: "Baden-Württemberg",
              url: 'https://www.lieferando.de/lieferservice-baden-wuerttemberg'
            },
            {
              text: 'Bayern',
              url: 'https://www.lieferando.de/lieferservice-bayern'
            },
            {
              text: 'Berlin',
              url: 'https://www.lieferando.de/lieferservice-berlin'
            },
            {
              text: "Brandenburg",
              url: 'https://www.lieferando.de/lieferservice-brandenburg'
            },
            {
              text: "Bremen",
              url: 'https://www.lieferando.de/lieferservice-bremen'
            },
            {
              text: 'Hamburg',
              url: 'https://www.lieferando.de/lieferservice-hamburg'
            },
            {
              text: 'Hessen',
              url: 'https://www.lieferando.de/lieferservice-hessen'
            },
            {
              text: 'Mecklenburg-Vorpommern',
              url: 'https://www.lieferando.de/lieferservice-mecklenburg-vorpommern'
            },
            {
              text: 'Niedersachsen',
              url: 'https://www.lieferando.de/lieferservice-niedersachsen'
            },
            {
              text: 'Nordrhein-Westfalen',
              url: 'https://www.lieferando.de/lieferservice-nordrhein-westfalen'
            },
            {
              text: 'Rheinland-Pfalz',
              url: 'https://www.lieferando.de/lieferservice-rheinland-pfalz'
            },
            {
              text: 'Saarland',
              url: 'https://www.lieferando.de/lieferservice-saarland'
            },
            {
              text: 'Sachsen',
              url: 'https://www.lieferando.de/lieferservice-sachsen'
            },
            {
              text: 'Sachsen-Anhalt',
              url: 'https://www.lieferando.de/lieferservice-sachsen-anhalt'
            },
            {
              text: 'Schleswig-Holstein',
              url: 'https://www.lieferando.de/lieferservice-schleswig-holstein',
            },
            {
              text: "Thüringen",
              url: 'https://www.lieferando.de/lieferservice-thueringen'
            },
          ]
        },
      ]
    },
    faqs: [
      {
        question: 'Who’s starring in the new Just Eat ad?',
        answer: 'Pop icon, Katy Perry.'
      },
    ],
    hero: {
      logo: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/logos/dss_lieferando_de.png',
      main: 'Christina Aguilera und Latto',
      sub: 'Lieferando Markenkampagne 2023',
      img: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/christina-latto.png',
    },
    about: {
      title: 'Über die Kampagne',
      text: "Wir sind mit einer neuen Kampagne am Start.\n\nUnsere aktuelle Kampagne ist in Zusammenarbeit mit McCann London entstanden und verbindet die Hip-Hop-Energie von Latto mit Christina Aguileras genialer Interpretation von Operngesang. Das Ergebnis? Ein unerwarteter visueller und musikalischer Genuss, der die vielseitige Auswahl an Geschmacksrichtungen, die es bei Lieferando gibt, perfekt verkörpert.",
      img: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/xtina-wave.gif',
    },
    video: {
      title: 'Musikvideo: Hör ich da Lieferando',
      id: 'https://www.youtube.com/embed/ag-QEn7ms_E?si=CVN0LC7fFv3ES44A',
    },
    lyrics: {
      title: 'Songtext von „Hör ich da Lieferando“ ft. Christina Aguilera und Latto',
      lyrics: `Seid ihr bereit für was Neues?

      Hör ich da Lieferando
      
      So, du denkst, es gibt 
      nur Burger und Pommes
      
      Von wegen: Alles geht
      Mit Auswahl ohne Ende
      
      Oh, yeah, die App kann so viel mehr
      Als nur Fast Food und Co.
      
      Wechselt Styles, wie Oper zu Rap, yo
      
      Yummy
      
      Und nicht nur Restaurants im Programm
      
      Auch Lebensmittel, schau an!
      
      Ok, Zeit für Gönnung vom Feinsten
      
      Worauf hast du Lust, Bro?
      Wie wär's mit nem saftigen Taco?
      
      Pad Thai, das ist so gut
      
      Dazu Gyoza, gut gebraten,
      Denn wählerisch sind wir, absolut!
      
      Frühstück oder Lunch, Babe?
      Dinner oder Brunch?
      
      Du willst schick essen?
      Lieferando liefert zu allen Anlässen
      
      Ein cooler Typ
      Bringt die besten Bao Buns
      
      Dann Kaffee, extra stark
      Das wird super Fun
      
      Eis schlecken, Fashion checken
      Was ist als Nächstes dran?
      
      Nonstop Sushi-Zug, ich lass es krachen
      
      Wenn man so cool ist wie ich,
      was willste machen?
      
      Hör ich da Lieferando`,
      img: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/christina-lyrics.png',
    },
    food: {
      title: 'Diese Leckerbissen spielen in der neuen Kampagne mit Christina Aguilera und Latto eine Rolle',
      intro: 'Worauf hast du Lust? Hier findest du alles, was in dem Werbespot vorkommt und du bei Lieferando bestellen kannst:*',
      list: [
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature1_tunapoke.png',
          title: 'Poke Bowl mit Thunfisch',
          link: 'https://www.lieferando.de/poke-bowl-bestellen',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature2_foccacia.png',
          title: 'Focaccia-Sandwich',
          link: 'https://www.lieferando.de/sandwiches-bestellen',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature3_thaisalad.png',
          title: 'Pad Thai',
          link: 'https://www.lieferando.de/thailaendisch-bestellen',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature4_groceries.png',
          title: 'Lebensmittel',
          link: 'https://www.lieferando.de/lebensmittel-bestellen',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature5_tacos.png',
          title: 'Tacos',
          link: 'https://www.lieferando.de/mexikanisch-bestellen',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature6_pizza.png',
          title: 'Pizza',
          link: 'https://www.lieferando.de/amerikanische-pizza-bestellen',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature7_turkishmezze.png',
          title: 'Türkische Vorspeisen',
          link: 'https://www.lieferando.de/tuerkisches-essen-bestellen',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature8_macaroons.png',
          title: 'Macarons',
          link: 'https://www.lieferando.de/desserts-bestellen',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature10_avotoast.png',
          title: 'Toast mit Avocado und pochiertem Ei',
          link: 'https://www.lieferando.de/fruehstueck-bestellen',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature11_acaibowl.png',
          title: 'Açaí Bowl',
          link: 'https://www.lieferando.de/fruehstueck-bestellen',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature13_yogurt.png',
          title: 'Joghurt mit Granola',
          link: 'https://www.lieferando.de/fruehstueck-bestellen',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature14_pastries.png',
          title: 'Verschiedenes Gebäck',
          link: 'https://www.lieferando.de/desserts-bestellen',
        },
      ],
      disclaimer: '*Alle Angebote sind ortsabhängig.',
    },
  },
  ch_en: {
    navbar: {
      logo: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/logos/logo_je.svg',
      language: 'Language',
      country_toggle: [
        {
          logo: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/country-svg/gb.svg',
          url: 'https://www.just-eat.ch/en/deals/did-somebody-say/',
          text: 'English'
        },
        {
          logo: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/country-svg/ch.svg',
          url: 'https://www.just-eat.ch/deals/daenksch-au-grad-a-just-eat/',
          text: 'Deutsch'
        },
        {
          logo: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/country-svg/fr.svg',
          url: 'https://www.just-eat.ch/fr/deals/quel-quun-a-dit/',
          text: 'Français'
        },
      ]
    },
    button: {
      text: 'Go home',
      url: 'https://www.just-eat.ch/en'
    },
    footer: {
      logo: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say-vue/static/img/logos/dss_logo_footer.png',
      main_link: 'https://www.just-eat.ch/en',
      links: [
        {
          text: 'Recommend a restaurant',
          url: 'https://www.just-eat.ch/en/recommend',
        },
        {
          text: 'Sign up a restaurant',
          url: 'https://www.just-eat.ch/en/partner/signup/',
        },
        {
          text: 'Jobs',
          url: 'https://careers.justeattakeaway.com/global/en?_gl=1*x2yul1*_ga*MDE4YmNkZjdkNzExMDAwZjMzZmY5NzEwMmEyZDA1MDc1MDAyMzA2ZDAwOWRj*_ga_4PH28YDTSD*MTcwMDA0MjQzMS4yLjEuMTcwMDA0MzU5My4wLjAuMA..',
        },
        {
          text: 'Terms of use',
          url: 'https://www.just-eat.ch/en/terms-of-use',
        },
        {
          text: 'Privacy statement',
          url: 'https://www.just-eat.ch/en/privacy-statement',
        },
        {
          text: 'Colophon',
          url: 'https://www.just-eat.ch/en/colofon',
        },
        {
          text: 'Cookie statement',
          url: 'https://www.just-eat.ch/en/cookiestatement',
        },
        {
          text: 'Bug Bounty',
          url: 'https://www.just-eat.ch/en/bugbounty',
        },
        {
          text: 'Ethics Hotline',
          url: 'https://app.convercent.com/en-gb/LandingPage/d8e86634-ec59-ec11-a985-000d3ab9f296',
        }
      ],
      copyright: '2023 Just Eat',
      mainNavFirst: {
        colTitle: 'Just Eat',
        subLinks: [
        {
          text: 'Just Eat for Business',
          url: 'https://www.just-eat.ch/en/business/',
        },
        {
          text: 'Customer service',
          url: 'https://www.just-eat.ch/en/customerservice',
        },
        {
          text: 'Recommend a business',
          url: 'https://www.just-eat.ch/en/recommend',
        },
        {
          text: 'List your business',
          url: 'https://www.just-eat.ch/en/partner/signup/',
        },
        {
          text: 'Become an affiliate',
          url: 'https://www.just-eat.ch/en/affiliate',
        },
        {
          text: 'Become a courier',
          url: 'https://www.just-eat.ch/en/courier?utm_source=mainsite&utm_medium=referral&utm_content=footer'
        },
        {
          text: 'Jobs',
          url: 'https://careers.justeattakeaway.com/global/en?_gl=1*x2yul1*_ga*MDE4YmNkZjdkNzExMDAwZjMzZmY5NzEwMmEyZDA1MDc1MDAyMzA2ZDAwOWRj*_ga_4PH28YDTSD*MTcwMDA0MjQzMS4yLjEuMTcwMDA0MzU5My4wLjAuMA..',
        },
        {
          text: 'StampCard',
          url: 'https://www.just-eat.ch/en#stamp-cards',
        },
        {
          text: 'Points',
          url: 'https://www.just-eat.ch/en/points',
        },
        {
          text: 'Terms of use',
          url: 'https://www.just-eat.ch/en/terms-of-use',
        },
        {
          text: 'Privacy statement',
          url: 'https://www.just-eat.ch/en/privacy-statement',
        },
        {
          text: 'Colophon',
          url: 'https://www.just-eat.ch/en/colofon',
        },
        {
          text: 'Cookie statement',
          url: 'https://www.just-eat.ch/en/cookiestatement',
        }
        ],
      },
      mainNavSecond: [
        {
          colTitle: 'International',
          subLinks: [
            {
              text: 'Investor Relations',
              url: 'https://www.justeattakeaway.com/',
            },
            {
              text: '10bis',
              url: 'https://www.10bis.co.il',
            },
            {
              text: 'Bistro.sk',
              url: 'https://www.bistro.sk',
            },
            {
              text: 'Grubhub',
              url: 'https://www.grubhub.com',
            },
            {
              text: 'Just Eat - Switzerland',
              url: 'https://www.just-eat.ch',
            },
            {
              text: 'Just Eat - France',
              url: 'https://www.just-eat.fr',
            },
            {
              text: 'Just Eat - Denmark',
              url: 'https://www.just-eat.dk',
            },
            {
              text: 'Just Eat - Spain',
              url: 'https://www.just-eat.es',
            },
            {
              text: 'Just Eat - United Kingdom',
              url: 'https://www.just-eat.co.uk',
            },
            {
              text: 'Just Eat - Ireland',
              url: 'https://www.just-eat.ie',
            },
            {
              text: 'Just Eat - Italy',
              url: 'https://www.justeat.it',
            },
            {
              text: 'Lieferando.at',
              url: 'https://www.lieferando.at',
            },
            {
              text: 'Lieferando.de',
              url: 'https://www.lieferando.de',
            },
            {
              text: 'Menulog - Australia',
              url: 'https://www.menulog.com.au',
            },
            {
              text: 'Menulog - New Zealand',
              url: 'https://www.menulog.co.nz',
            },
            {
              text: 'Pyszne.pl',
              url: 'https://www.pyszne.pl',
            },
            {
              text: 'SkipTheDishes',
              url: 'https://www.skipthedishes.com',
            },
            {
              text: 'Takeaway.com - Belgium',
              url: 'https://www.takeaway.com/be',
            },
            {
              text: 'Takeaway.com - Luxembourg',
              url: 'https://www.takeaway.com/lu',
            },
            {
              text: 'Takeaway.com - Bulgaria',
              url: 'https://www.takeaway.com/bg',
            },
            {
              text: 'Thuisbezorgd.nl',
              url: 'https://www.thuisbezorgd.nl',
            }
          ],
        },
        {          
          colTitle: 'Food',
          subLinks: [
            {
              text: 'Food',
              url: 'https://www.just-eat.ch/en/order-takeaway',
            },
            {
              text: 'Pizza',
              url: 'https://www.just-eat.ch/en/order-pizza',
            },
            {
              text: 'Chinese',
              url: 'https://www.just-eat.ch/en/order-chinese-food',
            },
            {
              text: 'Breakfast',
              url: 'https://www.just-eat.ch/en/order-breakfast',
            },
            {
              text: 'Sushi',
              url: 'https://www.just-eat.ch/en/order-sushi',
            },
            {
              text: 'Burgers',
              url: 'https://www.just-eat.ch/en/order-burger',
            },
            {
              text: 'Vegan',
              url: 'https://www.just-eat.ch/en/order-vegan',
            },
            {
              text: 'Groceries',
              url: 'https://www.just-eat.ch/en/order-groceries',
            },
            {
              text: 'Asian',
              url: 'https://www.just-eat.ch/en/order-asian',
            },
            {
              text: 'Indian',
              url: 'https://www.just-eat.ch/en/order-indian-food',
            },
            {
              text: 'Tacos',
              url: 'https://www.just-eat.ch/en/order-tacos',
            },
            {
              text: 'Kebab',
              url: 'https://www.just-eat.ch/en/order-kebab',
            },
            {
              text: 'Order more food..',
              url: 'https://www.just-eat.ch/en/order-more-food',
            }
          ],
        },
        {          
          colTitle: 'Explore',
          subLinks: [
            {
              text: 'Giftcards',
              url: 'https://www.just-eat.ch/en/gift-cards/',
            },
            {
              text: 'Sustainability',
              url: 'https://www.just-eat.ch/en/sustainability/',
            },
            {
              text: 'Free Delivery Geneva',
              url: 'https://www.just-eat.ch/en/deals/free-delivery-geneva/',
            },
            {
              text: 'Taste the Summer',
              url: 'https://www.just-eat.ch/en/deals/tastethesummer/',
            },
            {
              text: 'Become a courier in Zürich',
              url: 'https://www.just-eat.ch/en/courier/zurich/',
            },
            {
              text: 'Become a courier in Basel',
              url: 'https://www.just-eat.ch/en/courier/basel/',
            },
            {
              text: 'Become a courier in Geneva',
              url: 'https://www.just-eat.ch/en/courier/geneva/',
            },
            {
              text: 'Become a courier in Lausanne',
              url: 'https://www.just-eat.ch/en/courier/lausanne/',
            },
            {
              text: 'Become a courier in Bern',
              url: 'https://www.just-eat.ch/en/courier/bern/',
            },
            {
              text: 'Become a courier in St. Gallen',
              url: 'https://www.just-eat.ch/en/courier/st-gallen/',
            },
            {
              text: 'Become a courier in Winterthur',
              url: 'https://www.just-eat.ch/en/courier/winterthur/',
            },
          ],
        },
        {
          colTitle: 'Cities',
          subLinks: [
            {
              text: 'Zürich',
              url: 'https://www.just-eat.ch/en/order-takeaway-zuerich-zuerich'
            },
            {
              text: 'Genf',
              url: 'https://www.just-eat.ch/en/order-takeaway-genf-genf'
            },
            {
              text: 'Basel',
              url: 'https://www.just-eat.ch/en/order-takeaway-basel'
            },
            {
              text: 'Bern',
              url: 'https://www.just-eat.ch/en/order-takeaway-bern'
            },
            {
              text: 'Lausanne',
              url: 'https://www.just-eat.ch/en/order-takeaway-lausanne'
            },
            {
              text: 'Winterthur',
              url: 'https://www.just-eat.ch/en/order-takeaway-winterthur',
            },
            {
              text: 'Luzern',
              url: 'https://www.just-eat.ch/en/order-takeaway-luzern-luzern'
            },
            {
              text: 'St-Gallen',
              url: 'https://www.just-eat.ch/en/order-takeaway-sankt-gallen'
            },
            {
              text: 'Freiburg',
              url: 'https://www.just-eat.ch/en/order-takeaway-fribourg'
            },
            {
              text: 'Biel',
              url: 'https://www.just-eat.ch/en/order-takeaway-biel',
            },
            {
              text: 'Neuchatel',
              url: 'https://www.just-eat.ch/en/order-takeaway-neuchatel',
            },
            {
              text: 'Zug',
              url: 'https://www.just-eat.ch/en/order-takeaway-zug',
            },
            {
              text: 'View all locations',
              url: 'https://www.just-eat.co.uk/takeaway/'
            }
          ]
        },
        {
          colTitle: 'Chains',
          subLinks: [
            {
              text: "McDonald's",
              url: 'https://www.just-eat.ch/en/mcdonalds',
            },
            {
              text: 'Burger King',
              url: 'https://www.just-eat.ch/en/burger-king'
            },
            {
              text: "Domino’s Pizza",
              url: 'https://www.just-eat.ch/en/dominos-pizza'
            },
            {
              text: 'KFC',
              url: 'https://www.just-eat.ch/en/kfc'
            },
            {
              text: 'Subway',
              url: 'https://www.just-eat.ch/en/subway'
            },
            {
              text: 'Dunkin Donuts',
              url: 'https://www.just-eat.ch/en/dunkin-donuts'
            },
            {
              text: "Giga Taco’s",
              url: 'https://www.just-eat.ch/en/giga-tacos'
            },
            {
              text: 'Peking Garden',
              url: 'https://www.just-eat.ch/en/peking-garden',
            },
            {
              text: 'Poulet Hochgenuss',
              url: 'https://www.just-eat.ch/en/poulet-hochgenuss'
            },
            {
              text: 'Napule',
              url: 'https://www.just-eat.ch/en/napule'
            },
            {
              text: 'Telepizza',
              url: 'https://www.just-eat.ch/en/'
            },
            {
              text: 'Brezelkönig',
              url: 'https://www.just-eat.ch/en/brezelkoenig'
            },
            {
              text: 'dean & david',
              url: 'https://www.just-eat.ch/en/dean-and-david',
            },
            {
              text: 'More chains…',
              url: 'https://www.just-eat.ch/en/chains'
            }
          ]
        },
        {          
          colTitle: 'New places',
          subLinks: [
            {
              text: 'Best Burger und Kebab, Benglen',
              url: 'https://www.just-eat.ch/en/menu/bash-burger-und-kebab',
            },
            {
              text: 'Mali Pizza Kebap Fislisbach, Fislisbach',
              url: 'https://www.just-eat.ch/en/menu/mali-pizza-kebap-fislisbach',
            },
            {
              text: 'Tibet Stubä - Wollishofen, Zürich',
              url: 'https://www.just-eat.ch/en/menu/tibet-stuba-wollishofen',
            },
            {
              text: 'Pizza La Regina Zurich, Zürich',
              url: 'https://www.just-eat.ch/en/menu/pizza-la-regina-zurich',
            },
            {
              text: 'PIRO. Pizzeria Napoletana, Dornach',
              url: 'https://www.just-eat.ch/en/menu/pizza-la-regina-zurich',
            },
            {
              text: 'Easy Shop, Biel',
              url: 'https://www.just-eat.ch/en/menu/easy-shop',
            },
            {
              text: 'Doppiozero, Le Lignon',
              url: 'https://www.just-eat.ch/en/menu/doppiozero-geneve',
            },
            {
              text: 'Rafa Food, Lausanne',
              url: 'https://www.just-eat.ch/en/menu/rafa-food',
            },
            {
              text: 'HappyBuns© Uetikon am See, Uetikon am See',
              url: 'https://www.just-eat.ch/en/menu/happybuns-uetikon-am-see',
            }
          ],
        },
        {         
          colTitle: 'Regions',
          subLinks: [
            {
              text: 'Aargau',
              url: 'https://www.just-eat.ch/en/order-takeaway-aargau',
            },
            {
              text: 'Appenzell Ausserrhoden',
              url: 'https://www.just-eat.ch/en/order-takeaway-appenzell-Ausserrhoden',
            },
            {
              text: 'Appenzell Innerrhoden',
              url: 'https://www.just-eat.ch/en/order-takeaway-appenzell-innerrhoden',
            },
            {
              text: 'Basel-Landschaft',
              url: 'https://www.just-eat.ch/en/order-takeaway-basel-landschaft',
            },
            {
              text: 'Basel-Stadt',
              url: 'https://www.just-eat.ch/en/order-takeaway-basel-stadt',
            },
            {
              text: 'Bern',
              url: 'https://www.just-eat.ch/en/order-takeaway-bern',
            },
            {
              text: 'Freiburg',
              url: 'https://www.just-eat.ch/en/order-takeaway-freiburg',
            },
            {
              text: 'Genf',
              url: 'https://www.just-eat.ch/en/order-takeaway-genf',
            },
            {
              text: 'Glarus',
              url: 'https://www.just-eat.ch/en/order-takeaway-glarus',
            },
            {
              text: 'Graubünden',
              url: 'https://www.just-eat.ch/en/order-takeaway-graubuenden',
            },
            {
              text: 'Jura',
              url: 'https://www.just-eat.ch/en/order-takeaway-jura',
            },
            {
              text: 'Liechtenstein',
              url: 'https://www.just-eat.ch/en/order-takeaway-liechtenstein',
            },
            {
              text: 'Luzern',
              url: 'https://www.just-eat.ch/en/order-takeaway-luzern',
            },
            {
              text: 'Neuenburg',
              url: 'https://www.just-eat.ch/en/order-takeaway-neuenburg',
            },
            {
              text: 'Nidwalden',
              url: 'https://www.just-eat.ch/en/order-takeaway-nidwalden',
            },
            {
              text: 'Obwalden',
              url: 'https://www.just-eat.ch/en/order-takeaway-obwalden',
            },
            {
              text: 'Sankt Gallen',
              url: 'https://www.just-eat.ch/en/order-takeaway-sankt-gallen',
            },
            {
              text: 'Schaffhausen',
              url: 'https://www.just-eat.ch/en/order-takeaway-schaffhausen',
            },
            {
              text: 'Schwyz',
              url: 'https://www.just-eat.ch/en/order-takeaway-schwyz',
            },
            {
              text: 'Solothurn',
              url: 'https://www.just-eat.ch/en/order-takeaway-solothurn',
            },
            {
              text: 'Thurgau',
              url: 'https://www.just-eat.ch/en/order-takeaway-thurgau',
            },
            {
              text: 'Ticino',
              url: 'https://www.just-eat.ch/en/order-takeaway-ticino',
            },
            {
              text: 'Uri',
              url: 'https://www.just-eat.ch/en',
            },
            {
              text: 'Waadt',
              url: 'https://www.just-eat.ch/en/order-takeaway-waadt',
            },
            {
              text: 'Zug',
              url: 'https://www.just-eat.ch/en/order-takeaway-zug',
            },
            {
              text: 'Zürich',
              url: 'https://www.just-eat.ch/en/order-takeaway-zuerich',
            },
          ],
        },
      ]
    },
    hero: {
      logo: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say-vue/static/img/logos/dss_logo.svg',
      main: 'Christina Aguilera and Latto',
      sub: 'Just Eat brand campaign 2023',
      img: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/christina-latto.png',
    },
    about: {
      title: 'About the campaign',
      text: 'We’re back once again with a fresh campaign.\n\nTogether with McCann London, our latest creation brings together Latto’s hip-hop energy with Christina Aguilera’s effortless take on opera. The result? An unexpected visual and musical delight that perfectly embodies the surprising range of flavours you’ll find at Just Eat.',
      img: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/xtina-wave.gif',
    },
    video: {
      title: 'Full Did Somebody Say music video',
      id: 'https://www.youtube.com/embed/mJqG8YIPRh0?si=NeImEgV5TvOhZ12Z',
    },
    lyrics: {
      title: 'Did Somebody Say ft. Christina Aguilera and Latto full lyrics',
      lyrics: `La la la la la la laaa								
      Did Somebody Say Just Eat			
      
      Oh you thought it was just burgers and fries 
      They got more flavours than you tasted or you heard in your life			
      Ooh - this is what the app do, it ain’t only fast food 				
      Switching  styles like opera to rap too 	
      
      Yummy
      And it ain’t only restaurants any more
      We can go bananas at the grocery store 
      Yum yum yum yum			
      
      I’m a bad girl but my takeout badder
      What you need dude? I can cop a taco platter
      Thai rice sticky icky
      Gyoza on the side fried right cos we kinda picky 
      
      Breakfast or lunch hun, dinner or brunch 
      Wanna find the finest dining? I got a hunch
      And some hot tall dude’s bringing buns to the ballroom 
      
      Got me a strong coffee, let’s get it on papi
      Ice-cream with my magazine, who can stop me 				
      
      And my sushi train is on loop 		
      When you this slick, whatchoo gon’ do?
      
      Laaaaaaaaaa						
      Did Somebody Say Just Eat	`,
      img: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/christina-lyrics.png',
    },
    food: {
      title: 'Dishes and services featured in the new campaign featuring Christina Aguilera and Latto',
      intro: 'Something tasty caught your eye? Here are all the featured dishes from the ad available on our platform.',
      list: [
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature1_tunapoke.pnƒg',
          title: 'Poké Bowl',
          link: 'https://www.just-eat.ch/poke-bowl-bestellen',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature2_foccacia.png',
          title: 'Focaccia sandwich',
          link: 'https://www.just-eat.ch/en/order-italian-food',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature3_thaisalad.png',
          title: 'Thai salad',
          link: 'https://www.just-eat.ch/en/order-thai-food',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature4_groceries.png',
          title: 'Various groceries',
          link: '’https://www.just-eat.ch/en/order-groceries',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature5_tacos.png',
          title: 'Tacos',
          link: 'https://www.just-eat.ch/en/order-tacos',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature6_pizza.png',
          title: 'Pizza',
          link: 'https://www.just-eat.ch/en/order-pizza',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature7_turkishmezze.png',
          title: 'Oriental mezze',
          link: 'https://www.just-eat.ch/en/order-oriental',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature8_macaroons.png',
          title: 'Macarons / Luxemburgerli',
          link: 'https://www.just-eat.ch/en/order-baked-goods',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature9_waffles.png',
          title: 'Waffles',
          link: 'https://www.just-eat.ch/en/order-breakfast',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature10_avotoast.png',
          title: 'Avocado & Egg Toast',
          link: 'https://www.just-eat.ch/en/order-breakfast',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature11_acaibowl.png',
          title: 'Acai Bowl',
          link: 'https://www.just-eat.ch/en/order-breakfast',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature12_fruitsalad.png',
          title: 'Fruit Salad',
          link: 'https://www.just-eat.ch/en/order-breakfast',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature13_yogurt.png',
          title: 'Yoghurt & Muesli',
          link: 'https://www.just-eat.ch/en/order-breakfast',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature14_pastries.png',
          title: 'Selection of pastries',
          link: 'https://www.just-eat.ch/en/order-desserts',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature15_icedcoffee.png',
          title: 'Ice Coffee',
          link: 'https://www.just-eat.ch/en/order-coffee',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature16_smoothie.png',
          title: 'Smoothies',
          link: 'https://www.just-eat.ch/en/order-smoothies',
        },
      ],
      disclaimer: '*All supply is dependent on location.'
    },
    word: {
      title: 'A word from those involved with the new Just Eat advert',
      words: [
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say-vue/static/img/profile_image_xtina.png',
          name: 'Christina Aguilera',
          role: 'Talent',
          quote: 'I had so much fun combining different music styles alongside my girl Latto for Just Eat Takeaway. With non-stop laughter and love, we had the best time bringing this project to life. It was clear while shooting long days that JET is the much needed one-stop-shop for meals and grocery needs.',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say-vue/static/img/profile_image_latto.png',
          name: 'Latto',
          role: 'Talent',
          quote: 'When I heard about the opportunity to work with Just Eat I was actually abroad on tour using the app! It was a no-brainer for me especially with the iconic Christina Aguilera involved. I had so much fun with this collab and have loved seeing it come to life.'
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say-vue/static/img/profile_image_suso.png',
          name: 'Susan O’Brien',
          role: 'VP Global Brand at Just Eat',
          quote: "We’re back with a new hip-hopera twist of our Did Somebody Say brand platform, this time with double the star power. Christina Aguilera and Latto are the perfect duo to bring something extraordinary to our customers, and this new mix doesn’t disappoint, just like the food choices you can get on Just Eat. Whether you're craving your favourite takeaway or looking for everyday groceries, we’re here everyday to deliver it all and more.",
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say-vue/static/img/profile_image_dept.png',
          name: 'Dept',
          role: 'Digital Agency',
          quote: 'Jeff Bowerman, Executive Creative Director at DEPT® said: “Our role at DEPT® was taking this great idea and making it sing in social and digital spaces. Tapping into cultural and native platform insights to speak to audiences wherever they spend their time, whilst making sure we deliver key brand messages like range and delivery in stand-out creative ways.”'
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say-vue/static/img/profile_logo_weber.png',
          name: 'Joanna Pritchard',
          role: 'Executive Vice President at Weber Shandwick',
          quote: 'The opportunity to explore the unexpected collision of hip hop and opera from an earned media perspective has been a fantastic challenge. We’ve loved developing earned ideas for the markets to adapt and implement locally that reflect joy in the unexpected and the surprising breadth of cuisines now available through Just Eat Takeaway.com.',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say-vue/static/img/profile_logo_radicalmedia.png',
          name: 'Ben Schneider',
          role: 'SVP and Executive Producer at RadicalMedia London',
          quote: 'Producing this years campaign alongside our partners at McCann London and JET Global has been a pleasure and privilege. The genre-crossing music - and a yet unseen artist pairing JET has curated presented a unique opportunity for our director Dave Meyers to bring the campaign to life.',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say-vue/static/img/profile_image_mccann.png',
          name: 'Rob Webster and Alexei Berwitz',
          role: 'Creative Directors at McCann London',
          quote: "Surprising is the greatest and perhaps the hardest brief of all. But thanks to our ever-courageous clients and the amazing efforts of all involved, this campaign hits unexpected notes at every turn – hip-hop and opera isn't an obvious musical combination, but it's one that really, really works.",
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say-vue/static/img/profile_image_talentrepublic.png',
          name: 'Talent Republic',
          role: 'Talent agency',
          quote: "The hip-hop meets opera creative certainly made this ‘Did Somebody Say’ campaign the most challenging from a Talent perspective. There are very few iconic female singers who can reach the vocal levels that Christina soared to, and with such a distinctive delivery. In Latto we found the perfect counterpoint as someone who has bags of attitude and energy, and who is fast becoming one of the most sought-after rappers around.\n\nIn terms of audience reach and recognition, pairing such an established Artist with such a fresh, new talent was key. The fact they embodied the characteristics of ‘rap’ and ‘opera’  they were asked to convey in their respective roles, and looked so stunning together, was the icing on the cake for us",
        }
      ]
    }
  },
  ch_de: {
    navbar: {
      logo: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/logos/logo_je.svg',
      language: 'Sprache',
      country_toggle: [
        {
          logo: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/country-svg/ch.svg',
          url: 'https://www.just-eat.ch/deals/daenksch-au-grad-a-just-eat/',
          text: 'Deutsch'
        },
        {
          logo: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/country-svg/gb.svg',
          url: 'https://www.just-eat.ch/en/deals/did-somebody-say/',
          text: 'English'
        },
        {
          logo: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/country-svg/fr.svg',
          url: 'https://www.just-eat.ch/fr/deals/quel-quun-a-dit/',
          text: 'Français'
        },
      ]
    },
    button: {
      text: 'Go home',
      url: 'https://www.just-eat.ch/'
    },
    footer: {
      logo: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/logos/dss_footer_swiss_de.png',
      main_link: 'https://www.just-eat.ch/',
      links: [
        {
          text: 'Ein Restaurant empfehlen',
          url: 'https://www.just-eat.ch/empfehlen',
        },
        {
          text: 'Ein Restaurant anmelden',
          url: 'https://www.just-eat.ch/partner/anmelden/',
        },
        {
          text: 'Jobs',
          url: 'https://careers.justeattakeaway.com/de/de?_gl=1*1ly5dki*_ga*MDE4YmNkZjdkNzExMDAwZjMzZmY5NzEwMmEyZDA1MDc1MDAyMzA2ZDAwOWRj*_ga_4PH28YDTSD*MTY5OTk2NzY1NS4xLjEuMTY5OTk4MTI1NC4wLjAuMA..',
        },
        {
          text: 'AGB',
          url: 'https://www.just-eat.ch/agb',
        },
        {
          text: 'Datenschutzerklärung',
          url: 'https://www.just-eat.ch/privacy-statement',
        },
        {
          text: 'Impressum',
          url: 'https://www.just-eat.ch/impressum',
        },
        {
          text: 'Verwendung von Cookies',
          url: 'https://www.just-eat.ch/cookiestatement',
        },
        {
          text: 'Bug Bounty',
          url: 'https://www.just-eat.ch/bugbounty',
        },
        {
          text: 'Ethik-Hotline',
          url: 'https://app.convercent.com/de-de/LandingPage/d8e86634-ec59-ec11-a985-000d3ab9f296',
        }
      ],
      copyright: '2023 Just Eat',
      mainNavFirst: {
        colTitle: 'Just Eat',
        subLinks: [
        {
          text: 'Just Eat for Business',
          url: 'https://www.just-eat.ch/business/',
        },
        {
          text: 'Kundenservice',
          url: 'https://www.just-eat.ch/kundenservice',
        },
        {
          text: 'Ein Geschäft empfehlen',
          url: 'https://www.just-eat.ch/empfehlen',
        },
        {
          text: 'Ein Geschäft anmelden',
          url: 'https://www.just-eat.ch/partner/anmelden/',
        },
        {
          text: 'Werde Affiliate-Partner',
          url: 'https://www.just-eat.ch/affiliate',
        },
        {
          text: 'Fahren*in werden',
          url: 'https://www.just-eat.ch/fahrer?utm_source=mainsite&utm_medium=referral&utm_content=footer',
        },
        {
          text: 'Jobs',
          url: 'https://careers.justeattakeaway.com/de/de?_gl=1*1ly5dki*_ga*MDE4YmNkZjdkNzExMDAwZjMzZmY5NzEwMmEyZDA1MDc1MDAyMzA2ZDAwOWRj*_ga_4PH28YDTSD*MTY5OTk2NzY1NS4xLjEuMTY5OTk4MTI1NC4wLjAuMA..',
        },
        {
          text: 'Stempelkarten',
          url: 'https://www.just-eat.ch/#stempelkarten',
        },
        {
          text: 'Points',
          url: 'https://www.just-eat.ch/points',
        },
        {
          text: 'AGB',
          url: 'https://www.just-eat.ch/agb',
        },
        {
          text: 'Datenschutzerklärung',
          url: 'https://www.just-eat.ch/privacy-statement',
        },
        {
          text: 'Impressum',
          url: 'https://www.just-eat.ch/impressum',
        },
        {
          text: 'Verwendung von Cookies',
          url: 'https://www.just-eat.ch/cookiestatement',
        }
        ],
      },
      mainNavSecond: [
        {
          colTitle: 'International',
          subLinks: [
            {
              text: 'Investor Relations',
              url: 'https://www.justeattakeaway.com/',
            },
            {
              text: '10bis',
              url: 'https://www.10bis.co.il',
            },
            {
              text: 'Bistro.sk',
              url: 'https://www.bistro.sk',
            },
            {
              text: 'Grubhub',
              url: 'https://www.grubhub.com',
            },
            {
              text: 'Just Eat - Switzerland',
              url: 'https://www.just-eat.ch',
            },
            {
              text: 'Just Eat - France',
              url: 'https://www.just-eat.fr',
            },
            {
              text: 'Just Eat - Denmark',
              url: 'https://www.just-eat.dk',
            },
            {
              text: 'Just Eat - Spain',
              url: 'https://www.just-eat.es',
            },
            {
              text: 'Just Eat - United Kingdom',
              url: 'https://www.just-eat.co.uk',
            },
            {
              text: 'Just Eat - Ireland',
              url: 'https://www.just-eat.ie',
            },
            {
              text: 'Just Eat - Italy',
              url: 'https://www.justeat.it',
            },
            {
              text: 'Lieferando.at',
              url: 'https://www.lieferando.at',
            },
            {
              text: 'Lieferando.de',
              url: 'https://www.lieferando.de',
            },
            {
              text: 'Menulog - Australia',
              url: 'https://www.menulog.com.au',
            },
            {
              text: 'Menulog - New Zealand',
              url: 'https://www.menulog.co.nz',
            },
            {
              text: 'Pyszne.pl',
              url: 'https://www.pyszne.pl',
            },
            {
              text: 'SkipTheDishes',
              url: 'https://www.skipthedishes.com',
            },
            {
              text: 'Takeaway.com - Belgium',
              url: 'https://www.takeaway.com/be',
            },
            {
              text: 'Takeaway.com - Luxembourg',
              url: 'https://www.takeaway.com/lu',
            },
            {
              text: 'Takeaway.com - Bulgaria',
              url: 'https://www.takeaway.com/bg',
            },
            {
              text: 'Thuisbezorgd.nl',
              url: 'https://www.thuisbezorgd.nl',
            }
          ],
        },
        {          
          colTitle: 'Essen',
          subLinks: [
            {
              text: 'Essen',
              url: 'https://www.just-eat.ch/lieferservice',
            },
            {
              text: 'Pizza',
              url: 'https://www.just-eat.ch/pizza-bestellen',
            },
            {
              text: 'Chinesisch',
              url: 'https://www.just-eat.ch/chinesisch-bestellen',
            },
            {
              text: 'Frühstuck',
              url: 'https://www.just-eat.ch/fruehstueck-bestellen',
            },
            {
              text: 'Sushi',
              url: 'https://www.just-eat.ch/sushi-bestellen',
            },
            {
              text: 'Burger',
              url: 'https://www.just-eat.ch/burger-bestellen',
            },
            {
              text: 'Vegan',
              url: 'https://www.just-eat.ch/vegan-essen-bestellen',
            },
            {
              text: 'Lebensmittel',
              url: 'https://www.just-eat.ch/lebensmittel-bestellen',
            },
            {
              text: 'Asiatisch',
              url: 'https://www.just-eat.ch/asiatisch-essen-bestellen',
            },
            {
              text: 'Indisch',
              url: 'https://www.just-eat.ch/indisch-bestellen',
            },
            {
              text: 'Tacos',
              url: 'https://www.just-eat.ch/tacos-bestellen',
            },
            {
              text: 'Kebab',
              url: 'https://www.just-eat.ch/kebab-bestellen',
            },
            {
              text: 'Mehr Essen bestellen..',
              url: 'https://www.just-eat.ch/mehr-essen-bestellen',
            }
          ],
        },
        {          
          colTitle: 'Entdecke',
          subLinks: [
            {
              text: 'Essen bestellen',
              url: 'https://www.just-eat.ch/essen-bestellen',
            },
            {
              text: 'Essen zum mitnehmen',
              url: 'https://www.just-eat.ch/essen-zum-mitnehmen',
            },
            {
              text: 'Foodwiki',
              url: 'https://www.just-eat.ch/foodwiki/',
            },
            {
              text: 'Geschenkkarten',
              url: 'https://www.just-eat.ch/geschenkkarten/',
            },
            {
              text: 'Nachkaltigkeit',
              url: 'https://www.just-eat.ch/nachhaltigkeit/',
            },
            {
              text: 'Newsroom',
              url: 'https://www.justeattakeaway.com/newsroom/de-CH-CH/?_gl=1*e3dvfg*_ga*MDE4YmNkZjdkNzExMDAwZjMzZmY5NzEwMmEyZDA1MDc1MDAyMzA2ZDAwOWRj*_ga_4PH28YDTSD*MTY5OTk2NzY1NS4xLjEuMTY5OTk4MjMzOC4wLjAuMA..',
            },
            {
              text: 'Just Eat Reports',
              url: 'https://www.just-eat.ch/deals/so-bestellte-die-schweiz-2022/',
            },
            {
              text: 'Beste Restaurants Schweiz',
              url: 'https://www.just-eat.ch/deals/stadt/',
            },
            {
              text: 'Gratis Lieferung Zürich',
              url: 'https://www.just-eat.ch/deals/gratis-lieferung-zurich/',
            },
            {
              text: 'Schmeckt wie Sommer',
              url: 'https://www.just-eat.ch/deals/schmeckt-wie-sommer/',
            },
            {
              text: 'Werde Fahrer:in in Zürich',
              url: 'https://www.just-eat.ch/fahrer/zurich',
            },
            {
              text: 'Werde Fahrer:in in Basel',
              url: 'https://www.just-eat.ch/fahrer/basel',
            },
            {
              text: 'Werde Fahrer:in in Genf',
              url: 'https://www.just-eat.ch/fahrer/genf',
            },
            {
              text: 'Werde Fahrer:in in Lausanne',
              url: 'https://www.just-eat.ch/fahrer/lausanne',
            },
            {
              text: 'Werde Fahrer:in in Bern',
              url: 'https://www.just-eat.ch/fahrer/bern',
            },
            {
              text: 'Werde Fahrer:in in St. Gallen',
              url: 'https://www.just-eat.ch/fahrer/st-gallen',
            },
            {
              text: 'Werde Fahrer:in in Winterthur',
              url: 'https://www.just-eat.ch/fahrer/winterthur',
            },
          ],
        },
        {
          colTitle: 'Städte',
          subLinks: [
            {
              text: 'Zürich',
              url: 'https://www.just-eat.ch/lieferservice-zuerich-zuerich',
            },
            {
              text: 'Genf',
              url: 'https://www.just-eat.ch/lieferservice-genf-genf',
            },
            {
              text: 'Basel',
              url: 'https://www.just-eat.ch/lieferservice-basel',
            },
            {
              text: 'Bern',
              url: 'https://www.just-eat.ch/lieferservice-bern-bern',
            },
            {
              text: 'Lausanne',
              url: 'https://www.just-eat.ch/lieferservice-lausanne',
            },
            {
              text: 'Winterthur',
              url: 'https://www.just-eat.ch/lieferservice-winterthur',
            },
            {
              text: 'Luzern',
              url: 'https://www.just-eat.ch/lieferservice-luzern-luzern',
            },
            {
              text: 'St. Gallen',
              url: 'https://www.just-eat.ch/lieferservice-sankt-gallen',
            },
            {
              text: 'Lugano',
              url: 'https://www.just-eat.ch/lieferservice-lugano',
            },
            {
              text: 'Freiburg',
              url: 'https://www.just-eat.ch/lieferservice-fribourg',
            },
            {
              text: 'Biel',
              url: 'https://www.just-eat.ch/lieferservice-biel',
            },
            {
              text: 'Neuchatel',
              url: 'https://www.just-eat.ch/lieferservice-neuchatel',
            },
            {
              text: 'Zug',
              url: 'https://www.just-eat.ch/lieferservice-zug',
            },
          ]
        },
        {
          colTitle: 'Ketten',
          subLinks: [
            {
              text: "McDonald's",
              url: 'https://www.just-eat.ch/mcdonalds',
            },
            {
              text: 'Burger King',
              url: 'https://www.just-eat.ch/burger-king'
            },
            {
              text: "Domino’s Pizza",
              url: 'https://www.just-eat.ch/dominos-pizza'
            },
            {
              text: 'KFC',
              url: 'https://www.just-eat.ch/kfc'
            },
            {
              text: 'Subway',
              url: 'https://www.just-eat.ch/subway'
            },
            {
              text: 'Dunkin Donuts',
              url: 'https://www.just-eat.ch/dunkin-donuts'
            },
            {
              text: 'Giga Taco’s',
              url: 'https://www.just-eat.ch/giga-tacos'
            },
            {
              text: 'Peking Garden',
              url: 'https://www.just-eat.ch/peking-garden',
            },
            {
              text: 'Poulet Hochgenuss',
              url: 'https://www.just-eat.ch/poulet-hochgenuss'
            },
            {
              text: 'Napule',
              url: 'https://www.just-eat.ch/napule'
            },
            {
              text: 'Telepizza',
              url: 'https://www.just-eat.ch/'
            },
            {
              text: 'Brezelkönig',
              url: 'https://www.just-eat.ch/brezelkoeni',
            },
            {
              text: 'dean & david',
              url: 'https://www.just-eat.ch/dean-and-david',
            },
            {
              text: 'Mehr Restaurantketten…',
              url: 'https://www.just-eat.ch/ketten'
            }
          ]
        },
        {          
          colTitle: 'New places',
          subLinks: [
            {
              text: 'Best Burger und Kebab, Benglen',
              url: 'https://www.just-eat.ch/speisekarte/bash-burger-und-kebab',
            },
            {
              text: 'Mali Pizza Kebap Fislisbach, Fislisbach',
              url: 'https://www.just-eat.ch/speisekarte/mali-pizza-kebap-fislisbach',
            },
            {
              text: 'Tibet Stubä - Wollishofen, Zürich',
              url: 'https://www.just-eat.ch/speisekarte/tibet-stuba-wollishofen',
            },
            {
              text: 'Pizza La Regina Zurich, Zürich',
              url: 'https://www.just-eat.ch/speisekarte/pizza-la-regina-zurich',
            },
            {
              text: 'PIRO. Pizzeria Napoletana, Dornach',
              url: 'https://www.just-eat.ch/speisekarte/pizza-la-regina-zurich',
            },
            {
              text: 'Easy Shop, Biel',
              url: 'https://www.just-eat.ch/speisekarte/easy-shop',
            },
            {
              text: 'Doppiozero, Le Lignon',
              url: 'https://www.just-eat.ch/speisekarte/doppiozero-geneve',
            },
            {
              text: 'Rafa Food, Lausanne',
              url: 'https://www.just-eat.ch/speisekarte/rafa-food',
            },
            {
              text: 'HappyBuns© Uetikon am See, Uetikon am See',
              url: 'https://www.just-eat.ch/speisekarte/happybuns-uetikon-am-see',
            }
          ],
        },
        {         
          colTitle: 'Regions',
          subLinks: [
            {
              text: 'Aargau',
              url: 'https://www.just-eat.ch/lieferservice-aargau',
            },
            {
              text: 'Appenzell Ausserrhoden',
              url: 'https://www.just-eat.ch/lieferservice-appenzell-Ausserrhoden',
            },
            {
              text: 'Appenzell Innerrhoden',
              url: 'https://www.just-eat.ch/lieferservice-appenzell-innerrhoden',
            },
            {
              text: 'Basel-Landschaft',
              url: 'https://www.just-eat.ch/lieferservice-basel-landschaft',
            },
            {
              text: 'Basel-Stadt',
              url: 'https://www.just-eat.ch/lieferservice-takeaway-basel-stadt',
            },
            {
              text: 'Bern',
              url: 'https://www.just-eat.ch/lieferservice-takeaway-bern',
            },
            {
              text: 'Freiburg',
              url: 'https://www.just-eat.ch/lieferservice-takeaway-freiburg',
            },
            {
              text: 'Genf',
              url: 'https://www.just-eat.ch/lieferservice-takeaway-genf',
            },
            {
              text: 'Glarus',
              url: 'https://www.just-eat.ch/lieferservice-takeaway-glarus',
            },
            {
              text: 'Graubünden',
              url: 'https://www.just-eat.ch/lieferservice-takeaway-graubuenden',
            },
            {
              text: 'Jura',
              url: 'https://www.just-eat.ch/lieferservice-takeaway-jura',
            },
            {
              text: 'Liechtenstein',
              url: 'https://www.just-eat.ch/lieferservice-takeaway-liechtenstein',
            },
            {
              text: 'Luzern',
              url: 'https://www.just-eat.ch/lieferservice-takeaway-luzern',
            },
            {
              text: 'Neuenburg',
              url: 'https://www.just-eat.ch/lieferservice-takeaway-neuenburg',
            },
            {
              text: 'Nidwalden',
              url: 'https://www.just-eat.ch/lieferservice-takeaway-nidwalden',
            },
            {
              text: 'Obwalden',
              url: 'https://www.just-eat.ch/lieferservice-takeaway-obwalden',
            },
            {
              text: 'Sankt Gallen',
              url: 'https://www.just-eat.ch/lieferservice-takeaway-sankt-gallen',
            },
            {
              text: 'Schaffhausen',
              url: 'https://www.just-eat.ch/lieferservice-takeaway-schaffhausen',
            },
            {
              text: 'Schwyz',
              url: 'https://www.just-eat.ch/lieferservice-takeaway-schwyz',
            },
            {
              text: 'Solothurn',
              url: 'https://www.just-eat.ch/lieferservice-takeaway-solothurn',
            },
            {
              text: 'Thurgau',
              url: 'https://www.just-eat.ch/lieferservice-takeaway-thurgau',
            },
            {
              text: 'Ticino',
              url: 'https://www.just-eat.ch/lieferservice-takeaway-ticino',
            },
            {
              text: 'Uri',
              url: 'https://www.just-eat.ch/',
            },
            {
              text: 'Waadt',
              url: 'https://www.just-eat.ch/lieferservice-takeaway-waadt',
            },
            {
              text: 'Zug',
              url: 'https://www.just-eat.ch/lieferservice-takeaway-zug',
            },
            {
              text: 'Zürich',
              url: 'https://www.just-eat.ch/lieferservice-takeaway-zuerich',
            },
          ],
        },
      ]
    },
    hero: {
      logo: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/logos/dss_jet_swiss_de.png',
      main: 'Christina Aguilera und Latto',
      sub: 'Just Eat Marketingkampagne 2023',
      img: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/christina-latto.png',
    },
    about: {
      title: 'Infos zur Kampagne',
      text: 'Wir sind mit einer neuen Kampagne am Start.\n\nSie ist in Zusammenarbeit mit McCann London entstanden und verbindet die Hip-Hop-Energie von Latto mit Christina Aguileras entspannter Interpretation von Operngesang. Das Ergebnis? Ein unerwarteter visueller und musikalischer Genuss, der die grosse Auswahl an vielseitigen Geschmacksrichtungen zeigt, die es bei Just Eat gibt.',
      img: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/xtina-wave.gif',
    },
    video: {
      title: 'Das Musikvideo',
      id: 'https://www.youtube.com/embed/kAXMHuNEWa8?si=UCzJRx-0WDiYM2mG',
    },
    lyrics: {
      title: 'Songtext zum "Dänksch au grad a Just Eat" Hit von Christina Aguilera und Latto',
      lyrics: `Alle ready für etwas Neues?
Dänksch au grad a Just Eat

Ach, du denkst, es gibt
nur Burger und Pommes

Aber die haben mehr Geschmäcker
Als du im Leben je genossen hast

Ja, die App hat viel mehr drauf
Als nur Fast Food und Co.

Wir wechseln ja auch von Oper zu Rap

Yummy

Neben Restaurants und feinen Lokalen

Liefern wir von Supermarktregalen

Bin ein böses Mädchen, unersättlich

Worauf hast du Lust?
Hier, ein Taco-Teller: Köstlich!

Thai-Reis, klebrig, klebrig

Dazu Gyoza, gut gebraten
Denn wir sind wählerisch

Ob Zmorge oder Zmittag
Znacht oder Brunch

Du willst das beste Essen?
Ich hab da so eine Fantasie

Von einem heissen Typen
Der bringt Bao Buns zum Dippen

Dann Kaffee, extra stark
Geht ab wie im Funpark

Glace schlecken und shoppen
Wer kann mich stoppen?

Und hier kommt Sushi auf Schienen

Wir sind so cool drauf
Wir geben niemals auf

Dänksch au grad a Just Eat`,
      img: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/christina-lyrics.png',
    },
    food: {
      title: 'Finde hier alle Gerichte, die im neuen Video von Christina Aguilera und Latto besungen werden',
      intro: 'Was hat dich gluschtig gemacht? Hier sind alle im Musikvideo vorkommenden Speisen und Getränke. Viele sind auf unserer Plattform bestellbar.*',
      list: [
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature1_tunapoke.pnƒg',
          title: 'Poké Bowl',
          link: 'https://www.just-eat.ch/poke-bowl-bestellen',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature2_foccacia.png',
          title: 'Focaccia-Sandwich',
          link: 'https://www.just-eat.ch/sandwiches-bestellen',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature3_thaisalad.png',
          title: 'Thailändisch',
          link: 'https://www.just-eat.ch/thailaendisch-bestellen'
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature4_groceries.png',
          title: 'Diverse Lebensmittel',
          link: 'https://www.just-eat.ch/lebensmittel-bestellen',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature5_tacos.png',
          title: 'Tacos',
          link: 'https://www.just-eat.ch/tacos-bestellen',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature6_pizza.png',
          title: 'Pizza',
          link: 'https://www.just-eat.ch/pizza-bestellen',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature7_turkishmezze.png',
          title: 'Orientalische Mezze',
          link: 'https://www.just-eat.ch/tuerkisches-essen-bestellen',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature8_macaroons.png',
          title: 'Macarons / Luxemburgerli',
          link: 'https://www.just-eat.ch/backwaren-bestellen',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature9_waffles.png',
          title: 'Waffeln',
          link: 'https://www.just-eat.ch/backwaren-bestellen',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature10_avotoast.png',
          title: 'Avocado & Ei Toast',
          link: 'https://www.just-eat.ch/fruehstueck-bestellen',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature11_acaibowl.png',
          title: 'Açai bowl',
          link: 'https://www.just-eat.ch/fruehstueck-bestellen',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature13_yogurt.png',
          title: 'Joghurt & Müesli',
          link: 'https://www.just-eat.ch/fruehstueck-bestellen',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature14_pastries.png',
          title: 'Desserts',
          link: 'https://www.just-eat.ch/backwaren-bestellen',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature15_icedcoffee.png',
          title: 'Eiskaffee',
          link: 'https://www.just-eat.ch/kaffee-bestellen',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature16_smoothie.png',
          title: 'Smoothie',
          link: 'https://www.just-eat.ch/smoothies-bestellen',
        },
      ],
      disclaimer: '*Das Angebot auf Just Eat ist ortsabhängig. Nicht alle Gerichte und Produkte sind in allen Regionen verfügbar.',
    },
  },
  ch_fr: {
    navbar: {
      logo: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/logos/logo_je.svg',
      language: 'Langue',
      country_toggle: [
        {
          logo: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/country-svg/fr.svg',
          url: 'https://www.just-eat.ch/fr/deals/quel-quun-a-dit/',
          text: 'Français'
        },
        {
          logo: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/country-svg/ch.svg',
          url: 'https://www.just-eat.ch/deals/daenksch-au-grad-a-just-eat/',
          text: 'Deutsch'
        },
        {
          logo: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/country-svg/gb.svg',
          url: 'https://www.just-eat.ch/en/deals/did-somebody-say/',
          text: 'English'
        },
      ]
    },
    button: {
      text: 'Go home',
      url: 'https://www.just-eat.ch/fr'
    },
    footer: {
      logo: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/logos/dss_footer_swiss_fr.png',
      main_link: 'https://www.just-eat.ch/fr',
      links: [
        {
          text: 'Recommander un restaurant',
          url: 'https://www.just-eat.ch/fr/recommander',
        },
        {
          text: 'Inscrire un restaurant',
          url: 'https://www.just-eat.ch/fr/partenaire/inscription/',
        },
        {
          text: 'Offres d’emploi',
          url: 'https://careers.justeattakeaway.com/fr/fr?_gl=1*n6fsfi*_ga*MDE4YmNkZjdkNzExMDAwZjMzZmY5NzEwMmEyZDA1MDc1MDAyMzA2ZDAwOWRj*_ga_4PH28YDTSD*MTcwMDA4MjkxOS4zLjEuMTcwMDA4NzAyOS4wLjAuMA..',
        },
        {
          text: 'Conditions d’utilisation',
          url: 'https://www.just-eat.ch/fr/conditions-d-utilisation',
        },
        {
          text: 'Déclaration de confidentialité',
          url: 'https://www.just-eat.ch/fr/privacy-statement',
        },
        {
          text: 'Mentions légales',
          url: 'https://www.just-eat.ch/fr/colofon',
        },
        {
          text: 'Cookie Statement',
          url: 'https://www.just-eat.ch/fr/cookiestatement',
        },
        {
          text: 'Bug Bounty',
          url: 'https://www.just-eat.ch/fr/bugbounty',
        },
        {
          text: 'Ligne d’alerte éthique',
          url: 'https://app.convercent.com/fr-fr/LandingPage/d8e86634-ec59-ec11-a985-000d3ab9f296',
        }
      ],
      copyright: '2023 Just Eat',
      mainNavFirst: {
        colTitle: 'Just Eat',
        subLinks: [
        {
          text: 'Just Eat for Business',
          url: 'https://www.just-eat.ch/fr/business/',
        },
        {
          text: 'Service Client',
          url: 'https://www.just-eat.ch/fr/service-clientele',
        },
        {
          text: 'Recommander un partenaire',
          url: 'https://www.just-eat.ch/fr/recommander',
        },
        {
          text: 'Inscrire votre partenaire',
          url: 'https://www.just-eat.ch/fr/partenaire/inscription/',
        },
        {
          text: 'Affiliez-vous !',
          url: 'https://www.just-eat.ch/fr/affiliate',
        },
        {
          text: 'Rejoignez nos livreurs',
          url: 'https://www.just-eat.ch/fr/livreur?utm_source=mainsite&utm_medium=referral&utm_content=footer',
        },
        {
          text: 'Offres d’emploi',
          url: 'https://careers.justeattakeaway.com/fr/fr?_gl=1*1jhb194*_ga*MDE4YmNkZjdkNzExMDAwZjMzZmY5NzEwMmEyZDA1MDc1MDAyMzA2ZDAwOWRj*_ga_4PH28YDTSD*MTcwMDA4MjkxOS4zLjEuMTcwMDA4NzQ1Mi4wLjAuMA..',
        },
        {
          text: 'Carte de fidélité',
          url: 'https://www.just-eat.ch/fr#cartes-%C3%A9pargne',
        },
        {
          text: 'Points',
          url: 'https://www.just-eat.ch/f/points',
        },
        {
          text: 'Conditions d’utilisation',
          url: 'https://www.just-eat.ch/fr/conditions-d-utilisation',
        },
        {
          text: 'Déclaration de confidentialité',
          url: 'https://www.just-eat.ch/fr/privacy-statement',
        },
        {
          text: 'Mentions légales',
          url: 'https://www.just-eat.ch/fr/colofon',
        },
        {
          text: 'Politique des cookies',
          url: 'https://www.just-eat.ch/fr/cookiestatement',
        }
        ],
      },
      mainNavSecond: [
        {
          colTitle: 'International',
          subLinks: [
            {
              text: 'Investor Relations',
              url: 'https://www.justeattakeaway.com/',
            },
            {
              text: '10bis',
              url: 'https://www.10bis.co.il',
            },
            {
              text: 'Bistro.sk',
              url: 'https://www.bistro.sk',
            },
            {
              text: 'Grubhub',
              url: 'https://www.grubhub.com',
            },
            {
              text: 'Just Eat - Switzerland',
              url: 'https://www.just-eat.ch',
            },
            {
              text: 'Just Eat - France',
              url: 'https://www.just-eat.fr',
            },
            {
              text: 'Just Eat - Denmark',
              url: 'https://www.just-eat.dk',
            },
            {
              text: 'Just Eat - Spain',
              url: 'https://www.just-eat.es',
            },
            {
              text: 'Just Eat - United Kingdom',
              url: 'https://www.just-eat.co.uk',
            },
            {
              text: 'Just Eat - Ireland',
              url: 'https://www.just-eat.ie',
            },
            {
              text: 'Just Eat - Italy',
              url: 'https://www.justeat.it',
            },
            {
              text: 'Lieferando.at',
              url: 'https://www.lieferando.at',
            },
            {
              text: 'Lieferando.de',
              url: 'https://www.lieferando.de',
            },
            {
              text: 'Menulog - Australia',
              url: 'https://www.menulog.com.au',
            },
            {
              text: 'Menulog - New Zealand',
              url: 'https://www.menulog.co.nz',
            },
            {
              text: 'Pyszne.pl',
              url: 'https://www.pyszne.pl',
            },
            {
              text: 'SkipTheDishes',
              url: 'https://www.skipthedishes.com',
            },
            {
              text: 'Takeaway.com - Belgium',
              url: 'https://www.takeaway.com/be',
            },
            {
              text: 'Takeaway.com - Luxembourg',
              url: 'https://www.takeaway.com/lu',
            },
            {
              text: 'Takeaway.com - Bulgaria',
              url: 'https://www.takeaway.com/bg',
            },
            {
              text: 'Thuisbezorgd.nl',
              url: 'https://www.thuisbezorgd.nl',
            }
          ],
        },
        {          
          colTitle: 'Nourriture',
          subLinks: [
            {
              text: 'Nourriture',
              url: 'https://www.just-eat.ch/fr/livraison-repas',
            },
            {
              text: 'Pizza',
              url: 'https://www.just-eat.ch/fr/commander-pizza',
            },
            {
              text: 'Chinois',
              url: 'https://www.just-eat.ch/fr/livraison-chinois',
            },
            {
              text: 'Petit déjeuner',
              url: 'https://www.just-eat.ch/fr/livraison-petit-dejeuner',
            },
            {
              text: 'Sushi',
              url: 'https://www.just-eat.ch/fr/livraison-sushi',
            },
            {
              text: 'Burgers',
              url: 'https://www.just-eat.ch/fr/livraison-burgers',
            },
            {
              text: 'Vegáne',
              url: 'https://www.just-eat.ch/fr/livraison-vegan',
            },
            {
              text: 'Courses',
              url: 'https://www.just-eat.ch/fr/livraison-courses',
            },
            {
              text: 'Asiatique',
              url: 'https://www.just-eat.ch/fr/livraison-asiatique',
            },
            {
              text: 'Indien',
              url: 'https://www.just-eat.ch/fr/livraison-indien',
            },
            {
              text: 'Tacos',
              url: 'https://www.just-eat.ch/fr/commander-tacos',
            },
            {
              text: 'Kebab',
              url: 'https://www.just-eat.ch/fr/livraison-kebab',
            },
            {
              text: 'Plus de spécialités..',
              url: 'hhttps://www.just-eat.ch/fr/commander-plus-de-repas',
            }
          ],
        },
        {          
          colTitle: 'Décrouvir',
          subLinks: [
            {
              text: 'Cartes Cadeaux',
              url: 'https://www.just-eat.ch/fr/cartes-cadeaux/',
            },
            {
              text: 'Durabilité',
              url: 'https://www.just-eat.ch/fr/durabilite/',
            },
            {
              text: 'Espace presse',
              url: 'https://www.justeattakeaway.com/newsroom/fr-CH/?_gl=1*1ace0ky*_ga*MDE4YmNkZjdkNzExMDAwZjMzZmY5NzEwMmEyZDA1MDc1MDAyMzA2ZDAwOWRj*_ga_4PH28YDTSD*MTcwMDA4MjkxOS4zLjEuMTcwMDA4ODg1OS4wLjAuMA..',
            },
            {
              text: 'Just Eat Rapport 2022',
              url: 'https://www.just-eat.ch/fr/deals/so-ordonne-suisse-2022/',
            },
            {
              text: 'Meilleurs Restaurants Suisse',
              url: 'https://www.just-eat.ch/fr/deals/villes/',
            },
            {
              text: 'Livraison Gratuite Genève',
              url: 'https://www.just-eat.ch/fr/deals/livraison-gratuite-geneve/',
            },
            {
              text: 'Saveurs de l’éte',
              url: 'https://www.just-eat.ch/fr/deals/saveurs-de-lete/',
            },
            {
              text: 'Deviens livreur à Zurich',
              url: 'https://www.just-eat.ch/fr/livreur/zurich',
            },
            {
              text: 'Deviens livreur à Bâle',
              url: 'https://www.just-eat.ch/fr/livreur/bale',
            },
            {
              text: 'Deviens livreur à Genève',
              url: 'https://www.just-eat.ch/fr/livreur/geneva',
            },
            {
              text: 'Deviens livreur à Lausanne',
              url: 'https://www.just-eat.ch/fr/livreur/lausanne',
            },
            {
              text: 'Deviens livreur à Berne',
              url: 'https://www.just-eat.ch/fr/livreur/berne',
            },
            {
              text: 'Deviens livreur à Saint-Gall',
              url: 'https://www.just-eat.ch/fr/livreur/saint-gall',
            },
            {
              text: 'Deviens livreur à Winterthour',
              url: 'https://www.just-eat.ch/fr/livreur/winterthour',
            },
          ],
        },
        {
          colTitle: 'Villes',
          subLinks: [
            {
              text: 'Zürich',
              url: 'https://www.just-eat.ch/fr/livraison-repas-zuerich-zuerich'
            },
            {
              text: 'Genf',
              url: 'https://www.just-eat.ch/fr/livraison-repas-genf-genf'
            },
            {
              text: 'Basel',
              url: 'https://www.just-eat.ch/fr/livraison-repas-basel',
            },
            {
              text: 'Bern',
              url: 'https://www.just-eat.ch/fr/livraison-repas-bern-bern',
            },
            {
              text: 'Lausanne',
              url: 'https://www.just-eat.ch/fr/livraison-repas-lausanne',
            },
            {
              text: 'Winterthur',
              url: 'https://www.just-eat.ch/fr/livraison-repas-winterthur',
            },
            {
              text: 'Luzern',
              url: 'https://www.just-eat.ch/fr/livraison-repas-luzern-luzern',
            },
            {
              text: 'St. Gallen',
              url: 'https://www.just-eat.ch/fr/livraison-repas-sankt-gallen'
            },
            {
              text: 'Lugano',
              url: 'https://www.just-eat.ch/fr/livraison-repas-lugano'
            },
            {
              text: 'Freiburg',
              url: 'https://www.just-eat.ch/fr/livraison-repas-fribourg',
            },
            {
              text: 'Biel',
              url: 'https://www.just-eat.ch/fr/livraison-repas-biel',
            },
            {
              text: 'Neuchatel',
              url: 'https://www.just-eat.ch/fr/livraison-repas-neuchatel',
            },
            {
              text: 'Zug',
              url: 'https://www.just-eat.ch/fr/livraison-repas-zug',
            },
            {
              text: 'View all locations',
              url: 'https://www.just-eat.co.uk/takeaway/'
            }
          ]
        },
        {
          colTitle: 'Chaînes',
          subLinks: [
            {
              text: "McDonald's",
              url: 'https://www.just-eat.ch/fr/mcdonalds',
            },
            {
              text: 'Burger King',
              url: 'https://www.just-eat.ch/fr/burger-king'
            },
            {
              text: 'Domino’s Pizza',
              url: 'https://www.just-eat.ch/fr/dominos-pizza'
            },
            {
              text: 'KFC',
              url: 'https://www.just-eat.ch/fr/kfc'
            },
            {
              text: 'Subway',
              url: 'https://www.just-eat.ch/fr/subway'
            },
            {
              text: 'Dunkin Donuts',
              url: 'https://www.just-eat.ch/fr/dunkin-donuts'
            },
            {
              text: 'Giga Taco’s',
              url: 'https://www.just-eat.ch/fr/giga-tacos'
            },
            {
              text: 'Peking Garden',
              url: 'https://www.just-eat.ch/fr/peking-garden',
            },
            {
              text: 'Poulet Hochgenuss',
              url: 'https://www.just-eat.ch/fr/poulet-hochgenuss'
            },
            {
              text: 'Napule',
              url: 'https://www.just-eat.ch/fr/napule'
            },
            {
              text: 'Telepizza',
              url: 'https://www.just-eat.ch/fr/'
            },
            {
              text: 'Brezelkönig',
              url: 'https://www.just-eat.ch/fr/brezelkoenig'
            },
            {
              text: 'dean & david',
              url: 'https://www.just-eat.ch/fr/dean-and-david'
            },
            {
              text: 'Nos chaînes…',
              url: 'https://www.just-eat.ch/fr/chaines'
            }
          ]
        },
        {          
          colTitle: 'Nouveaux partneaires',
          subLinks: [
            {
              text: 'Best Burger und Kebab, Benglen',
              url: 'https://www.just-eat.ch/fr/menu/bash-burger-und-kebab',
            },
            {
              text: 'Mali Pizza Kebap Fislisbach, Fislisbach',
              url: 'https://www.just-eat.ch/fr/menu/mali-pizza-kebap-fislisbach',
            },
            {
              text: 'Tibet Stubä - Wollishofen, Zürich',
              url: 'https://www.just-eat.ch/fr/menu/tibet-stuba-wollishofen',
            },
            {
              text: 'Pizza La Regina Zurich, Zürich',
              url: 'https://www.just-eat.ch/fr/menu/pizza-la-regina-zurich',
            },
            {
              text: 'PIRO’. Pizzeria Napoletana, Dornach',
              url: 'https://www.just-eat.ch/fr/menu/pizza-la-regina-zurich',
            },
            {
              text: 'Easy Shop, Biel',
              url: 'https://www.just-eat.ch/fr/menu/easy-shop',
            },
            {
              text: 'Doppiozero, Le Lignon',
              url: 'https://www.just-eat.ch/fr/menu/doppiozero-geneve',
            },
            {
              text: 'Rafa Food, Lausanne',
              url: 'https://www.just-eat.ch/fr/menu/rafa-food',
            },
            {
              text: 'HappyBuns© Uetikon am See, Uetikon am See',
              url: 'https://www.just-eat.ch/fr/menu/happybuns-uetikon-am-see',
            }
          ],
        },
        {         
          colTitle: 'Regions',
          subLinks: [
            {
              text: 'Aargau',
              url: 'https://www.just-eat.ch/fr/livraison-repas-aargau',
            },
            {
              text: 'Appenzell Ausserrhoden',
              url: 'https://www.just-eat.ch/fr/livraison-repas-Ausserrhoden',
            },
            {
              text: 'Appenzell Innerrhoden',
              url: 'https://www.just-eat.ch/fr/livraison-repas-innerrhoden',
            },
            {
              text: 'Basel-Landschaft',
              url: 'https://www.just-eat.ch/fr/livraison-repas-landschaft',
            },
            {
              text: 'Basel-Stadt',
              url: 'https://www.just-eat.ch/fr/livraison-repas-basel-stadt',
            },
            {
              text: 'Bern',
              url: 'https://www.just-eat.ch/fr/livraison-repas-bern',
            },
            {
              text: 'Freiburg',
              url: 'https://www.just-eat.ch/fr/livraison-repas-freiburg',
            },
            {
              text: 'Genf',
              url: 'https://www.just-eat.ch/fr/livraison-repas-genf',
            },
            {
              text: 'Glarus',
              url: 'https://www.just-eat.ch/fr/livraison-repas-glarus',
            },
            {
              text: 'Graubünden',
              url: 'https://www.just-eat.ch/fr/livraison-repas-graubuenden',
            },
            {
              text: 'Jura',
              url: 'https://www.just-eat.ch/fr/livraison-repas-jura',
            },
            {
              text: 'Liechtenstein',
              url: 'https://www.just-eat.ch/fr/livraison-repas--liechtenstein',
            },
            {
              text: 'Luzern',
              url: 'https://www.just-eat.ch/fr/livraison-repas-uzern',
            },
            {
              text: 'Neuenburg',
              url: 'https://www.just-eat.ch/fr/livraison-repas-neuenburg',
            },
            {
              text: 'Nidwalden',
              url: 'https://www.just-eat.ch/fr/livraison-repas-nidwalden',
            },
            {
              text: 'Obwalden',
              url: 'https://www.just-eat.ch/fr/livraison-repas-obwalden',
            },
            {
              text: 'Sankt Gallen',
              url: 'https://www.just-eat.ch/fr/livraison-repas-sankt-gallen',
            },
            {
              text: 'Schaffhausen',
              url: 'https://www.just-eat.ch/fr/livraison-repas-schaffhausen',
            },
            {
              text: 'Schwyz',
              url: 'https://www.just-eat.ch/fr/livraison-repas-schwyz',
            },
            {
              text: 'Solothurn',
              url: 'https://www.just-eat.ch/fr/livraison-repas-solothurn',
            },
            {
              text: 'Thurgau',
              url: 'https://www.just-eat.ch/fr/livraison-repas-thurgau',
            },
            {
              text: 'Ticino',
              url: 'https://www.just-eat.ch/fr/livraison-repas-ticino',
            },
            {
              text: 'Uri',
              url: 'https://www.just-eat.ch/fr',
            },
            {
              text: 'Waadt',
              url: 'https://www.just-eat.ch/fr/livraison-repas-waadt',
            },
            {
              text: 'Zug',
              url: 'https://www.just-eat.ch/fr/livraison-repas-zug',
            },
            {
              text: 'Zürich',
              url: 'https://www.just-eat.ch/fr/livraison-repas-zuerich',
            },
          ]
        },
      ]
    },
    hero: {
      logo: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/logos/dss_jet_swiss_fr.png',
      main: 'Christina Aguilera et Latto',
      sub: 'Campagne Just Eat 2023',
      img: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/christina-latto.png',
    },
    about: {
      title: 'À propos de la campagne',
      text: 'Nous voilà de retour avec une toute nouvelle campagne.\n\nNotre dernière création, en collaboration avec McCann London, allie l’énergie hip-hop de Latto et les incroyables vocalises de Christina Aguilera. Le résultat? Un véritable plaisir pour les yeux et les oreilles qui incarne parfaitement la surprenante variété de saveurs que vous trouverez chez Just Eat.',
      img: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/xtina-wave.gif',
    },
    video: {
      title: 'Découvrez le clip Quelqu’un a dit',
      id: 'https://www.youtube.com/embed/9pio6r2OkNs?si=efPxue979CqTxsZk',
    },
    lyrics: {
      title: 'Paroles complètes de Quelqu’un a dit ft. Christina Aguilera et Latto',
      lyrics: `On vous a prévu du lourd

Quelqu’un a dit Just Eat

Tu pensais qu’il n’y avait
que des burgers et des frites 

Mais y’a plus de plats dans l’app
Tu les goûteras tous si t’es cap

Pour ça, notre app c’est le feu
Dessus y’a tout ce que tu veux

Jette un œil, ça va te surprendre

Miam

Y’en a pour toutes les bourses

Et tu peux même faire tes courses!

Quand je commande, c’est moi la boss

Vas-y, dis-moi ce qui te chauffe
Je peux te faire livrer des tacos

Du riz thaï bien parfumé

Et des gyozas bien préparés
Tu vas être impressionné·e bébé

Petit-déj ou dîner
Brunch ou souper

Envie d'un repas de qualité?
Laisse Just Eat te régaler

Le serveur aux petits oignons
M’apporte des baos trop mignons

Et du café bien serré
Y a qu’à demander, bébé!

Une glace avec mon magazine préféré
Tous mes désirs deviennent réalité

Des sushis? Là aussi, ça roule

Une app comme ça
c’est vraiment trop cool

Quelqu’un a dit Just Eat`,
      img: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/christina-lyrics.png',
    },
    food: {
      title: 'Plats et services présentés dans la nouvelle campagne mettant en scène Christina Aguilera et Latto',
      intro: 'Quelque chose vous a mis l’eau à la bouche? Vous trouverez sur notre plateforme tous les plats (et services) présentés dans le clip de la campagne.*',
      list: [
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature1_tunapoke.pnƒg',
          title: 'Poké bowl au thon',
          link: 'https://www.just-eat.ch/fr/livraison-poke-bowl',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature2_foccacia.png',
          title: 'Focaccia',
          link: 'https://www.just-eat.ch/fr/commander-pizza-italienne',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature3_thaisalad.png',
          title: 'Salade thaï',
          link: 'https://www.just-eat.ch/fr/livraison-thailandais',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature4_groceries.png',
          title: 'Épicerie',
          link: '’https://www.just-eat.ch/fr/livraison-courses',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature5_tacos.png',
          title: 'Tacos',
          link: 'https://www.just-eat.ch/fr/commander-tacos',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature6_pizza.png',
          title: 'Pizza',
          link: 'https://www.just-eat.ch/fr/commander-pizza',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature7_turkishmezze.png',
          title: 'Mezzés turcs',
          link: 'https://www.just-eat.ch/fr/order-oriental',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature8_macaroons.png',
          title: 'Macarons',
          link: 'https://www.just-eat.ch/fr/livraison-desserts',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature9_waffles.png',
          title: 'Gaufres',
          link: 'https://www.just-eat.ch/fr/livraison-petit-dejeuner',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature10_avotoast.png',
          title: 'Toast avocat et œuf poché',
          link: 'https://www.just-eat.ch/fr/livraison-petit-dejeuner'
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature11_acaibowl.png',
          title: 'Bol d’açaï',
          link: 'https://www.just-eat.ch/fr/livraison-petit-dejeuner',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature12_fruitsalad.png',
          title: 'Salade de fruits',
          link: 'https://www.just-eat.ch/fr/livraison-petit-dejeuner',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature13_yogurt.png',
          title: 'Yoghourt et granola',
          link: 'https://www.just-eat.ch/fr/livraison-petit-dejeuner',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature14_pastries.png',
          title: 'Sélection de pâtisseries',
          link: 'https://www.just-eat.ch/fr/livraison-desserts',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature15_icedcoffee.png',
          title: 'Café glacé',
          link: 'https://www.just-eat.ch/fr/order-coffee',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature16_smoothie.png',
          title: 'Smoothies',
          link: 'https://www.just-eat.ch/fr/order-smoothies',
        },
      ],
      disclaimer: '*Offer depends on location.',
    },
    word: {
      title: 'A word from those involved with the new Just Eat advert',
      words: [
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say-vue/static/img/profile_image_xtina.png',
          name: 'Christina Aguilera',
          role: 'Talent',
          quote: 'I had so much fun combining different music styles alongside my girl Latto for Just Eat Takeaway. With non-stop laughter and love, we had the best time bringing this project to life. It was clear while shooting long days that JET is the much needed one-stop-shop for meals and grocery needs.',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say-vue/static/img/profile_image_latto.png',
          name: 'Latto',
          role: 'Talent',
          quote: 'When I heard about the opportunity to work with Just Eat I was actually abroad on tour using the app! It was a no-brainer for me especially with the iconic Christina Aguilera involved. I had so much fun with this collab and have loved seeing it come to life.'
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say-vue/static/img/profile_image_suso.png',
          name: 'Susan O’Brien',
          role: 'VP Global Brand at Just Eat',
          quote: "We’re back with a new hip-hopera twist of our Did Somebody Say brand platform, this time with double the star power. Christina Aguilera and Latto are the perfect duo to bring something extraordinary to our customers, and this new mix doesn’t disappoint, just like the food choices you can get on Just Eat. Whether you're craving your favourite takeaway or looking for everyday groceries, we’re here everyday to deliver it all and more.",
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say-vue/static/img/profile_image_dept.png',
          name: 'Dept',
          role: 'Digital Agency',
          quote: 'Jeff Bowerman, Executive Creative Director at DEPT® said: “Our role at DEPT® was taking this great idea and making it sing in social and digital spaces. Tapping into cultural and native platform insights to speak to audiences wherever they spend their time, whilst making sure we deliver key brand messages like range and delivery in stand-out creative ways.”'
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say-vue/static/img/profile_logo_weber.png',
          name: 'Joanna Pritchard',
          role: 'Executive Vice President at Weber Shandwick',
          quote: 'The opportunity to explore the unexpected collision of hip hop and opera from an earned media perspective has been a fantastic challenge. We’ve loved developing earned ideas for the markets to adapt and implement locally that reflect joy in the unexpected and the surprising breadth of cuisines now available through Just Eat Takeaway.com.',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say-vue/static/img/profile_logo_radicalmedia.png',
          name: 'Ben Schneider',
          role: 'SVP and Executive Producer at RadicalMedia London',
          quote: 'Producing this years campaign alongside our partners at McCann London and JET Global has been a pleasure and privilege. The genre-crossing music - and a yet unseen artist pairing JET has curated presented a unique opportunity for our director Dave Meyers to bring the campaign to life.',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say-vue/static/img/profile_image_mccann.png',
          name: 'Rob Webster and Alexei Berwitz',
          role: 'Creative Directors at McCann London',
          quote: "Surprising is the greatest and perhaps the hardest brief of all. But thanks to our ever-courageous clients and the amazing efforts of all involved, this campaign hits unexpected notes at every turn – hip-hop and opera isn't an obvious musical combination, but it's one that really, really works.",
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say-vue/static/img/profile_image_talentrepublic.png',
          name: 'Talent Republic',
          role: 'Talent agency',
          quote: "The hip-hop meets opera creative certainly made this ‘Did Somebody Say’ campaign the most challenging from a Talent perspective. There are very few iconic female singers who can reach the vocal levels that Christina soared to, and with such a distinctive delivery. In Latto we found the perfect counterpoint as someone who has bags of attitude and energy, and who is fast becoming one of the most sought-after rappers around.\n\nIn terms of audience reach and recognition, pairing such an established Artist with such a fresh, new talent was key. The fact they embodied the characteristics of ‘rap’ and ‘opera’  they were asked to convey in their respective roles, and looked so stunning together, was the icing on the cake for us",
        }
      ]
    }
  },
  nl_nl: {
    navbar: {
      logo: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/logos/logo_nl.svg',
      country_toggle: [
        {
          logo: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/country-svg/nl.svg',
          url: 'https://www.thuisbezorgd.nl/deals/zei-dr-iemand-thuisbezorgd/',
          text: 'Nederlands'
        },
        {
          logo: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/country-svg/gb.svg',
          url: 'https://www.thuisbezorgd.nl/en/deals/did-somebody-say',
          text: 'English'
        },
      ],
      language: 'Taal',
    },
    button: {
      text: 'Go home',
      url: 'https://www.thuisbezorgd.nl'
    },
    footer: {
      logo: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/logos/dss_footer_nl.png',
      main_link: 'https://www.thuisbezorgd.nl',
      links: [
        {
          text: 'Restaurant aanbevelen',
          url: 'https://www.thuisbezorgd.nl/aanbevelen'
        },
        {
          text: 'Restaurant aanmelden',
          url: 'https://www.thuisbezorgd.nl/aanmelden'
        },
        {
          text: 'Vacatures',
          url: 'https://careers.justeattakeaway.com/nl/nl?_gl=1*l4qmqe*_ga*MDE4NmEyMmI0MTIwMDAxMzQ5OTMxMTEzNTFkZDA1MDc1MDAyZTA2ZDAwYjNi*_ga_4PH28YDTSD*MTcwMDE0NjI0OC4zNC4xLjE3MDAxNDYyNTMuMC4wLjA.',
        },
        {
          text: 'Algemene voorwaarden',
          url: 'https://www.thuisbezorgd.nl/algemene-voorwaarden'
        },
        {
          text: 'Privacy statement',
          url: 'https://www.thuisbezorgd.nl/privacy-statement',
        },
        {
          text: 'Colofon',
          url: 'https://www.thuisbezorgd.nl/colofon'
        },
        {
          text: 'Cookieverklaring',
          url: 'https://www.thuisbezorgd.nl/cookieverklaring'
        },
        {
          text: 'Bug Bounty',
          url: 'https://www.thuisbezorgd.nl/bugbounty',
        },
        {
          text: 'Ethiek-hotline',
          url: 'https://app.convercent.com/nl-nl/LandingPage/d8e86634-ec59-ec11-a985-000d3ab9f296'
        },
      ],
      copyright: '2023 Thuisbezorgd.nl',
      mainNavFirst: {
        colTitle: 'Thuisbezorgd.nl',
        subLinks: [
          {
            text: 'Thuisbezorgd.nl for Business',
            url: 'https://www.thuisbezorgd.nl/business',
          },
          {
            text: 'Klantenservice',
            url: 'https://www.thuisbezorgd.nl/klantenservice'
          },
          {
            text: 'Een bedrijf aanbevelen',
            url: 'https://www.thuisbezorgd.nl/aanbevelen'
          },
          {
            text: 'Meld je bedrijf aan',
            url: 'https://www.thuisbezorgd.nl/aanmelden',
          },
          {
            text: 'Word affiliate',
            url: 'https://www.thuisbezorgd.nl/affiliate',
          },
          {
            text: 'Word bezorger',
            url: 'https://www.thuisbezorgd.nl/bezorger?utm_source=mainsite&utm_medium=referral&utm_content=footer'
          },
          {
            text: 'Vacatures',
            url: 'https://careers.justeattakeaway.com/nl/nl?_gl=1*v8vtot*_ga*MDE4NmEyMmI0MTIwMDAxMzQ5OTMxMTEzNTFkZDA1MDc1MDAyZTA2ZDAwYjNi*_ga_4PH28YDTSD*MTcwMDE0NjI0OC4zNC4xLjE3MDAxNDYyNTMuMC4wLjA.'
          },
          {
            text: 'Stempelkaarten',
            url: 'https://www.thuisbezorgd.nl/#stempelkaarten'
          },
          {
            text: 'Points',
            url: 'https://www.thuisbezorgd.nl/punten',
          },
          {
            text: 'Algemene voorwaarden',
            url: 'https://www.thuisbezorgd.nl/algemene-voorwaarden'
          },
          {
            text: 'Privacy statement',
            url: 'https://www.thuisbezorgd.nl/privacy-statement',
          },
          {
            text: 'Colofon',
            url: 'https://www.thuisbezorgd.nl/colofon',
          },
          {
            text: 'Cookieverklaring',
            url: 'https://www.thuisbezorgd.nl/cookieverklaring'
          },
        ],
      },
      mainNavSecond: [
        {
          colTitle: 'International',
          subLinks: [
            {
              text: 'Investor Relations',
              url: 'https://www.justeattakeaway.com/',
            },
            {
              text: '10bis',
              url: 'https://www.10bis.co.il',
            },
            {
              text: 'Bistro.sk',
              url: 'https://www.bistro.sk',
            },
            {
              text: 'Grubhub',
              url: 'https://www.grubhub.com',
            },
            {
              text: 'Just Eat - Switzerland',
              url: 'https://www.just-eat.ch',
            },
            {
              text: 'Just Eat - France',
              url: 'https://www.just-eat.fr',
            },
            {
              text: 'Just Eat - Denmark',
              url: 'https://www.just-eat.dk',
            },
            {
              text: 'Just Eat - Spain',
              url: 'https://www.just-eat.es',
            },
            {
              text: 'Just Eat - United Kingdom',
              url: 'https://www.just-eat.co.uk',
            },
            {
              text: 'Just Eat - Ireland',
              url: 'https://www.just-eat.ie',
            },
            {
              text: 'Just Eat - Italy',
              url: 'https://www.justeat.it',
            },
            {
              text: 'Lieferando.at',
              url: 'https://www.lieferando.at',
            },
            {
              text: 'Lieferando.de',
              url: 'https://www.lieferando.de',
            },
            {
              text: 'Menulog - Australia',
              url: 'https://www.menulog.com.au',
            },
            {
              text: 'Menulog - New Zealand',
              url: 'https://www.menulog.co.nz',
            },
            {
              text: 'Pyszne.pl',
              url: 'https://www.pyszne.pl',
            },
            {
              text: 'SkipTheDishes',
              url: 'https://www.skipthedishes.com',
            },
            {
              text: 'Takeaway.com - Belgium',
              url: 'https://www.takeaway.com/be',
            },
            {
              text: 'Takeaway.com - Luxembourg',
              url: 'https://www.takeaway.com/lu',
            },
            {
              text: 'Takeaway.com - Bulgaria',
              url: 'https://www.takeaway.com/bg',
            },
            {
              text: 'Thuisbezorgd.nl',
              url: 'https://www.thuisbezorgd.nl',
            }
          ],
        },
        {          
          colTitle: 'Eten',
          subLinks: [
            {
              text: 'Eten',
              url: 'https://www.thuisbezorgd.nl/eten-bestellen',
            },
            {
              text: 'Pizza',
              url: 'https://www.thuisbezorgd.nl/pizza-bestellen',
            },
            {
              text: 'Sushi',
              url: 'https://www.thuisbezorgd.nl/sushi-bestellen',
            },
            {
              text: 'Veganistisch',
              url: 'https://www.thuisbezorgd.nl/veganistisch-eten-bestellen',
            },
            {
              text: 'Chinees',
              url: 'https://www.thuisbezorgd.nl/chinees-bestellen',
            },
            {
              text: 'Poké bowl',
              url: 'https://www.thuisbezorgd.nl/poke-bowl-bestellen',
            },
            {
              text: 'Roti',
              url: 'https://www.thuisbezorgd.nl/roti-bestellen',
            },
            {
              text: 'Spareribs',
              url: 'https://www.thuisbezorgd.nl/spare-ribs-bestellen',
            },
            {
              text: 'Thais',
              url: 'https://www.thuisbezorgd.nl/thais-bestellen',
            },
            {
              text: 'Kapsalon',
              url: 'https://www.thuisbezorgd.nl/kapsalon-bestellen',
            },
            {
              text: 'Broodjes',
              url: 'https://www.thuisbezorgd.nl/broodjes-bestellen',
            },
            {
              text: 'Boodschappen',
              url: 'https://www.thuisbezorgd.nl/boodschappen-bestellen',
            },
            {
              text: 'Spaans/Tapas',
              url: 'https://www.thuisbezorgd.nl/spaans-en-tapas-bestellen',
            },
            {
              text: 'Shoarma',
              url: 'https://www.thuisbezorgd.nl/shoarma-bestellen',
            },
            {
              text: 'Meer eten bestellen...',
              url: 'https://www.thuisbezorgd.nl/meer-eten-bestellen',
            }
          ],
        },
        {          
          colTitle: 'Ontdek',
          subLinks: [
            {
              text: 'Foodwiki',
              url: 'https://www.thuisbezorgd.nl/foodwiki/',
            },
            {
              text: 'Cadeaukaarten',
              url: 'https://www.thuisbezorgd.nl/cadeaukaarten/',
            },
            {
              text: 'Kortingscode Thuisbezorgd.nl',
              url: 'https://www.thuisbezorgd.nl/kortingscodes',
            },
            {
              text: 'Wat eten we vandaag?',
              url: 'https://www.thuisbezorgd.nl/wat-eten-we-vandaag',
            },
            {
              text: 'Duurzaamheid',
              url: 'https://www.thuisbezorgd.nl/duurzaamheid/',
            },
            {
              text: 'Newsroom',
              url: 'https://www.justeattakeaway.com/newsroom/nl-NL/?_gl=1*14rvscs*_ga*MDE4NmEyMmI0MTIwMDAxMzQ5OTMxMTEzNTFkZDA1MDc1MDAyZTA2ZDAwYjNi*_ga_4PH28YDTSD*MTcwMDE0NjI0OC4zNC4xLjE3MDAxNDYyNTMuMC4wLjA.',
            },
            {
              text: 'Thuisbezorgd.nl Rapport 2022',
              url: 'https://www.thuisbezorgd.nl/deals/food-trend-rapport-2022/',
            },
            {
              text: 'Proef de zomer',
              url: 'https://www.thuisbezorgd.nl/deals/proef-de-zomer/',
            },
            {
              text: 'Het Grote Snackbar Onderzoek',
              url: 'https://www.thuisbezorgd.nl/deals/het-grote-snackbar-onderzoek/',
            },
            {
              text: 'Word bezorger in Rotterdam',
              url: 'https://www.thuisbezorgd.nl/bezorger/rotterdam',
            },
            {
              text: 'Word bezorger in Amsterdam',
              url: 'https://www.thuisbezorgd.nl/bezorger/amsterdam',
            },
            {
              text: 'Word bezorger in Den Haag',
              url: 'https://www.thuisbezorgd.nl/bezorger/den-haag',
            },
            {
              text: 'Word bezorger in Utrecht',
              url: 'https://www.thuisbezorgd.nl/bezorger/utrecht',
            },
            {
              text: 'Word bezorger in Groningen',
              url: 'https://www.thuisbezorgd.nl/bezorger/groningen',
            },
            {
              text: 'Win UEFA Europa League® Tickets',
              url: 'https://www.thuisbezorgd.nl/deals/wedstrijd-deals/',
            },
          ],
        },
        {
          colTitle: 'Steden',
          subLinks: [
            {
              text: 'Amsterdam',
              url: 'https://www.thuisbezorgd.nl/eten-bestellen-amsterdam'
            },
            {
              text: 'Rotterdam',
              url: 'https://www.thuisbezorgd.nl/eten-bestellen-rotterdam'
            },
            {
              text: 'Den Haag',
              url: 'https://www.thuisbezorgd.nl/eten-bestellen-den-haag'
            },
            {
              text: 'Utrecht',
              url: 'https://www.thuisbezorgd.nl/eten-bestellen-utrecht'
            },
            {
              text: 'Eindhoven',
              url: 'https://www.thuisbezorgd.nl/eten-bestellen-eindhoven',
            },
            {
              text: "Tilburg",
              url: 'https://www.thuisbezorgd.nl/eten-bestellen-tilburg'
            },
            {
              text: 'Almere',
              url: 'https://www.thuisbezorgd.nl/eten-bestellen-almere'
            },
            {
              text: 'Groningen',
              url: 'https://www.thuisbezorgd.nl/eten-bestellen-groningen'
            },
            {
              text: 'Breda',
              url: 'https://www.thuisbezorgd.nl/eten-bestellen-breda'
            },
            {
              text: 'Nijmegen',
              url: 'https://www.thuisbezorgd.nl/eten-bestellen-nijmegen'
            },
            {
              text: 'Enschede',
              url: 'https://www.thuisbezorgd.nl/eten-bestellen-enschede',
            },
            {
              text: "Arnhem",
              url: 'https://www.thuisbezorgd.nl/eten-bestellen-arnhem'
            },
            {
              text: 'Zwolle',
              url: 'https://www.thuisbezorgd.nl/eten-bestellen-zwolle',
            },
            {
              text: 'Haarlem',
              url: 'https://www.thuisbezorgd.nl/eten-bestellen-haarlem',
            },
            {
              text: 'Leiden',
              url: 'https://www.thuisbezorgd.nl/eten-bestellen-leiden'
            }
          ]
        },
        {
          colTitle: 'Ketens',
          subLinks: [
            {
              text: "McDonald's",
              url: 'https://www.thuisbezorgd.nl/mcdonalds'
            },
            {
              text: 'Subway',
              url: 'https://www.thuisbezorgd.nl/subway'
            },
            {
              text: 'KFC',
              url: 'https://www.thuisbezorgd.nl/kfc',
            },
            {
              text: 'Spare Rib Express',
              url: 'https://www.thuisbezorgd.nl/spare-rib-express',
            },
            {
              text: 'Burger King',
              url: 'https://www.thuisbezorgd.nl/burger-king'
            },
            {
              text: 'eazie',
              url: 'https://www.thuisbezorgd.nl/eazie'
            },
            {
              text: 'Bakker Bart',
              url: 'https://www.thuisbezorgd.nl/bakker-bart'
            },
            {
              text: "Happy Italy",
              url: 'https://www.thuisbezorgd.nl/happy-italy'
            },

            {
              text: "FEBO",
              url: 'https://www.thuisbezorgd.nl/febo',
            },
            {
              text: 'De Beren',
              url: 'https://www.thuisbezorgd.nl/de-beren'
            },
            {
              text: 'Sumo Sushi',
              url: 'https://www.thuisbezorgd.nl/sumo-take-away-delivery'
            },
            {
              text: 'Vapiano',
              url: 'https://www.thuisbezorgd.nl/vapiano'
            },
            {
              text: "Domino's Pizza",
              url: 'https://www.thuisbezorgd.nl/dominos-pizza',
            },
            {
              text: "New York Pizza",
              url: 'https://www.thuisbezorgd.nl/new-york-pizza'
            },
            {
              text: 'Meer restaurantketens...',
              url: 'https://www.thuisbezorgd.nl/ketens',
            },
          ]
        },
        {
          colTitle: 'Nieuwe locaties',
          subLinks: [
            {
              text: "Al Mercato 2023, Goes",
              url: 'https://www.thuisbezorgd.nl/menu/al-mercato-2023'
            },
            {
              text: 'Café Restaurant Dierenselaan, Den Haag',
              url: 'https://www.thuisbezorgd.nl/menu/cafe-restaurant-dierenselaan'
            },
            {
              text: 'EkoBites, Den Haag',
              url: 'https://www.thuisbezorgd.nl/menu/ekobites'
            },
            {
              text: "Fresh Burger 7, Amsterdam",
              url: 'https://www.thuisbezorgd.nl/menu/fresh-burger-7'
            },
            {
              text: "Snackbar Nico's, Den Bosch",
              url: 'https://www.thuisbezorgd.nl/menu/snackbar-nicos'
            },
            {
              text: 'Eetcafe Babylon, Dordrecht',
              url: 'https://www.thuisbezorgd.nl/menu/eetcafe-babylon-new'
            },
            {
              text: "Joe's Burger, Leiden",
              url: 'https://www.thuisbezorgd.nl/menu/joes-burger-2'
            },
            {
              text: 'Sushi Tijd, Eindhoven',
              url: 'https://www.thuisbezorgd.nl/menu/sushi-tijd-1'
            },
            {
              text: 'Bakkerij Nieuwendijk, Nieuwendijk',
              url: 'https://www.thuisbezorgd.nl/menu/bakkerij-nieuwendijk'
            },
            {
              text: 'Al Aseel Groningen, Groningen',
              url: 'https://www.thuisbezorgd.nl/menu/al-aseel-groningen'
            },
          ]
        },
        {
          colTitle: 'Provincies',
          subLinks: [
            {
              text: "Drenthe",
              url: 'https://www.thuisbezorgd.nl/eten-bestellen-drenthe'
            },
            {
              text: 'Flevoland',
              url: 'https://www.thuisbezorgd.nl/eten-bestellen-flevoland'
            },
            {
              text: 'Friesland',
              url: 'https://www.thuisbezorgd.nl/eten-bestellen-friesland'
            },
            {
              text: "Gelderland",
              url: 'https://www.thuisbezorgd.nl/eten-bestellen-gelderland'
            },
            {
              text: "Groningen",
              url: 'https://www.thuisbezorgd.nl/eten-bestellen-provincie-groningen'
            },
            {
              text: 'Limburg',
              url: 'https://www.thuisbezorgd.nl/eten-bestellen-limburg'
            },
            {
              text: 'Noord-Brabant',
              url: 'https://www.thuisbezorgd.nl/eten-bestellen-noord-brabant'
            },
            {
              text: 'Noord-Holland',
              url: 'https://www.thuisbezorgd.nl/eten-bestellen-noord-holland'
            },
            {
              text: 'Overijssel',
              url: 'https://www.thuisbezorgd.nl/eten-bestellen-overijssel'
            },
            {
              text: 'Utrecht',
              url: 'https://www.thuisbezorgd.nl/eten-bestellen-provincie-utrecht'
            },
            {
              text: 'Zeeland',
              url: 'https://www.thuisbezorgd.nl/eten-bestellen-zeeland'
            },
            {
              text: 'Zuid-Holland',
              url: 'hhttps://www.thuisbezorgd.nl/eten-bestellen-zuid-holland'
            },
          ]
        },
      ]
    },
    hero: {
      logo: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/logos/dss_thuisbezorgd.png',
      main: 'Christina Aguilera en Latto',
      sub: 'Thuisbezorgd.nl merkcampagne 2023',
      img: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/christina-latto.png',
    },
    about: {
      title: 'Over de campagne',
      text: "We zijn weer terug met een te gekke campagne.\n\nSamen met McCann London hebben we voor onze nieuwste creatie Latto’s hip-hop energie gecombineerd met Christina Aguilera’s eigentijdse kijk op opera. Het resultaat? Een betoverende reis van beeld en geluid door de eindeloze wereld van smaakvariaties op Thuisbezorgd.nl",
      img: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/xtina-wave.gif',
    },
    video: {
      title: "Zei D'r Iemand videoclip",
      id: 'https://www.youtube.com/embed/y-af2NvPAQ4?si=h0rnkp61CnCjK1Jz',
    },
    lyrics: {
      title: "Zei D'r Iemand ft. Christina Aguilera & Latto songtekst",
      lyrics: `Y'all ready for something new?

      Zei d'r iemand Thuisbezorgd
      
      Oh you thought it was
      just burgers and fries
      
      They got more flavours than you tasted
      Or you heard in your life
      
      Ooh - this is what the app do
      It ain't only fast food
      
      Switching styles like opera to rap too
      
      Yummy
      
      And it ain't only restaurants anymore
      
      We can go bananas at the grocery store
      
      I'm a bad girl but my takeout badder
      
      What you need dude?
      I can cop a taco platter
      
      Thai rice sticky icky
      
      Gyoza on the side fried right
      Cos we kinda picky
      
      Breakfast or lunch hun
      Dinner or brunch
      
      Wanna find the finest dining?
      I got a hunch
      
      And some hot tall dude's
      Bringing buns to the ballroom
      
      Got me a strong coffee
      Let's get it on papi
      
      Ice-cream with my magazine
      Who can stop me
      
      And my sushi train is on loop
      
      When you this slick
      whatchoo gon’ do?
      
      Zei d'r iemand Thuisbezorgd`,
      img: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/christina-lyrics.png',
    },
    food: {
      title: 'Al het lekkers uit de campagne met Christina Aguilera en Latto',
      intro: 'Je oog laten vallen op iets lekkers? Dit is al het lekkers uit de campagne dat je kunt bestellen op ons platform.',
      list: [
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature1_tunapoke.png',
          title: 'Tonijn pokébowl',
          link: 'https://www.thuisbezorgd.nl/poke-bowl-bestellen',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature2_foccacia.png',
          title: 'Focaccia sandwich',
          link: 'https://www.thuisbezorgd.nl/broodjes-bestellen',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature3_thaisalad.png',
          title: 'Thaise salade',
          link: 'https://www.thuisbezorgd.nl/thais-bestellen',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature4_groceries.png',
          title: 'Boodschappen',
          link: 'https://www.thuisbezorgd.nl/boodschappen-bestellen',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature5_tacos.png',
          title: 'Taco’s',
          link: 'https://www.thuisbezorgd.nl/tacos-bestellen',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature6_pizza.png',
          title: 'Pizza',
          link: 'https://www.thuisbezorgd.nl/amerikaanse-pizza-bestellen',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature7_turkishmezze.png',
          title: 'Turkse mezze',
          link: 'https://www.thuisbezorgd.nl/turks-eten-bestellen',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature8_macaroons.png',
          title: 'Macarons',
          link: 'https://www.thuisbezorgd.nl/ijs-desserts-bestellen',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature10_avotoast.png',
          title: 'Avocado en gepocheerd ei op toast',
          link: 'https://www.thuisbezorgd.nl/ontbijt-bestellen',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature11_acaibowl.png',
          title: 'Acai bowl',
          link: 'https://www.thuisbezorgd.nl/ontbijt-bestellen',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature13_yogurt.png',
          title: 'Yoghurt & granola',
          link: 'https://www.thuisbezorgd.nl/ontbijt-bestellen',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature14_pastries.png',
          title: 'Diverse gebakjes',
          link: 'https://www.thuisbezorgd.nl/ijs-desserts-bestellen',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature15_icedcoffee.png',
          title: 'IJskoffie',
          link: 'https://www.thuisbezorgd.nl/order-coffee',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature16_smoothie.png',
          title: 'Smoothies',
          link: 'https://www.thuisbezorgd.nl/smoothies-bestellen',
        },
      ],
      disclaimer: '*Beschikbaarheid is afhankelijk van je locatie.',
    },
  },
  nl_en: {
    navbar: {
      logo: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/logos/logo_nl.svg',
      country_toggle: [
        {
          logo: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/country-svg/gb.svg',
          url: 'https://www.thuisbezorgd.nl/en/deals/did-somebody-say',
          text: 'English'
        },
        {
          logo: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/country-svg/nl.svg',
          url: 'https://www.thuisbezorgd.nl/deals/zei-dr-iemand-thuisbezorgd/',
          text: 'Nederlands'
        },
      ],
      language: 'Language',
    },
    button: {
      text: 'Go home',
      url: 'https://www.thuisbezorgd.nl/en'
    },
    footer: {
      logo: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/logos/dss_footer_nl.png',
      main_link: 'https://www.thuisbezorgd.nl/en',
      links: [
        {
          text: 'Recommend a restaurant',
          url: 'https://www.thuisbezorgd.nl/en/recommend'
        },
        {
          text: 'Sign up a restaurant',
          url: 'https://www.thuisbezorgd.nl/en/signup'
        },
        {
          text: 'Jobs',
          url: 'https://careers.justeattakeaway.com/global/en?_gl=1*1gcvuwl*_ga*MDE4NmEyMmI0MTIwMDAxMzQ5OTMxMTEzNTFkZDA1MDc1MDAyZTA2ZDAwYjNi*_ga_4PH28YDTSD*MTcwMDEzNDY5OS4zMy4xLjE3MDAxMzQ3MDMuMC4wLjA.',
        },
        {
          text: 'Terms of Service',
          url: 'https://www.thuisbezorgd.nl/en/terms-of-use'
        },
        {
          text: 'Privacy statement',
          url: 'https://www.thuisbezorgd.nl/en/privacy-statement',
        },
        {
          text: 'Colophon',
          url: 'https://www.thuisbezorgd.nl/en/colofon'
        },
        {
          text: 'Cookie statement',
          url: 'https://www.thuisbezorgd.nl/en/cookiestatement'
        },
        {
          text: 'Bug Bounty',
          url: 'https://www.thuisbezorgd.nl/en/bugbounty',
        },
        {
          text: 'Ethics hotline',
          url: 'https://app.convercent.com/en-gb/LandingPage/d8e86634-ec59-ec11-a985-000d3ab9f296'
        },
      ],
      copyright: '2023 Thuisbezorgd.nl',
      mainNavFirst: {
        colTitle: 'Thuisbezorgd.nl',
        subLinks: [
          {
            text: 'Thuisbezorgd.nl for Business',
            url: 'https://www.thuisbezorgd.nl/en/business',
          },
          {
            text: 'Customer service',
            url: 'https://www.thuisbezorgd.nl/en/customerservice'
          },
          {
            text: 'Recommend a business',
            url: 'https://www.thuisbezorgd.nl/en/recommend'
          },
          {
            text: 'List your business',
            url: 'https://www.thuisbezorgd.nl/en/signup',
          },
          {
            text: 'Become an affiliate',
            url: 'https://www.thuisbezorgd.nl/en/affiliate',
          },
          {
            text: 'Become a courier',
            url: 'https://www.thuisbezorgd.nl/en/courier?utm_source=mainsite&utm_medium=referral&utm_content=footer'
          },
          {
            text: 'Jobs',
            url: 'https://careers.justeattakeaway.com/global/en?_gl=1*1fj5rov*_ga*MDE4NmEyMmI0MTIwMDAxMzQ5OTMxMTEzNTFkZDA1MDc1MDAyZTA2ZDAwYjNi*_ga_4PH28YDTSD*MTcwMDEzNDY5OS4zMy4xLjE3MDAxMzQ3MDMuMC4wLjA.'
          },
          {
            text: 'StampCard',
            url: 'https://www.thuisbezorgd.nl/en#stamp-cards'
          },
          {
            text: 'Points',
            url: 'https://www.thuisbezorgd.nl/en/punten',
          },
          {
            text: 'Terms of use',
            url: 'https://www.thuisbezorgd.nl/en/terms-of-use'
          },
          {
            text: 'Privacy statement',
            url: 'https://www.thuisbezorgd.nl/en/privacy-statement',
          },
          {
            text: 'Colophon',
            url: 'https://www.thuisbezorgd.nl/en/colofon',
          },
          {
            text: 'Cookie statement',
            url: 'https://www.thuisbezorgd.nl/en/cookiestatement'
          },
        ],
      },
      mainNavSecond: [
        {
          colTitle: 'International',
          subLinks: [
            {
              text: 'Investor Relations',
              url: 'https://www.justeattakeaway.com/',
            },
            {
              text: '10bis',
              url: 'https://www.10bis.co.il',
            },
            {
              text: 'Bistro.sk',
              url: 'https://www.bistro.sk',
            },
            {
              text: 'Grubhub',
              url: 'https://www.grubhub.com',
            },
            {
              text: 'Just Eat - Switzerland',
              url: 'https://www.just-eat.ch',
            },
            {
              text: 'Just Eat - France',
              url: 'https://www.just-eat.fr',
            },
            {
              text: 'Just Eat - Denmark',
              url: 'https://www.just-eat.dk',
            },
            {
              text: 'Just Eat - Spain',
              url: 'https://www.just-eat.es',
            },
            {
              text: 'Just Eat - United Kingdom',
              url: 'https://www.just-eat.co.uk',
            },
            {
              text: 'Just Eat - Ireland',
              url: 'https://www.just-eat.ie',
            },
            {
              text: 'Just Eat - Italy',
              url: 'https://www.justeat.it',
            },
            {
              text: 'Lieferando.at',
              url: 'https://www.lieferando.at',
            },
            {
              text: 'Lieferando.de',
              url: 'https://www.lieferando.de',
            },
            {
              text: 'Menulog - Australia',
              url: 'https://www.menulog.com.au',
            },
            {
              text: 'Menulog - New Zealand',
              url: 'https://www.menulog.co.nz',
            },
            {
              text: 'Pyszne.pl',
              url: 'https://www.pyszne.pl',
            },
            {
              text: 'SkipTheDishes',
              url: 'https://www.skipthedishes.com',
            },
            {
              text: 'Takeaway.com - Belgium',
              url: 'https://www.takeaway.com/be',
            },
            {
              text: 'Takeaway.com - Luxembourg',
              url: 'https://www.takeaway.com/lu',
            },
            {
              text: 'Takeaway.com - Bulgaria',
              url: 'https://www.takeaway.com/bg',
            },
            {
              text: 'Thuisbezorgd.nl',
              url: 'https://www.thuisbezorgd.nl',
            }
          ],
        },
        {          
          colTitle: 'Food',
          subLinks: [
            {
              text: 'Food',
              url: 'https://www.thuisbezorgd.nl/en/order-takeaway',
            },
            {
              text: 'Pizza',
              url: 'https://www.thuisbezorgd.nl/en/order-pizza',
            },
            {
              text: 'Chinese',
              url: 'https://www.thuisbezorgd.nl/en/order-sushi',
            },
            {
              text: 'Vegan',
              url: 'https://www.thuisbezorgd.nl/en/order-vegan',
            },
            {
              text: 'Sushi',
              url: 'https://www.thuisbezorgd.nl/en/order-chinese-food',
            },
            {
              text: 'Poke bowl',
              url: 'https://www.thuisbezorgd.nl/en/order-poke-bowl',
            },
            {
              text: 'Roti',
              url: 'https://www.thuisbezorgd.nl/en/order-roti',
            },
            {
              text: 'Spare ribs',
              url: 'https://www.thuisbezorgd.nl/en/order-spare-ribs',
            },
            {
              text: 'Thai',
              url: 'https://www.thuisbezorgd.nl/en/order-thai-food',
            },
            {
              text: 'Sandwiches',
              url: 'https://www.thuisbezorgd.nl/en/order-sandwiches',
            },
            {
              text: 'Groceries',
              url: 'https://www.thuisbezorgd.nl/en/order-groceries',
            },
            {
              text: 'Spanish/Tapas',
              url: 'https://www.thuisbezorgd.nl/en/order-spanish-and-tapas',
            },
            {
              text: 'Shoarma',
              url: 'https://www.thuisbezorgd.nl/en/order-shoarma',
            },
            {
              text: 'Order more food...',
              url: 'https://www.thuisbezorgd.nl/en/order-more-food',
            }
          ],
        },
        {          
          colTitle: 'Explore',
          subLinks: [
            {
              text: 'Foodwiki',
              url: 'https://www.thuisbezorgd.nl/en/foodwiki/',
            },
            {
              text: 'Giftcards',
              url: 'https://www.thuisbezorgd.nl/en/gift-cards/',
            },
            {
              text: 'Sustainability',
              url: 'https://www.thuisbezorgd.nl/en/sustainability/',
            },
            {
              text: 'Taste the Summer',
              url: 'https://www.thuisbezorgd.nl/en/deals/tastethesummer/',
            },
            {
              text: 'Become a Courier in Rotterdam',
              url: 'https://www.thuisbezorgd.nl/en/courier/rotterdam',
            },
            {
              text: 'Become a Courier in Amsterdam',
              url: 'https://www.thuisbezorgd.nl/en/courier/amsterdam',
            },
            {
              text: 'Become a Courier in The Hague',
              url: 'https://www.thuisbezorgd.nl/en/courier/the-hague',
            },
            {
              text: 'Become a Courier in Utrecht',
              url: 'https://www.thuisbezorgd.nl/en/courier/utrecht',
            },
            {
              text: 'Become a Courier in Groningen',
              url: 'https://www.thuisbezorgd.nl/en/courier/groningen',
            },
            {
              text: 'Win UEFA Europa League® Tickets',
              url: 'https://www.thuisbezorgd.nl/en/deals/match-day-deals/',
            },
          ],
        },
        {
          colTitle: 'Cities',
          subLinks: [
            {
              text: 'Amsterdam',
              url: 'https://www.thuisbezorgd.nl/en/order-takeaway-amsterdam'
            },
            {
              text: 'Rotterdam',
              url: 'https://www.thuisbezorgd.nl/en/order-takeaway-rotterdam'
            },
            {
              text: 'Den Haag',
              url: 'https://www.thuisbezorgd.nl/en/order-takeaway-den-haag'
            },
            {
              text: 'Utrecht',
              url: 'https://www.thuisbezorgd.nl/en/order-takeaway-utrecht'
            },
            {
              text: 'Eindhoven',
              url: 'https://www.thuisbezorgd.nl/en/order-takeaway-eindhoven',
            },
            {
              text: "Tilburg",
              url: 'https://www.thuisbezorgd.nl/en/order-takeaway-tilburg'
            },
            {
              text: 'Almere',
              url: 'https://www.thuisbezorgd.nl/en/order-takeaway-almere'
            },
            {
              text: 'Groningen',
              url: 'https://www.thuisbezorgd.nl/en/order-takeaway-groningen'
            },
            {
              text: 'Breda',
              url: 'https://www.thuisbezorgd.nl/en/order-takeaway-breda'
            },
            {
              text: 'Nijmegen',
              url: 'https://www.thuisbezorgd.nl/en/order-takeaway-nijmegen'
            },
            {
              text: 'Enschede',
              url: 'https://www.thuisbezorgd.nl/en/order-takeaway-enschede',
            },
            {
              text: "Arnhem",
              url: 'https://www.thuisbezorgd.nl/en/order-takeaway-arnhem'
            },
            {
              text: 'Zwolle',
              url: 'https://www.thuisbezorgd.nl/en/order-takeaway-zwolle',
            },
            {
              text: 'Haarlem',
              url: 'https://www.thuisbezorgd.nl/en/order-takeaway-haarlem',
            },
            {
              text: 'Leiden',
              url: 'https://www.thuisbezorgd.nl/en/order-takeaway-leiden'
            }
          ]
        },
        {
          colTitle: 'Chains',
          subLinks: [
            {
              text: "McDonald's",
              url: 'https://www.thuisbezorgd.nl/en/mcdonalds'
            },
            {
              text: 'Subway',
              url: 'https://www.thuisbezorgd.nl/en/subway'
            },
            {
              text: 'KFC',
              url: 'https://www.thuisbezorgd.nl/en/kfc',
            },
            {
              text: 'Spare Rib Express',
              url: 'https://www.thuisbezorgd.nl/en/spare-rib-express',
            },
            {
              text: 'Burger King',
              url: 'https://www.thuisbezorgd.nl/en/burger-king'
            },
            {
              text: 'eazie',
              url: 'https://www.thuisbezorgd.nl/en/eazie'
            },
            {
              text: 'Bakker Bart',
              url: 'https://www.thuisbezorgd.nl/en/bakker-bart'
            },
            {
              text: "Happy Italy",
              url: 'https://www.thuisbezorgd.nl/en/happy-italy'
            },

            {
              text: "FEBO",
              url: 'https://www.thuisbezorgd.nl/en/febo',
            },
            {
              text: 'De Beren',
              url: 'https://www.thuisbezorgd.nl/en/de-beren'
            },
            {
              text: 'Sumo Sushi',
              url: 'https://www.thuisbezorgd.nl/en/sumo-take-away-delivery'
            },
            {
              text: 'Vapiano',
              url: 'https://www.thuisbezorgd.nl/en/vapiano'
            },
            {
              text: "Domino's Pizza",
              url: 'https://www.thuisbezorgd.nl/en/dominos-pizza',
            },
            {
              text: "New York Pizza",
              url: 'https://www.thuisbezorgd.nl/en/new-york-pizza'
            },
            {
              text: 'More chains...',
              url: 'https://www.thuisbezorgd.nl/en/chains',
            },
          ]
        },
        {
          colTitle: 'New places',
          subLinks: [
            {
              text: "Al Mercato 2023, Goes",
              url: 'https://www.thuisbezorgd.nl/en/menu/al-mercato-2023'
            },
            {
              text: 'Café Restaurant Dierenselaan, Den Haag',
              url: 'https://www.thuisbezorgd.nl/en/menu/cafe-restaurant-dierenselaan'
            },
            {
              text: 'EkoBites, Den Haag',
              url: 'https://www.thuisbezorgd.nl/en/menu/ekobites'
            },
            {
              text: "Fresh Burger 7, Amsterdam",
              url: 'https://www.thuisbezorgd.nl/en/menu/fresh-burger-7'
            },
            {
              text: "Snackbar Nico's, Den Bosch",
              url: 'https://www.thuisbezorgd.nl/en/menu/snackbar-nicos'
            },
            {
              text: 'Eetcafe Babylon, Dordrecht',
              url: 'https://www.thuisbezorgd.nl/en/menu/eetcafe-babylon-new'
            },
            {
              text: "Joe's Burger, Leiden",
              url: 'https://www.thuisbezorgd.nl/en/menu/joes-burger-2'
            },
            {
              text: 'Sushi Tijd, Eindhoven',
              url: 'https://www.thuisbezorgd.nl/en/menu/sushi-tijd-1'
            },
            {
              text: 'Bakkerij Nieuwendijk, Nieuwendijk',
              url: 'https://www.thuisbezorgd.nl/en/menu/bakkerij-nieuwendijk'
            },
            {
              text: 'Al Aseel Groningen, Groningen',
              url: 'https://www.thuisbezorgd.nl/en/menu/al-aseel-groningen'
            },
          ]
        },
        {
          colTitle: 'Regions',
          subLinks: [
            {
              text: "Drenthe",
              url: 'https://www.thuisbezorgd.nl/en/order-takeaway-drenthe'
            },
            {
              text: 'Flevoland',
              url: 'https://www.thuisbezorgd.nl/en/order-takeaway-flevoland'
            },
            {
              text: 'Friesland',
              url: 'https://www.thuisbezorgd.nl/en/order-takeaway-friesland'
            },
            {
              text: "Gelderland",
              url: 'https://www.thuisbezorgd.nl/en/order-takeaway-gelderland'
            },
            {
              text: "Groningen",
              url: 'https://www.thuisbezorgd.nl/en/order-takeaway-provincie-groningen'
            },
            {
              text: 'Limburg',
              url: 'https://www.thuisbezorgd.nl/en/order-takeaway-limburg'
            },
            {
              text: 'Noord-Brabant',
              url: 'https://www.thuisbezorgd.nl/en/order-takeaway-noord-brabant'
            },
            {
              text: 'Noord-Holland',
              url: 'https://www.thuisbezorgd.nl/en/order-takeaway-noord-holland'
            },
            {
              text: 'Overijssel',
              url: 'https://www.thuisbezorgd.nl/en/order-takeaway-overijssel'
            },
            {
              text: 'Utrecht',
              url: 'https://www.thuisbezorgd.nl/en/order-takeaway-provincie-utrecht'
            },
            {
              text: 'Zeeland',
              url: 'https://www.thuisbezorgd.nl/en/order-takeaway-zeeland'
            },
            {
              text: 'Zuid-Holland',
              url: 'https://www.thuisbezorgd.nl/en/order-takeaway-zuid-holland'
            },
          ]
        },
      ]
    },
    hero: {
      logo: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/logos/dss_thuisbezorgd.png',
      main: 'Christina Aguilera and Latto',
      sub: 'Thuisbezorgd.nl brand campaign 2023',
      img: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/christina-latto.png',
    },
    about: {
      title: 'About the campaign',
      text: "We're back with an awesome campaign.\n\nTogether with McCann London, we have combined Latto's hip-hop energy with Christina Aguilera's contemporary take on opera for our latest creation. The result? A surprising visual and musical whole and the perfect embodiment of all the surprising flavors you will find on Thuisbezorgd.nl.",
      img: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/xtina-wave.gif',
    },
    video: {
      title: 'Did Somebody Say music video',
      id: 'https://www.youtube.com/embed/y-af2NvPAQ4?si=h0rnkp61CnCjK1Jz',
    },
    lyrics: {
      title: 'Did Somebody Say ft. Christina Aguilera and Latto lyrics',
      lyrics: `Y'all ready for something new?

      Zei d'r iemand Thuisbezorgd
      
      Oh you thought it was
      just burgers and fries
      
      They got more flavours than you tasted
      Or you heard in your life
      
      Ooh - this is what the app do
      It ain't only fast food
      
      Switching styles like opera to rap too
      
      Yummy
      
      And it ain't only restaurants anymore
      
      We can go bananas at the grocery store
      
      I'm a bad girl but my takeout badder
      
      What you need dude?
      I can cop a taco platter
      
      Thai rice sticky icky
      
      Gyoza on the side fried right
      Cos we kinda picky
      
      Breakfast or lunch hun
      Dinner or brunch
      
      Wanna find the finest dining?
      I got a hunch
      
      And some hot tall dude's
      Bringing buns to the ballroom
      
      Got me a strong coffee
      Let's get it on papi
      
      Ice-cream with my magazine
      Who can stop me
      
      And my sushi train is on loop
      
      When you this slick
      whatchoo gon’ do?
      
      Zei d'r iemand Thuisbezorgd`,
      img: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/christina-lyrics.png',
    },
    food: {
      title: 'All the goodies from the new campaign with Christina Aguilera and Latto',
      intro: 'Interested in something tasty? These are all the foods from the campaign that you can order on our platform.',
      list: [
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature1_tunapoke.png',
          title: 'Tuna poke bowl',
          link: 'https://www.thuisbezorgd.nl/en/order-poke-bowl',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature2_foccacia.png',
          title: 'Focaccia sandwich',
          link: 'https://www.thuisbezorgd.nl/en/order-sandwiches',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature3_thaisalad.png',
          title: 'Thai salad',
          link: 'https://www.thuisbezorgd.nl/en/order-thai-food',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature4_groceries.png',
          title: 'Groceries',
          link: 'https://www.thuisbezorgd.nl/en/order-groceries',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature5_tacos.png',
          title: 'Tacos',
          link: 'https://www.thuisbezorgd.nl/en/order-tacos',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature6_pizza.png',
          title: 'Pizza',
          link: 'https://www.thuisbezorgd.nl/en/order-american-style-pizza',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature7_turkishmezze.png',
          title: 'Turkish mezze',
          link: 'https://www.thuisbezorgd.nl/en/order-turkish-food',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature8_macaroons.png',
          title: 'Macaroons',
          link: 'https://www.thuisbezorgd.nl/en/order-desserts',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature10_avotoast.png',
          title: 'Avocado & poached egg on toast',
          link: 'https://thuisbezorgd.nl/en/order-breakfast',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature11_acaibowl.png',
          title: 'Acai bowl',
          link: 'https://thuisbezorgd.nl/en/order-breakfast',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature13_yogurt.png',
          title: 'Yogurt & granola',
          link: 'https://thuisbezorgd.nl/en/order-breakfast',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature14_pastries.png',
          title: 'Selection of pastries',
          link: 'https://www.thuisbezorgd.nl/en/order-desserts',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature15_icedcoffee.png',
          title: 'Iced coffee',
          link: 'https://www.thuisbezorgd.nl/en/order-coffee',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature16_smoothie.png',
          title: 'Smoothies',
          link: 'https://www.thuisbezorgd.nl/en/order-smoothies',
        },
      ],
      disclaimer: '*Availability of groceries depends on your location.',
    },
  },
  dk_en: {
    navbar: {
      logo: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/logos/logo_nl.svg',
      country_toggle: [
        {
          logo: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/country-svg/gb.svg',
          url: 'https://www.thuisbezorgd.nl/en/deals/did-somebody-say',
          text: 'English'
        },
        {
          logo: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/country-svg/nl.svg',
          url: 'https://www.thuisbezorgd.nl/deals/zei-dr-iemand-thuisbezorgd/',
          text: 'Nederlands'
        },
      ],
      language: 'Language',
    },
    button: {
      text: 'Go home',
      url: 'https://www.thuisbezorgd.nl/en'
    },
    footer: {
      logo: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/logos/dss_footer_nl.png',
      main_link: 'https://www.thuisbezorgd.nl/en',
      links: [
        {
          text: 'Recommend a restaurant',
          url: 'https://www.thuisbezorgd.nl/en/recommend'
        },
        {
          text: 'Sign up a restaurant',
          url: 'https://www.thuisbezorgd.nl/en/signup'
        },
        {
          text: 'Jobs',
          url: 'https://careers.justeattakeaway.com/global/en?_gl=1*1gcvuwl*_ga*MDE4NmEyMmI0MTIwMDAxMzQ5OTMxMTEzNTFkZDA1MDc1MDAyZTA2ZDAwYjNi*_ga_4PH28YDTSD*MTcwMDEzNDY5OS4zMy4xLjE3MDAxMzQ3MDMuMC4wLjA.',
        },
        {
          text: 'Terms of Service',
          url: 'https://www.thuisbezorgd.nl/en/terms-of-use'
        },
        {
          text: 'Privacy statement',
          url: 'https://www.thuisbezorgd.nl/en/privacy-statement',
        },
        {
          text: 'Colophon',
          url: 'https://www.thuisbezorgd.nl/en/colofon'
        },
        {
          text: 'Cookie statement',
          url: 'https://www.thuisbezorgd.nl/en/cookiestatement'
        },
        {
          text: 'Bug Bounty',
          url: 'https://www.thuisbezorgd.nl/en/bugbounty',
        },
        {
          text: 'Ethics hotline',
          url: 'https://app.convercent.com/en-gb/LandingPage/d8e86634-ec59-ec11-a985-000d3ab9f296'
        },
      ],
      copyright: '2023 Thuisbezorgd.nl',
      mainNavFirst: {
        colTitle: 'Thuisbezorgd.nl',
        subLinks: [
          {
            text: 'Thuisbezorgd.nl for Business',
            url: 'https://www.thuisbezorgd.nl/en/business',
          },
          {
            text: 'Customer service',
            url: 'https://www.thuisbezorgd.nl/en/customerservice'
          },
          {
            text: 'Recommend a business',
            url: 'https://www.thuisbezorgd.nl/en/recommend'
          },
          {
            text: 'List your business',
            url: 'https://www.thuisbezorgd.nl/en/signup',
          },
          {
            text: 'Become an affiliate',
            url: 'https://www.thuisbezorgd.nl/en/affiliate',
          },
          {
            text: 'Become a courier',
            url: 'https://www.thuisbezorgd.nl/en/courier?utm_source=mainsite&utm_medium=referral&utm_content=footer'
          },
          {
            text: 'Jobs',
            url: 'https://careers.justeattakeaway.com/global/en?_gl=1*1fj5rov*_ga*MDE4NmEyMmI0MTIwMDAxMzQ5OTMxMTEzNTFkZDA1MDc1MDAyZTA2ZDAwYjNi*_ga_4PH28YDTSD*MTcwMDEzNDY5OS4zMy4xLjE3MDAxMzQ3MDMuMC4wLjA.'
          },
          {
            text: 'StampCard',
            url: 'https://www.thuisbezorgd.nl/en#stamp-cards'
          },
          {
            text: 'Points',
            url: 'https://www.thuisbezorgd.nl/en/punten',
          },
          {
            text: 'Terms of use',
            url: 'https://www.thuisbezorgd.nl/en/terms-of-use'
          },
          {
            text: 'Privacy statement',
            url: 'https://www.thuisbezorgd.nl/en/privacy-statement',
          },
          {
            text: 'Colophon',
            url: 'https://www.thuisbezorgd.nl/en/colofon',
          },
          {
            text: 'Cookie statement',
            url: 'https://www.thuisbezorgd.nl/en/cookiestatement'
          },
        ],
      },
      mainNavSecond: [
        {
          colTitle: 'International',
          subLinks: [
            {
              text: 'Investor Relations',
              url: 'https://www.justeattakeaway.com/',
            },
            {
              text: '10bis',
              url: 'https://www.10bis.co.il',
            },
            {
              text: 'Bistro.sk',
              url: 'https://www.bistro.sk',
            },
            {
              text: 'Grubhub',
              url: 'https://www.grubhub.com',
            },
            {
              text: 'Just Eat - Switzerland',
              url: 'https://www.just-eat.ch',
            },
            {
              text: 'Just Eat - France',
              url: 'https://www.just-eat.fr',
            },
            {
              text: 'Just Eat - Denmark',
              url: 'https://www.just-eat.dk',
            },
            {
              text: 'Just Eat - Spain',
              url: 'https://www.just-eat.es',
            },
            {
              text: 'Just Eat - United Kingdom',
              url: 'https://www.just-eat.co.uk',
            },
            {
              text: 'Just Eat - Ireland',
              url: 'https://www.just-eat.ie',
            },
            {
              text: 'Just Eat - Italy',
              url: 'https://www.justeat.it',
            },
            {
              text: 'Lieferando.at',
              url: 'https://www.lieferando.at',
            },
            {
              text: 'Lieferando.de',
              url: 'https://www.lieferando.de',
            },
            {
              text: 'Menulog - Australia',
              url: 'https://www.menulog.com.au',
            },
            {
              text: 'Menulog - New Zealand',
              url: 'https://www.menulog.co.nz',
            },
            {
              text: 'Pyszne.pl',
              url: 'https://www.pyszne.pl',
            },
            {
              text: 'SkipTheDishes',
              url: 'https://www.skipthedishes.com',
            },
            {
              text: 'Takeaway.com - Belgium',
              url: 'https://www.takeaway.com/be',
            },
            {
              text: 'Takeaway.com - Luxembourg',
              url: 'https://www.takeaway.com/lu',
            },
            {
              text: 'Takeaway.com - Bulgaria',
              url: 'https://www.takeaway.com/bg',
            },
            {
              text: 'Thuisbezorgd.nl',
              url: 'https://www.thuisbezorgd.nl',
            }
          ],
        },
        {          
          colTitle: 'Food',
          subLinks: [
            {
              text: 'Food',
              url: 'https://www.thuisbezorgd.nl/en/order-takeaway',
            },
            {
              text: 'Pizza',
              url: 'https://www.thuisbezorgd.nl/en/order-pizza',
            },
            {
              text: 'Chinese',
              url: 'https://www.thuisbezorgd.nl/en/order-sushi',
            },
            {
              text: 'Vegan',
              url: 'https://www.thuisbezorgd.nl/en/order-vegan',
            },
            {
              text: 'Sushi',
              url: 'https://www.thuisbezorgd.nl/en/order-chinese-food',
            },
            {
              text: 'Poke bowl',
              url: 'https://www.thuisbezorgd.nl/en/order-poke-bowl',
            },
            {
              text: 'Roti',
              url: 'https://www.thuisbezorgd.nl/en/order-roti',
            },
            {
              text: 'Spare ribs',
              url: 'https://www.thuisbezorgd.nl/en/order-spare-ribs',
            },
            {
              text: 'Thai',
              url: 'https://www.thuisbezorgd.nl/en/order-thai-food',
            },
            {
              text: 'Sandwiches',
              url: 'https://www.thuisbezorgd.nl/en/order-sandwiches',
            },
            {
              text: 'Groceries',
              url: 'https://www.thuisbezorgd.nl/en/order-groceries',
            },
            {
              text: 'Spanish/Tapas',
              url: 'https://www.thuisbezorgd.nl/en/order-spanish-and-tapas',
            },
            {
              text: 'Shoarma',
              url: 'https://www.thuisbezorgd.nl/en/order-shoarma',
            },
            {
              text: 'Order more food...',
              url: 'https://www.thuisbezorgd.nl/en/order-more-food',
            }
          ],
        },
        {          
          colTitle: 'Explore',
          subLinks: [
            {
              text: 'Foodwiki',
              url: 'https://www.thuisbezorgd.nl/en/foodwiki/',
            },
            {
              text: 'Giftcards',
              url: 'https://www.thuisbezorgd.nl/en/gift-cards/',
            },
            {
              text: 'Sustainability',
              url: 'https://www.thuisbezorgd.nl/en/sustainability/',
            },
            {
              text: 'Taste the Summer',
              url: 'https://www.thuisbezorgd.nl/en/deals/tastethesummer/',
            },
            {
              text: 'Become a Courier in Rotterdam',
              url: 'https://www.thuisbezorgd.nl/en/courier/rotterdam',
            },
            {
              text: 'Become a Courier in Amsterdam',
              url: 'https://www.thuisbezorgd.nl/en/courier/amsterdam',
            },
            {
              text: 'Become a Courier in The Hague',
              url: 'https://www.thuisbezorgd.nl/en/courier/the-hague',
            },
            {
              text: 'Become a Courier in Utrecht',
              url: 'https://www.thuisbezorgd.nl/en/courier/utrecht',
            },
            {
              text: 'Become a Courier in Groningen',
              url: 'https://www.thuisbezorgd.nl/en/courier/groningen',
            },
            {
              text: 'Win UEFA Europa League® Tickets',
              url: 'https://www.thuisbezorgd.nl/en/deals/match-day-deals/',
            },
          ],
        },
        {
          colTitle: 'Cities',
          subLinks: [
            {
              text: 'Amsterdam',
              url: 'https://www.thuisbezorgd.nl/en/order-takeaway-amsterdam'
            },
            {
              text: 'Rotterdam',
              url: 'https://www.thuisbezorgd.nl/en/order-takeaway-rotterdam'
            },
            {
              text: 'Den Haag',
              url: 'https://www.thuisbezorgd.nl/en/order-takeaway-den-haag'
            },
            {
              text: 'Utrecht',
              url: 'https://www.thuisbezorgd.nl/en/order-takeaway-utrecht'
            },
            {
              text: 'Eindhoven',
              url: 'https://www.thuisbezorgd.nl/en/order-takeaway-eindhoven',
            },
            {
              text: "Tilburg",
              url: 'https://www.thuisbezorgd.nl/en/order-takeaway-tilburg'
            },
            {
              text: 'Almere',
              url: 'https://www.thuisbezorgd.nl/en/order-takeaway-almere'
            },
            {
              text: 'Groningen',
              url: 'https://www.thuisbezorgd.nl/en/order-takeaway-groningen'
            },
            {
              text: 'Breda',
              url: 'https://www.thuisbezorgd.nl/en/order-takeaway-breda'
            },
            {
              text: 'Nijmegen',
              url: 'https://www.thuisbezorgd.nl/en/order-takeaway-nijmegen'
            },
            {
              text: 'Enschede',
              url: 'https://www.thuisbezorgd.nl/en/order-takeaway-enschede',
            },
            {
              text: "Arnhem",
              url: 'https://www.thuisbezorgd.nl/en/order-takeaway-arnhem'
            },
            {
              text: 'Zwolle',
              url: 'https://www.thuisbezorgd.nl/en/order-takeaway-zwolle',
            },
            {
              text: 'Haarlem',
              url: 'https://www.thuisbezorgd.nl/en/order-takeaway-haarlem',
            },
            {
              text: 'Leiden',
              url: 'https://www.thuisbezorgd.nl/en/order-takeaway-leiden'
            }
          ]
        },
        {
          colTitle: 'Chains',
          subLinks: [
            {
              text: "McDonald's",
              url: 'https://www.thuisbezorgd.nl/en/mcdonalds'
            },
            {
              text: 'Subway',
              url: 'https://www.thuisbezorgd.nl/en/subway'
            },
            {
              text: 'KFC',
              url: 'https://www.thuisbezorgd.nl/en/kfc',
            },
            {
              text: 'Spare Rib Express',
              url: 'https://www.thuisbezorgd.nl/en/spare-rib-express',
            },
            {
              text: 'Burger King',
              url: 'https://www.thuisbezorgd.nl/en/burger-king'
            },
            {
              text: 'eazie',
              url: 'https://www.thuisbezorgd.nl/en/eazie'
            },
            {
              text: 'Bakker Bart',
              url: 'https://www.thuisbezorgd.nl/en/bakker-bart'
            },
            {
              text: "Happy Italy",
              url: 'https://www.thuisbezorgd.nl/en/happy-italy'
            },

            {
              text: "FEBO",
              url: 'https://www.thuisbezorgd.nl/en/febo',
            },
            {
              text: 'De Beren',
              url: 'https://www.thuisbezorgd.nl/en/de-beren'
            },
            {
              text: 'Sumo Sushi',
              url: 'https://www.thuisbezorgd.nl/en/sumo-take-away-delivery'
            },
            {
              text: 'Vapiano',
              url: 'https://www.thuisbezorgd.nl/en/vapiano'
            },
            {
              text: "Domino's Pizza",
              url: 'https://www.thuisbezorgd.nl/en/dominos-pizza',
            },
            {
              text: "New York Pizza",
              url: 'https://www.thuisbezorgd.nl/en/new-york-pizza'
            },
            {
              text: 'More chains...',
              url: 'https://www.thuisbezorgd.nl/en/chains',
            },
          ]
        },
        {
          colTitle: 'New places',
          subLinks: [
            {
              text: "Al Mercato 2023, Goes",
              url: 'https://www.thuisbezorgd.nl/en/menu/al-mercato-2023'
            },
            {
              text: 'Café Restaurant Dierenselaan, Den Haag',
              url: 'https://www.thuisbezorgd.nl/en/menu/cafe-restaurant-dierenselaan'
            },
            {
              text: 'EkoBites, Den Haag',
              url: 'https://www.thuisbezorgd.nl/en/menu/ekobites'
            },
            {
              text: "Fresh Burger 7, Amsterdam",
              url: 'https://www.thuisbezorgd.nl/en/menu/fresh-burger-7'
            },
            {
              text: "Snackbar Nico's, Den Bosch",
              url: 'https://www.thuisbezorgd.nl/en/menu/snackbar-nicos'
            },
            {
              text: 'Eetcafe Babylon, Dordrecht',
              url: 'https://www.thuisbezorgd.nl/en/menu/eetcafe-babylon-new'
            },
            {
              text: "Joe's Burger, Leiden",
              url: 'https://www.thuisbezorgd.nl/en/menu/joes-burger-2'
            },
            {
              text: 'Sushi Tijd, Eindhoven',
              url: 'https://www.thuisbezorgd.nl/en/menu/sushi-tijd-1'
            },
            {
              text: 'Bakkerij Nieuwendijk, Nieuwendijk',
              url: 'https://www.thuisbezorgd.nl/en/menu/bakkerij-nieuwendijk'
            },
            {
              text: 'Al Aseel Groningen, Groningen',
              url: 'https://www.thuisbezorgd.nl/en/menu/al-aseel-groningen'
            },
          ]
        },
        {
          colTitle: 'Regions',
          subLinks: [
            {
              text: "Drenthe",
              url: 'https://www.thuisbezorgd.nl/en/order-takeaway-drenthe'
            },
            {
              text: 'Flevoland',
              url: 'https://www.thuisbezorgd.nl/en/order-takeaway-flevoland'
            },
            {
              text: 'Friesland',
              url: 'https://www.thuisbezorgd.nl/en/order-takeaway-friesland'
            },
            {
              text: "Gelderland",
              url: 'https://www.thuisbezorgd.nl/en/order-takeaway-gelderland'
            },
            {
              text: "Groningen",
              url: 'https://www.thuisbezorgd.nl/en/order-takeaway-provincie-groningen'
            },
            {
              text: 'Limburg',
              url: 'https://www.thuisbezorgd.nl/en/order-takeaway-limburg'
            },
            {
              text: 'Noord-Brabant',
              url: 'https://www.thuisbezorgd.nl/en/order-takeaway-noord-brabant'
            },
            {
              text: 'Noord-Holland',
              url: 'https://www.thuisbezorgd.nl/en/order-takeaway-noord-holland'
            },
            {
              text: 'Overijssel',
              url: 'https://www.thuisbezorgd.nl/en/order-takeaway-overijssel'
            },
            {
              text: 'Utrecht',
              url: 'https://www.thuisbezorgd.nl/en/order-takeaway-provincie-utrecht'
            },
            {
              text: 'Zeeland',
              url: 'https://www.thuisbezorgd.nl/en/order-takeaway-zeeland'
            },
            {
              text: 'Zuid-Holland',
              url: 'https://www.thuisbezorgd.nl/en/order-takeaway-zuid-holland'
            },
          ]
        },
      ]
    },
    hero: {
      logo: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/logos/dss_thuisbezorgd.png',
      main: 'Christina Aguilera and Latto',
      sub: 'Thuisbezorgd.nl brand campaign 2023',
      img: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/christina-latto.png',
    },
    about: {
      title: 'About the campaign',
      text: "We're back with an awesome campaign.\n\nTogether with McCann London, we have combined Latto's hip-hop energy with Christina Aguilera's contemporary take on opera for our latest creation. The result? A surprising visual and musical whole and the perfect embodiment of all the surprising flavors you will find on Thuisbezorgd.nl.",
      img: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/xtina-wave.gif',
    },
    video: {
      title: 'Did Somebody Say music video',
      id: 'https://www.youtube.com/embed/y-af2NvPAQ4?si=h0rnkp61CnCjK1Jz',
    },
    lyrics: {
      title: 'Did Somebody Say ft. Christina Aguilera and Latto lyrics',
      lyrics: `Y'all ready for something new?

      Zei d'r iemand Thuisbezorgd
      
      Oh you thought it was
      just burgers and fries
      
      They got more flavours than you tasted
      Or you heard in your life
      
      Ooh - this is what the app do
      It ain't only fast food
      
      Switching styles like opera to rap too
      
      Yummy
      
      And it ain't only restaurants anymore
      
      We can go bananas at the grocery store
      
      I'm a bad girl but my takeout badder
      
      What you need dude?
      I can cop a taco platter
      
      Thai rice sticky icky
      
      Gyoza on the side fried right
      Cos we kinda picky
      
      Breakfast or lunch hun
      Dinner or brunch
      
      Wanna find the finest dining?
      I got a hunch
      
      And some hot tall dude's
      Bringing buns to the ballroom
      
      Got me a strong coffee
      Let's get it on papi
      
      Ice-cream with my magazine
      Who can stop me
      
      And my sushi train is on loop
      
      When you this slick
      whatchoo gon’ do?
      
      Zei d'r iemand Thuisbezorgd`,
      img: 'https://takeaway-landing-pages.k.elnino-production.com/storage/resources/globalBrand/christina-lyrics.png',
    },
    food: {
      title: 'All the goodies from the new campaign with Christina Aguilera and Latto',
      intro: 'Interested in something tasty? These are all the foods from the campaign that you can order on our platform.',
      list: [
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature1_tunapoke.png',
          title: 'Tuna poke bowl',
          link: 'https://www.thuisbezorgd.nl/en/order-poke-bowl',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature2_foccacia.png',
          title: 'Focaccia sandwich',
          link: 'https://www.thuisbezorgd.nl/en/order-sandwiches',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature3_thaisalad.png',
          title: 'Thai salad',
          link: 'https://www.thuisbezorgd.nl/en/order-thai-food',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature4_groceries.png',
          title: 'Groceries',
          link: 'https://www.thuisbezorgd.nl/en/order-groceries',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature5_tacos.png',
          title: 'Tacos',
          link: 'https://www.thuisbezorgd.nl/en/order-tacos',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature6_pizza.png',
          title: 'Pizza',
          link: 'https://www.thuisbezorgd.nl/en/order-american-style-pizza',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature7_turkishmezze.png',
          title: 'Turkish mezze',
          link: 'https://www.thuisbezorgd.nl/en/order-turkish-food',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature8_macaroons.png',
          title: 'Macaroons',
          link: 'https://www.thuisbezorgd.nl/en/order-desserts',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature10_avotoast.png',
          title: 'Avocado & poached egg on toast',
          link: 'https://thuisbezorgd.nl/en/order-breakfast',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature11_acaibowl.png',
          title: 'Acai bowl',
          link: 'https://thuisbezorgd.nl/en/order-breakfast',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature13_yogurt.png',
          title: 'Yogurt & granola',
          link: 'https://thuisbezorgd.nl/en/order-breakfast',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature14_pastries.png',
          title: 'Selection of pastries',
          link: 'https://www.thuisbezorgd.nl/en/order-desserts',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature15_icedcoffee.png',
          title: 'Iced coffee',
          link: 'https://www.thuisbezorgd.nl/en/order-coffee',
        },
        {
          img: 'https://www.just-eat.co.uk/CmsAssets/media/Files/Common/files/explore/did-somebody-say/img/images/feature16_smoothie.png',
          title: 'Smoothies',
          link: 'https://www.thuisbezorgd.nl/en/order-smoothies',
        },
      ],
      disclaimer: '*Availability of groceries depends on your location.',
    },
  },
};